// Comprehensive Civil Engineering Chapters for NEC Exam (Chapters 2-10, aligned to the official NEC ACiE syllabus)
export const additionalCivilEngineeringChapters = [
  {
    id: 2,
    title: "Soil Mechanics and Foundation Engineering",
    code: "ACiE02",
    topics: [
      {
        id: 1,
        title: "Soil properties and laboratory tests",
        description: "Tests for strength, permeability, compressibility, phase relationships; determination of index and engineering properties of soils; soil classification (descriptive, textural, ISI, MIT, USCS); boring log interpretation; sieve analysis and interpretation of results; determination of Atterberg limits of soils.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The water content of soil is defined as the ratio of weight of water to weight of ___ of given mass of soil.",
            options: ["Voids", "Solids", "Water", "Total soil"],
            correctAnswer: "Solids",
            explanation: "The water content of soil is defined as the ratio of weight of water to weight of Solids of given mass of soil."
          },
          {
            id: 2,
            question: "Meaning of SC in soil classification is ___.",
            options: ["Silty clay", "Sandy clay", "Sand with plastic fines", "Clayey sand"],
            correctAnswer: "Sand with plastic fines",
            explanation: "Meaning of SC in soil classification is Sand with plastic fines."
          },
          {
            id: 3,
            question: "The ratio of the volume of water present in a given soil mass to the total volume of its voids is known as ___.",
            options: ["Void ratio", "Porosity", "Degree of saturation", "Water content"],
            correctAnswer: "Degree of saturation",
            explanation: "The ratio of the volume of water present in a given soil mass to the total volume of its voids is known as Degree of saturation."
          },
          {
            id: 4,
            question: "The maximum water content at which a reduction in water content does not cause a decrease in volume of a soil mass is known as ___ limit.",
            options: ["Liquid", "Plastic", "Shrinkage", "Flow"],
            correctAnswer: "Shrinkage",
            explanation: "The maximum water content at which a reduction in water content does not cause a decrease in volume of a soil mass is known as Shrinkage limit."
          },
          {
            id: 5,
            question: "Soil of Kathmandu valley are ___ and organic.",
            options: ["Sandy", "Laterite", "Black cotton", "Red"],
            correctAnswer: "Black cotton",
            explanation: "Soil of Kathmandu valley are Black cotton and organic."
          },
          {
            id: 6,
            question: "Coefficient of uniformity is ___.",
            options: ["D30/D10", "D60/D30", "D60/D10", "D10/D60"],
            correctAnswer: "D60/D10",
            explanation: "Coefficient of uniformity is D60/D10."
          },
          {
            id: 7,
            question: "The value of the coefficient of uniformity for well-graded sand is ___.",
            options: [">3", ">4", ">6", ">8"],
            correctAnswer: ">6",
            explanation: "The value of the coefficient of uniformity for well-graded sand is >6."
          },
          {
            id: 8,
            question: "The coefficient of curvature for well graded soil lies between ___.",
            options: ["1 to 3", "3 to 5", "0.5 to 1", "4 to 6"],
            correctAnswer: "1 to 3",
            explanation: "The coefficient of curvature for well graded soil lies between 1 to 3."
          },
          {
            id: 9,
            question: "The soil which has been acted upon by stress greater than present stress is called ___.",
            options: ["Normally consolidated", "Lightly overconsolidated", "Over consolidated", "Under consolidated"],
            correctAnswer: "Over consolidated",
            explanation: "The soil which has been acted upon by stress greater than present stress is called Over consolidated."
          },
          {
            id: 10,
            question: "Bulking of sand is ___ in volume of sand due to moisture absorption.",
            options: ["Decrease", "No change", "Increase", "Proportional"],
            correctAnswer: "Increase",
            explanation: "Bulking of sand is Increase in volume of sand due to moisture absorption."
          },
          {
            id: 11,
            question: "The densification of a soil by means of mechanical manipulation is called ___.",
            options: ["Consolidation", "Compaction", "Stabilization", "Compression"],
            correctAnswer: "Compaction",
            explanation: "The densification of a soil by means of mechanical manipulation is called Compaction."
          },
          {
            id: 12,
            question: "The best suited material for stabilization of black cotton soils is ___.",
            options: ["Cement", "Fly ash", "Hydrated lime", "Sand"],
            correctAnswer: "Hydrated lime",
            explanation: "The best suited material for stabilization of black cotton soils is Hydrated lime."
          },
          {
            id: 13,
            question: "Ship footed roller is used for compacting ___ soils.",
            options: ["Sandy", "Gravelly", "Clayey", "Silty"],
            correctAnswer: "Clayey",
            explanation: "Ship footed roller is used for compacting Clayey soils."
          },
          {
            id: 14,
            question: "In CBR test, the size of the cylindrical plunger is ___ mm diameter.",
            options: ["25", "40", "50", "75"],
            correctAnswer: "50",
            explanation: "In CBR test, the size of the cylindrical plunger is 50 mm diameter."
          },
          {
            id: 15,
            question: "Which factor does NOT contribute to the stability of a slope?",
            options: ["Vegetation", "Increased slope angle", "Drainage", "Reinforcement"],
            correctAnswer: "Increased slope angle",
            explanation: "Increased slope angle is the correct answer."
          },
          {
            id: 16,
            question: "Water in soil pores that cannot be extracted by gravity drainage is called ___ water.",
            options: ["Capillary", "Hygroscopic", "Pellicular", "Gravitational"],
            correctAnswer: "Pellicular",
            explanation: "Water in soil pores that cannot be extracted by gravity drainage is called Pellicular water."
          },
          {
            id: 17,
            question: "Scour depth, frost depth and top soil determine ___.",
            options: ["Bearing capacity", "Settlement", "Depth of foundation", "Pile length"],
            correctAnswer: "Depth of foundation",
            explanation: "Scour depth, frost depth and top soil determine Depth of foundation."
          },
          {
            id: 18,
            question: "Bulk density of aggregates does NOT depend upon ___ of the container.",
            options: ["Size and shape", "Material", "Weight", "Volume"],
            correctAnswer: "Size and shape",
            explanation: "Bulk density of aggregates does NOT depend upon Size and shape of the container."
          },
          {
            id: 19,
            question: "Based on MIP method, Nepal is divided into ___ zones.",
            options: ["5", "6", "7", "8"],
            correctAnswer: "7",
            explanation: "Based on MIP method, Nepal is divided into 7 zones."
          },
          {
            id: 20,
            question: "Peanut butter is an example of a ___ fluid.",
            options: ["Newtonian", "Bingham plastic", "Non-Newtonian", "Ideal"],
            correctAnswer: "Non-Newtonian",
            explanation: "Peanut butter is an example of a Non-Newtonian fluid."
          },
          {
            id: 21,
            question: "Maximum density of water occurs at ___ °C.",
            options: ["0", "2", "4", "10"],
            correctAnswer: "4",
            explanation: "Maximum density of water occurs at 4 °C."
          },
          {
            id: 22,
            question: "Bulk modulus of liquid ___ with pressure.",
            options: ["Decreases", "Remains same", "Increases", "Fluctuates"],
            correctAnswer: "Increases",
            explanation: "Bulk modulus of liquid Increases with pressure."
          },
          {
            id: 23,
            question: "A non-Newtonian fluid is one which doesn't follow Newton's law of ___.",
            options: ["Continuity", "Conservation", "Viscosity", "Motion"],
            correctAnswer: "Viscosity",
            explanation: "A non-Newtonian fluid is one which doesn't follow Newton's law of Viscosity."
          },
          {
            id: 24,
            question: "Specific volume is defined as reciprocal of ___.",
            options: ["Viscosity", "Pressure", "Density", "Specific weight"],
            correctAnswer: "Density",
            explanation: "Specific volume is defined as reciprocal of Density."
          },
          {
            id: 25,
            question: "Viscosity is defined as the ___ to flow of fluid.",
            options: ["Tendency", "Energy", "Resistance", "Pressure"],
            correctAnswer: "Resistance",
            explanation: "Viscosity is defined as the Resistance to flow of fluid."
          },
          {
            id: 26,
            question: "The dimension of kinematic viscosity is ___.",
            options: ["ML⁻¹T⁻¹", "M°L²T⁻¹", "ML²T⁻²", "M°L¹T⁻¹"],
            correctAnswer: "M°L²T⁻¹",
            explanation: "The dimension of kinematic viscosity is M°L²T⁻¹."
          },
          {
            id: 27,
            question: "The dimensional formula of velocity gradient is ___.",
            options: ["M°L°T⁻¹", "ML⁻¹T⁻¹", "M°LT⁻²", "ML°T⁻¹"],
            correctAnswer: "M°L°T⁻¹",
            explanation: "The dimensional formula of velocity gradient is M°L°T⁻¹."
          },
          {
            id: 28,
            question: "The radius of curvature of the arc of the bubble tube is generally kept ___ m.",
            options: ["50", "75", "100", "150"],
            correctAnswer: "100",
            explanation: "The radius of curvature of the arc of the bubble tube is generally kept 100 m."
          },
          {
            id: 29,
            question: "If the dew point is above 0°C, then ___ will form.",
            options: ["Frost", "Snow", "Dew", "Ice"],
            correctAnswer: "Dew",
            explanation: "If the dew point is above 0°C, then Dew will form."
          },
          {
            id: 30,
            question: "A fluid will undergo ___ deformation under the action of shearing stress.",
            options: ["Elastic", "Plastic", "Continuous", "Brittle"],
            correctAnswer: "Continuous",
            explanation: "A fluid will undergo Continuous deformation under the action of shearing stress."
          },
          {
            id: 31,
            question: "If critical shear stress of channel is Tc, average shear stress required to move grain on bank is ___.",
            options: ["Tc", "0.5 Tc", "0.75 Tc", "1.25 Tc"],
            correctAnswer: "0.75 Tc",
            explanation: "If critical shear stress of channel is Tc, average shear stress required to move grain on bank is 0.75 Tc."
          },
          {
            id: 32,
            question: "The spherical shape of water drops is due to property of ___ of water.",
            options: ["Viscosity", "Density", "Surface tension", "Elasticity"],
            correctAnswer: "Surface tension",
            explanation: "The spherical shape of water drops is due to property of Surface tension of water."
          },
          {
            id: 33,
            question: "The value of pressure inside a soap bubble of radius R is ___.",
            options: ["2T/R", "4T/R", "T/R", "8T/R"],
            correctAnswer: "4T/R",
            explanation: "The value of pressure inside a soap bubble of radius R is 4T/R."
          },
          {
            id: 34,
            question: "Buoyant force is the resultant force on a body due to the fluid ___.",
            options: ["Pressure", "Weight", "Surrounding it", "Velocity"],
            correctAnswer: "Surrounding it",
            explanation: "Buoyant force is the resultant force on a body due to the fluid Surrounding it."
          },
          {
            id: 35,
            question: "Pabs = Pgauge ___ Patm.",
            options: ["×", "−", "÷", "±"],
            correctAnswer: "±",
            explanation: "Pabs = Pgauge ± Patm."
          },
          {
            id: 36,
            question: "Pressure at a point in a fluid will NOT be same in all directions when fluid is viscous and ___.",
            options: ["Static", "At rest", "Moving", "Incompressible"],
            correctAnswer: "Moving",
            explanation: "Pressure at a point in a fluid will NOT be same in all directions when fluid is viscous and Moving."
          },
          {
            id: 37,
            question: "Force on a hemispherical part if pressure acted is Po is ___.",
            options: ["2πr²Po", "Πr²Po", "Πr³Po", "2πrPo"],
            correctAnswer: "Πr²Po",
            explanation: "Force on a hemispherical part if pressure acted is Po is Πr²Po."
          },
          {
            id: 38,
            question: "The piezometric head for static fluid ___ at all points.",
            options: ["Varies", "Remains constant", "Increases", "Decreases"],
            correctAnswer: "Remains constant",
            explanation: "The piezometric head for static fluid Remains constant at all points."
          },
          {
            id: 39,
            question: "Pressure in Pascal at depth 1m below water surface is ___ Pascal.",
            options: ["9800", "9810", "10000", "9500"],
            correctAnswer: "9810",
            explanation: "Pressure in Pascal at depth 1m below water surface is 9810 Pascal."
          },
          {
            id: 40,
            question: "The correct expression is GM = ___.",
            options: ["I/V + BG", "I/V − BG", "BG − I/V", "V/I − BG"],
            correctAnswer: "I/V − BG",
            explanation: "The correct expression is GM = I/V − BG."
          },
          {
            id: 41,
            question: "A floating body attains stable equilibrium if its metacenter is ___ the centroid.",
            options: ["Below", "At", "Above", "Beside"],
            correctAnswer: "Above",
            explanation: "A floating body attains stable equilibrium if its metacenter is Above the centroid."
          },
          {
            id: 42,
            question: "Bourdon gauge is used to measure ___ pressure.",
            options: ["Absolute", "Atmospheric", "Vacuum", "Gauge"],
            correctAnswer: "Gauge",
            explanation: "Bourdon gauge is used to measure Gauge pressure."
          },
          {
            id: 43,
            question: "In Bernoulli's equation, each term represents total energy per unit ___.",
            options: ["Mass", "Volume", "Area", "Weight"],
            correctAnswer: "Weight",
            explanation: "In Bernoulli's equation, each term represents total energy per unit Weight."
          },
          {
            id: 44,
            question: "The sheet of water flowing over a weir is called ___.",
            options: ["Spillway", "Nappe", "Crest", "Sill"],
            correctAnswer: "Nappe",
            explanation: "The sheet of water flowing over a weir is called Nappe."
          },
          {
            id: 45,
            question: "Equation of continuity for compressible fluid in steady flow is ___.",
            options: ["A1V1=A2V2", "Ρ1A1V1=ρ2A2V2", "A1/V1=A2/V2", "V1+V2=constant"],
            correctAnswer: "Ρ1A1V1=ρ2A2V2",
            explanation: "Equation of continuity for compressible fluid in steady flow is Ρ1A1V1=ρ2A2V2."
          },
          {
            id: 46,
            question: "If area changes from A1 to A2, A1×V1 = A2×V2 is called equation of ___.",
            options: ["Momentum", "Energy", "Continuity", "Bernoulli"],
            correctAnswer: "Continuity",
            explanation: "If area changes from A1 to A2, A1×V1 = A2×V2 is called equation of Continuity."
          },
          {
            id: 47,
            question: "Bernoulli equation states energy is ___ for one streamline.",
            options: ["Variable", "Constant", "Zero", "Infinite"],
            correctAnswer: "Constant",
            explanation: "Bernoulli equation states energy is Constant for one streamline."
          },
          {
            id: 48,
            question: "Bernoulli equation is NOT to be used for ___ flow.",
            options: ["Turbulent", "Laminar", "Steady", "Viscous"],
            correctAnswer: "Viscous",
            explanation: "Bernoulli equation is NOT to be used for Viscous flow."
          },
          {
            id: 49,
            question: "Coefficient of friction for laminar flow is ___.",
            options: ["32/Re", "16/Re", "64/Re", "8/Re"],
            correctAnswer: "16/Re",
            explanation: "Coefficient of friction for laminar flow is 16/Re."
          },
          {
            id: 50,
            question: "The dimension of Manning rugosity coefficient is ___.",
            options: ["ML⁻⁰·³³T", "M°L⁰·³³T", "ML⁰·³³T⁻¹", "M°L⁻⁰·³³T"],
            correctAnswer: "ML⁻⁰·³³T",
            explanation: "The dimension of Manning rugosity coefficient is ML⁻⁰·³³T."
          },
          {
            id: 51,
            question: "When three pipes are connected in series, ___ is same through each pipe.",
            options: ["Pressure", "Head loss", "Discharge", "Velocity"],
            correctAnswer: "Discharge",
            explanation: "When three pipes are connected in series, Discharge is same through each pipe."
          },
          {
            id: 52,
            question: "When pipes of same material are connected in parallel, total loss of head is ___ as in each pipe.",
            options: ["More", "Less", "Same", "Double"],
            correctAnswer: "Same",
            explanation: "When pipes of same material are connected in parallel, total loss of head is Same as in each pipe."
          },
          {
            id: 53,
            question: "In a vertical stationary plate, jet after striking moves ___ the plate.",
            options: ["Perpendicular to", "Away from", "Along", "Into"],
            correctAnswer: "Along",
            explanation: "In a vertical stationary plate, jet after striking moves Along the plate."
          },
          {
            id: 54,
            question: "The force exerted by a jet of water on a stationary vertical plate in direction of jet is ___.",
            options: ["ΡaV", "ΡaV²", "Ρa²V", "ΡV²/2"],
            correctAnswer: "ΡaV²",
            explanation: "The force exerted by a jet of water on a stationary vertical plate in direction of jet is ΡaV²."
          },
          {
            id: 55,
            question: "Kinematic similarity between model and prototype is similarity of ___ pattern.",
            options: ["Pressure", "Velocity", "Streamline", "Force"],
            correctAnswer: "Streamline",
            explanation: "Kinematic similarity between model and prototype is similarity of Streamline pattern."
          },
          {
            id: 56,
            question: "In a venturi meter, ___ has the highest velocity.",
            options: ["Inlet", "Outlet", "Throat", "Diffuser"],
            correctAnswer: "Throat",
            explanation: "In a venturi meter, Throat has the highest velocity."
          },
          {
            id: 57,
            question: "Prandl mixing length is ___ at the pipe wall.",
            options: ["Maximum", "Infinite", "Zero", "Minimum but not zero"],
            correctAnswer: "Zero",
            explanation: "Prandl mixing length is Zero at the pipe wall."
          },
          {
            id: 58,
            question: "A pitot tube is used to measure ___ of flow.",
            options: ["Pressure", "Depth", "Velocity", "Discharge"],
            correctAnswer: "Velocity",
            explanation: "A pitot tube is used to measure Velocity of flow."
          },
          {
            id: 59,
            question: "Head loss formula h = flQ²/12.1D⁵ is given by ___.",
            options: ["Hazen-Williams", "Manning", "Darcy-Weisbach", "Chezy"],
            correctAnswer: "Darcy-Weisbach",
            explanation: "Head loss formula h = flQ²/12.1D⁵ is given by Darcy-Weisbach."
          },
          {
            id: 60,
            question: "Formula for sudden expansion loss is ___.",
            options: ["V1²/2g", "V2²/2g", "(V1-V2)²/2g", "(V1+V2)²/2g"],
            correctAnswer: "(V1-V2)²/2g",
            explanation: "Formula for sudden expansion loss is (V1-V2)²/2g."
          },
          {
            id: 61,
            question: "If particle size is 6 cm, Manning's rugosity coefficient is ___.",
            options: ["0.012", "0.020", "0.029", "0.040"],
            correctAnswer: "0.029",
            explanation: "If particle size is 6 cm, Manning's rugosity coefficient is 0.029."
          },
          {
            id: 62,
            question: "Coefficient of discharge for an orifice meter is in range ___.",
            options: ["0.45 to 0.55", "0.62 to 0.65", "0.80 to 0.85", "0.95 to 0.99"],
            correctAnswer: "0.62 to 0.65",
            explanation: "Coefficient of discharge for an orifice meter is in range 0.62 to 0.65."
          },
          {
            id: 63,
            question: "In Moody diagram, e/D parameter — e represents surface ___ height.",
            options: ["Friction", "Roughness", "Elevation", "Tension"],
            correctAnswer: "Roughness",
            explanation: "In Moody diagram, e/D parameter — e represents surface Roughness height."
          },
          {
            id: 64,
            question: "Fluids with strain rates proportional to applied shear stress are termed ___ fluid.",
            options: ["Ideal", "Non-Newtonian", "Newtonian", "Bingham plastic"],
            correctAnswer: "Newtonian",
            explanation: "Fluids with strain rates proportional to applied shear stress are termed Newtonian fluid."
          },
          {
            id: 65,
            question: "Water flowing steadily in constant cross-sectional pipe — pressure ___ with height.",
            options: ["Decreases", "Remains constant", "Increases", "Fluctuates"],
            correctAnswer: "Increases",
            explanation: "Water flowing steadily in constant cross-sectional pipe — pressure Increases with height."
          }
        ]
      },
      {
        id: 2,
        title: "Stresses on soil and seepage",
        description: "Effective stress (factors affecting effective stress, capillary rise, and quick sand conditions); seepage analysis [Seepage pressure, flow nets and their applications]; soil compressibility (including various indices) and compaction (definition, affecting factors).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Core cutter method is used to measure in-situ ___.",
            options: ["Permeability", "Shear strength", "Density", "Compressibility"],
            correctAnswer: "Density",
            explanation: "Core cutter method is used to measure in-situ Density."
          },
          {
            id: 2,
            question: "Falling head permeability test can be used for ___ permeable soil.",
            options: ["Highly", "Moderately", "Less", "Coarse"],
            correctAnswer: "Less",
            explanation: "Falling head permeability test can be used for Less permeable soil."
          },
          {
            id: 3,
            question: "The constant head permeability test can be used for ___ grained soil.",
            options: ["Fine", "Medium", "Coarse", "All"],
            correctAnswer: "Coarse",
            explanation: "The constant head permeability test can be used for Coarse grained soil."
          },
          {
            id: 4,
            question: "Critical hydraulic gradient is formed if seepage is upward, flow is upward and effective stress is ___.",
            options: ["Maximum", "Minimum", "Zero", "Equal to total stress"],
            correctAnswer: "Zero",
            explanation: "Critical hydraulic gradient is formed if seepage is upward, flow is upward and effective stress is Zero."
          },
          {
            id: 5,
            question: "Compaction is a process in which change in volume due to removal of ___.",
            options: ["Water", "Solids", "Air", "Voids"],
            correctAnswer: "Air",
            explanation: "Compaction is a process in which change in volume due to removal of Air."
          },
          {
            id: 6,
            question: "The direction of seepage water is perpendicular to the ___ line.",
            options: ["Flow", "Seepage", "Equipotential", "Boundary"],
            correctAnswer: "Equipotential",
            explanation: "The direction of seepage water is perpendicular to the Equipotential line."
          },
          {
            id: 7,
            question: "The critical gradient of seepage of water in a soil medium is (G=specific gravity, e=void ratio) ___.",
            options: ["G/(1+e)", "(G-1)/(1+e)", "(G+1)/(1-e)", "G-1/e"],
            correctAnswer: "(G-1)/(1+e)",
            explanation: "The critical gradient of seepage of water in a soil medium is (G=specific gravity, e=void ratio) (G-1)/(1+e)."
          },
          {
            id: 8,
            question: "Darcy's law is valid for ___ saturated soil and steady flow.",
            options: ["Partially", "Fully", "Non", "Over"],
            correctAnswer: "Fully",
            explanation: "Darcy's law is valid for Fully saturated soil and steady flow."
          },
          {
            id: 9,
            question: "In compaction of each layer of soil, thickness should be ___ mm.",
            options: ["100", "150", "200", "250"],
            correctAnswer: "150",
            explanation: "In compaction of each layer of soil, thickness should be 150 mm."
          },
          {
            id: 10,
            question: "For same soil, the effect of modified Proctor compared to standard Proctor test is to ___ maximum dry density and decrease OMC.",
            options: ["Maintain", "Decrease", "Increase", "Double"],
            correctAnswer: "Increase",
            explanation: "For same soil, the effect of modified Proctor compared to standard Proctor test is to Increase maximum dry density and decrease OMC."
          },
          {
            id: 11,
            question: "The formula for seepage discharge in flow net is ___.",
            options: ["Q = khNd/Nf", "Q = kh(Nf+Nd)", "Q = khNf/Nd", "Q = kh/(NfNd)"],
            correctAnswer: "Q = khNf/Nd",
            explanation: "The formula for seepage discharge in flow net is Q = khNf/Nd."
          },
          {
            id: 12,
            question: "Relative compaction is defined as ___.",
            options: ["Γd/γdmin", "Γdmax/γd", "Γd/γdmax", "Γdmin/γdmax"],
            correctAnswer: "Γd/γdmax",
            explanation: "Relative compaction is defined as Γd/γdmax."
          },
          {
            id: 13,
            question: "The neutral stress in a soil mass is stress taken up by the ___.",
            options: ["Soil skeleton", "Pore water", "Soil grains", "Clay particles"],
            correctAnswer: "Pore water",
            explanation: "The neutral stress in a soil mass is stress taken up by the Pore water."
          },
          {
            id: 14,
            question: "Vibratory roller should be selected to have effective compaction of the ___ grained soil.",
            options: ["Fine", "Clay", "Coarse", "Silty"],
            correctAnswer: "Coarse",
            explanation: "Vibratory roller should be selected to have effective compaction of the Coarse grained soil."
          },
          {
            id: 15,
            question: "Which has the minimum compressibility at room temperature?",
            options: ["Air", "Oil", "Mercury", "Water"],
            correctAnswer: "Water",
            explanation: "Water is the correct answer."
          },
          {
            id: 16,
            question: "Neutral stress in a soil mass is stress taken up by the ___.",
            options: ["Soil skeleton", "Pore water", "Clay particles", "Mineral grains"],
            correctAnswer: "Pore water",
            explanation: "Neutral stress in a soil mass is stress taken up by the Pore water."
          },
          {
            id: 17,
            question: "Vibratory roller should be selected for effective compaction of ___ soil.",
            options: ["Cohesive", "Clayey", "Fine grained", "Coarse grained"],
            correctAnswer: "Coarse grained",
            explanation: "Vibratory roller should be selected for effective compaction of Coarse grained soil."
          },
          {
            id: 18,
            question: "In compaction, each layer of soil thickness should be ___ mm.",
            options: ["50", "100", "150", "200"],
            correctAnswer: "150",
            explanation: "In compaction, each layer of soil thickness should be 150 mm."
          },
          {
            id: 19,
            question: "Effect of modified Proctor compared to standard Proctor is to ___ maximum dry density and ___ OMC.",
            options: ["Decrease; increase", "Increase; decrease", "Increase; increase", "Decrease; decrease"],
            correctAnswer: "Increase; decrease",
            explanation: "Effect of modified Proctor compared to standard Proctor is to Increase; decrease maximum dry density and ___ OMC."
          },
          {
            id: 20,
            question: "Relative compaction depends upon ___ of soil.",
            options: ["Gradation", "Structure", "Type", "Plasticity"],
            correctAnswer: "Type",
            explanation: "Relative compaction depends upon Type of soil."
          },
          {
            id: 21,
            question: "Darcy's law is valid for ___ saturated soil and ___ flow.",
            options: ["Partly; unsteady", "Fully; steady", "Partly; steady", "Fully; unsteady"],
            correctAnswer: "Fully; steady",
            explanation: "Darcy's law is valid for Fully; steady saturated soil and ___ flow."
          },
          {
            id: 22,
            question: "The rise of a liquid in a capillary tube depends on the ___ radius of the tube.",
            options: ["Outer", "Inner", "Average", "Effective"],
            correctAnswer: "Inner",
            explanation: "The rise of a liquid in a capillary tube depends on the Inner radius of the tube."
          },
          {
            id: 23,
            question: "If height in capillary P is 2/3 of height in Q, the ratio of diameters is ___.",
            options: ["2:3", "3:2", "1:2", "2:1"],
            correctAnswer: "3:2",
            explanation: "If height in capillary P is 2/3 of height in Q, the ratio of diameters is 3:2."
          },
          {
            id: 24,
            question: "The rise of a liquid in a capillary tube is due to ___.",
            options: ["Gravity", "Viscosity", "Surface tension", "Density"],
            correctAnswer: "Surface tension",
            explanation: "The rise of a liquid in a capillary tube is due to Surface tension."
          },
          {
            id: 25,
            question: "The capillary rise of water depends upon the ___ responsible.",
            options: ["Force", "Mass", "Weight", "Pressure"],
            correctAnswer: "Force",
            explanation: "The capillary rise of water depends upon the Force responsible."
          }
        ]
      },
      {
        id: 3,
        title: "Shear strength of soil and stability of slopes",
        description: "Concept of shear strength, principal planes and principal stresses; Mohr-Coulomb theory of shear strength; calculation of normal and shear stresses at different planes; relation of principle stress at failure condition; types of shear tests; stability of slopes.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "On wetting, cohesive soils ___ their shear strength.",
            options: ["Increase", "Maintain", "Decrease", "Double"],
            correctAnswer: "Decrease",
            explanation: "On wetting, cohesive soils Decrease their shear strength."
          },
          {
            id: 2,
            question: "Mohr's circle is a graphical representation of plane stress problems showing maximum ___.",
            options: ["Normal stress", "Principal stress", "Shear stress", "Bending stress"],
            correctAnswer: "Shear stress",
            explanation: "Mohr's circle is a graphical representation of plane stress problems showing maximum Shear stress."
          },
          {
            id: 3,
            question: "The shear strength of plastic undrained clay depends upon ___.",
            options: ["Friction angle", "Density", "Cohesion", "Void ratio"],
            correctAnswer: "Cohesion",
            explanation: "The shear strength of plastic undrained clay depends upon Cohesion."
          },
          {
            id: 4,
            question: "For testing a saturated clay for shear strength, the test recommended is ___.",
            options: ["Direct shear test", "Triaxial CD test", "Unconfined compression test", "Vane shear test"],
            correctAnswer: "Unconfined compression test",
            explanation: "For testing a saturated clay for shear strength, the test recommended is Unconfined compression test."
          },
          {
            id: 5,
            question: "Coulomb's equation for shear strength is given by: c = ___.",
            options: ["S + σtanϕ", "S × σtanϕ", "S - σtanϕ", "S / σtanϕ"],
            correctAnswer: "S - σtanϕ",
            explanation: "Coulomb's equation for shear strength is given by: c = S - σtanϕ."
          },
          {
            id: 6,
            question: "The radius of the Mohr's circle represents ___.",
            options: ["Normal stress", "Major principal stress", "Maximum shear stress", "Minor principal stress"],
            correctAnswer: "Maximum shear stress",
            explanation: "The radius of the Mohr's circle represents Maximum shear stress."
          },
          {
            id: 7,
            question: "Moment equilibrium is considered around the center of the circular arc is an assumption made in ___ theory of slope stability analysis.",
            options: ["Fellenius", "Taylor", "Bishop's", "Rankine"],
            correctAnswer: "Bishop's",
            explanation: "Moment equilibrium is considered around the center of the circular arc is an assumption made in Bishop's theory of slope stability analysis."
          },
          {
            id: 8,
            question: "When drainage is permitted throughout the triaxial test, it is known as ___ test.",
            options: ["UU", "CU", "CD", "UC"],
            correctAnswer: "CD",
            explanation: "When drainage is permitted throughout the triaxial test, it is known as CD test."
          },
          {
            id: 9,
            question: "Pore pressure developed in the triaxial test can be measured by ___.",
            options: ["Casagrande's apparatus", "Bishop's apparatus", "Oedometer", "Triaxial cell"],
            correctAnswer: "Bishop's apparatus",
            explanation: "Pore pressure developed in the triaxial test can be measured by Bishop's apparatus."
          },
          {
            id: 10,
            question: "Formula for shear strength from vane shear test is S = ___.",
            options: ["T/(πD²H)", "T/(πD²(H/2+D/6))", "T×D/(πH)", "T/(πDH²)"],
            correctAnswer: "T/(πD²(H/2+D/6))",
            explanation: "Formula for shear strength from vane shear test is S = T/(πD²(H/2+D/6))."
          },
          {
            id: 11,
            question: "The X and Y axes of Mohr's circle represent ___ stress and ___ stress.",
            options: ["Principal; shear", "Normal; shear", "Effective; total", "Major; minor"],
            correctAnswer: "Normal; shear",
            explanation: "The X and Y axes of Mohr's circle represent Normal; shear stress and ___ stress."
          },
          {
            id: 12,
            question: "Shear strength of plastic undrained clay depends upon ___.",
            options: ["Friction angle", "Cohesion", "Void ratio", "Permeability"],
            correctAnswer: "Cohesion",
            explanation: "Shear strength of plastic undrained clay depends upon Cohesion."
          },
          {
            id: 13,
            question: "For testing saturated clay for shear strength, the recommended test is ___.",
            options: ["Triaxial CD test", "Direct shear test", "Unconfined compression test", "Vane shear test"],
            correctAnswer: "Unconfined compression test",
            explanation: "For testing saturated clay for shear strength, the recommended test is Unconfined compression test."
          },
          {
            id: 14,
            question: "An angle θ in the physical element is represented as ___ on Mohr's circle.",
            options: ["Θ/2", "Θ", "2θ", "3θ"],
            correctAnswer: "2θ",
            explanation: "An angle θ in the physical element is represented as 2θ on Mohr's circle."
          },
          {
            id: 15,
            question: "In Bishop's theory of slope stability analysis, moment equilibrium is considered around the ___.",
            options: ["Base of slope", "Toe", "Center of the circular arc", "Crest"],
            correctAnswer: "Center of the circular arc",
            explanation: "In Bishop's theory of slope stability analysis, moment equilibrium is considered around the Center of the circular arc."
          },
          {
            id: 16,
            question: "Coulomb's equation for shear strength is c = ___.",
            options: ["S + σ tanϕ", "S - σ tanϕ", "S × σ tanϕ", "S/σ tanϕ"],
            correctAnswer: "S - σ tanϕ",
            explanation: "Coulomb's equation for shear strength is c = S - σ tanϕ."
          },
          {
            id: 17,
            question: "Maximum shear stress on a Mohr's circle equals ___.",
            options: ["(σ1+σ3)/2", "(σ1-σ3)/2", "Σ1-σ3", "(σ1+σ3)"],
            correctAnswer: "(σ1-σ3)/2",
            explanation: "Maximum shear stress on a Mohr's circle equals (σ1-σ3)/2."
          },
          {
            id: 18,
            question: "The parameter ϕ in Coulomb's equation 'S = c + σ tanϕ' represents ___.",
            options: ["Cohesion", "Unit weight", "Angle of internal friction", "Pore pressure"],
            correctAnswer: "Angle of internal friction",
            explanation: "The parameter ϕ in Coulomb's equation 'S = c + σ tanϕ' represents Angle of internal friction."
          },
          {
            id: 19,
            question: "In Taylor's stability number, Sn = Cm/γH, the term Cm is ___.",
            options: ["Maximum cohesion", "Mobilized cohesion", "Mean cohesion", "Critical cohesion"],
            correctAnswer: "Mobilized cohesion",
            explanation: "In Taylor's stability number, Sn = Cm/γH, the term Cm is Mobilized cohesion."
          },
          {
            id: 20,
            question: "Pore pressure developed in triaxial test can be measured by ___.",
            options: ["Piezometer", "Tensiometer", "Bishop's apparatus", "U-tube manometer"],
            correctAnswer: "Bishop's apparatus",
            explanation: "Pore pressure developed in triaxial test can be measured by Bishop's apparatus."
          }
        ]
      },
      {
        id: 4,
        title: "Soil exploration, earth pressure and retaining structures",
        description: "Soil exploration (methods, planning, soil sampling and samplers, field tests, site investigation reports); earth pressure theories; stability analysis of retaining walls; techniques to increase stability of retaining walls.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The formula for Active earth pressure coefficient is ___.",
            options: ["(1+sinϕ)/(1-sinϕ)", "(1-sinϕ)/(1+sinϕ)", "Tanϕ/2", "Sin²ϕ/(1-sinϕ)"],
            correctAnswer: "(1-sinϕ)/(1+sinϕ)",
            explanation: "The formula for Active earth pressure coefficient is (1-sinϕ)/(1+sinϕ)."
          },
          {
            id: 2,
            question: "The coefficient of passive earth pressure is ___.",
            options: ["(1-sinϕ)/(1+sinϕ)", "(1+sinϕ)/(1-sinϕ)", "Tanϕ/2", "1/Ka"],
            correctAnswer: "(1+sinϕ)/(1-sinϕ)",
            explanation: "The coefficient of passive earth pressure is (1+sinϕ)/(1-sinϕ)."
          },
          {
            id: 3,
            question: "Dilatancy correction for SPT N value is applied to ___.",
            options: ["Dense gravel", "Dry sand", "Fine silty saturated sand", "Stiff clay"],
            correctAnswer: "Fine silty saturated sand",
            explanation: "Dilatancy correction for SPT N value is applied to Fine silty saturated sand."
          },
          {
            id: 4,
            question: "Meniscus correction is ___ a correction of SPT.",
            options: ["Is", "Is always", "Is not", "Is the primary"],
            correctAnswer: "Is not",
            explanation: "Meniscus correction is Is not a correction of SPT."
          },
          {
            id: 5,
            question: "The relation of active earth pressure in cohesive soil is ___.",
            options: ["Ka x σz + 2C√Ka", "Ka x σz - 2C√Ka", "Ka x σz × 2C√Ka", "Ka x σz / 2C√Ka"],
            correctAnswer: "Ka x σz - 2C√Ka",
            explanation: "The relation of active earth pressure in cohesive soil is Ka x σz - 2C√Ka."
          },
          {
            id: 6,
            question: "The apex angle of Dutch cone is about ___°.",
            options: ["30", "45", "60", "90"],
            correctAnswer: "60",
            explanation: "The apex angle of Dutch cone is about 60°."
          },
          {
            id: 7,
            question: "Formula for area ratio is ___.",
            options: ["(D2²−D1²)/D1²×100", "(D2−D1)/D1×100", "(D2²+D1²)/D1²×100", "D2²/D1²×100"],
            correctAnswer: "(D2²−D1²)/D1²×100",
            explanation: "Formula for area ratio is (D2²−D1²)/D1²×100."
          },
          {
            id: 8,
            question: "Dilatancy correction for SPT N value is applied to ___ sand.",
            options: ["Dry", "Coarse", "Fine silty saturated", "Gravel"],
            correctAnswer: "Fine silty saturated",
            explanation: "Dilatancy correction for SPT N value is applied to Fine silty saturated sand."
          },
          {
            id: 9,
            question: "Which is NOT a correction for SPT?",
            options: ["Overburden correction", "Rod length correction", "Meniscus correction", "Borehole diameter correction"],
            correctAnswer: "Meniscus correction",
            explanation: "Meniscus correction is the correct answer."
          },
          {
            id: 10,
            question: "Based on Rankine's theory, the soil mass is assumed to be ___.",
            options: ["Heterogeneous", "Anisotropic", "Homogeneous", "Layered"],
            correctAnswer: "Homogeneous",
            explanation: "Based on Rankine's theory, the soil mass is assumed to be Homogeneous."
          },
          {
            id: 11,
            question: "The depth of exploration is independent of ___ of structure.",
            options: ["Type", "Load", "Size", "Location"],
            correctAnswer: "Size",
            explanation: "The depth of exploration is independent of Size of structure."
          },
          {
            id: 12,
            question: "Relation of active earth pressure in cohesive soil is ___.",
            options: ["Ka×σz + 2C√Ka", "Ka×σz − 2C√Ka", "Ka×σz − C√Ka", "Ka×σz + C"],
            correctAnswer: "Ka×σz − 2C√Ka",
            explanation: "Relation of active earth pressure in cohesive soil is Ka×σz − 2C√Ka."
          },
          {
            id: 13,
            question: "Cullman Graph is used in ___ wedge theory.",
            options: ["Rankine", "Bell", "Column", "Coulomb"],
            correctAnswer: "Column",
            explanation: "Cullman Graph is used in Column wedge theory."
          },
          {
            id: 14,
            question: "Active earth pressure is defined as lateral pressure exerted by soil when the retaining wall tends to move ___ from the backfill.",
            options: ["Towards", "Into", "Away", "Along"],
            correctAnswer: "Away",
            explanation: "Active earth pressure is defined as lateral pressure exerted by soil when the retaining wall tends to move Away from the backfill."
          },
          {
            id: 15,
            question: "Rankine theory assumes the retaining wall surface is ___.",
            options: ["Rough", "Smooth", "Inclined", "Stepped"],
            correctAnswer: "Smooth",
            explanation: "Rankine theory assumes the retaining wall surface is Smooth."
          },
          {
            id: 16,
            question: "If Poisson's ratio is 0.4, coefficient of earth pressure at rest K0 = ___.",
            options: ["0.25", "0.40", "0.67", "0.75"],
            correctAnswer: "0.67",
            explanation: "If Poisson's ratio is 0.4, coefficient of earth pressure at rest K0 = 0.67."
          },
          {
            id: 17,
            question: "Coefficient of passive earth pressure is ___.",
            options: ["(1-sinϕ)/(1+sinϕ)", "(1+sinϕ)/(1-sinϕ)", "Tan²(45-ϕ/2)", "Ka²"],
            correctAnswer: "(1+sinϕ)/(1-sinϕ)",
            explanation: "Coefficient of passive earth pressure is (1+sinϕ)/(1-sinϕ)."
          },
          {
            id: 18,
            question: "Exploration during construction is ___ stage of soil exploration.",
            options: ["First", "Second", "Last", "Not a"],
            correctAnswer: "Not a",
            explanation: "Exploration during construction is Not a stage of soil exploration."
          }
        ]
      },
      {
        id: 5,
        title: "Fundamentals of foundation",
        description: "Definition, Types (Shallow and Deep), functions, factor affecting, site investigation of foundation, concept of spread and mat foundation.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "If the length of footing is very larger than that of width, the type of footing used is ___.",
            options: ["Isolated footing", "Combined footing", "Strip footing", "Raft footing"],
            correctAnswer: "Strip footing",
            explanation: "If the length of footing is very larger than that of width, the type of footing used is Strip footing."
          },
          {
            id: 2,
            question: "Mat foundation is provided when ___ load has to be transferred.",
            options: ["Light", "Medium", "Heavy", "Dynamic"],
            correctAnswer: "Heavy",
            explanation: "Mat foundation is provided when Heavy load has to be transferred."
          },
          {
            id: 3,
            question: "Combined footing type of footing is preferred if two nearby separate footings are about to ___.",
            options: ["Support equal loads", "Fail", "Overlap", "Settle differentially"],
            correctAnswer: "Overlap",
            explanation: "Combined footing type of footing is preferred if two nearby separate footings are about to Overlap."
          },
          {
            id: 4,
            question: "The minimum depth of foundation in clayey soil is ___.",
            options: ["0.5 m", "0.9 m", "1.2 m", "1.5 m"],
            correctAnswer: "0.9 m",
            explanation: "The minimum depth of foundation in clayey soil is 0.9 m."
          },
          {
            id: 5,
            question: "The minimum depth of footing up to ground level is ___ mm.",
            options: ["300", "400", "500", "600"],
            correctAnswer: "500",
            explanation: "The minimum depth of footing up to ground level is 500 mm."
          },
          {
            id: 6,
            question: "The number of pier required for a column is ___.",
            options: ["1", "2", "3", "4"],
            correctAnswer: "3",
            explanation: "The number of pier required for a column is 3."
          },
          {
            id: 7,
            question: "The angle subtended by rigid cone below foundation with respect to horizontal is ___.",
            options: ["30°+∅/2", "45°+∅/2", "60°+∅/2", "90°-∅/2"],
            correctAnswer: "45°+∅/2",
            explanation: "The angle subtended by rigid cone below foundation with respect to horizontal is 45°+∅/2."
          },
          {
            id: 8,
            question: "A foundation is termed 'fully compensated' when total weight of excavated soil equals ___ % of building weight.",
            options: ["50", "75", "100", "125"],
            correctAnswer: "100",
            explanation: "A foundation is termed 'fully compensated' when total weight of excavated soil equals 100 % of building weight."
          },
          {
            id: 9,
            question: "Mat foundation is a type of ___ foundation.",
            options: ["Deep", "Pile", "Shallow", "Caisson"],
            correctAnswer: "Shallow",
            explanation: "Mat foundation is a type of Shallow foundation."
          },
          {
            id: 10,
            question: "Pile foundation is ___ type.",
            options: ["Shallow", "Spread", "Deep", "Isolated"],
            correctAnswer: "Deep",
            explanation: "Pile foundation is Deep type."
          },
          {
            id: 11,
            question: "Pile foundation is constructed in ___.",
            options: ["Pairs", "Rows", "Group", "Isolation"],
            correctAnswer: "Group",
            explanation: "Pile foundation is constructed in Group."
          },
          {
            id: 12,
            question: "Mat foundation is provided when heavy load is to be transferred and isolated footing covers more than ___ % area.",
            options: ["30", "40", "50", "60"],
            correctAnswer: "50",
            explanation: "Mat foundation is provided when heavy load is to be transferred and isolated footing covers more than 50 % area."
          },
          {
            id: 13,
            question: "Which is NOT a common type of Mat foundation?",
            options: ["Flat plate", "Beam and slab", "Double flat plate thickened", "Plate thickened under columns"],
            correctAnswer: "Double flat plate thickened",
            explanation: "Double flat plate thickened is the correct answer."
          },
          {
            id: 14,
            question: "If there are 2 or more columns in a single foundation, it is called ___ footing.",
            options: ["Isolated", "Raft", "Combined", "Strap"],
            correctAnswer: "Combined",
            explanation: "If there are 2 or more columns in a single foundation, it is called Combined footing."
          },
          {
            id: 15,
            question: "Combined footing is preferred when two nearby separate footings are about to ___.",
            options: ["Separate", "Overlap", "Differ in load", "Differ in size"],
            correctAnswer: "Overlap",
            explanation: "Combined footing is preferred when two nearby separate footings are about to Overlap."
          },
          {
            id: 16,
            question: "Minimum depth of foundation in clayey soil is ___ m.",
            options: ["0.5", "0.7", "0.9", "1.2"],
            correctAnswer: "0.9",
            explanation: "Minimum depth of foundation in clayey soil is 0.9 m."
          },
          {
            id: 17,
            question: "The type of footing used when two columns carry equal loads is ___ footing.",
            options: ["Trapezoidal", "Cantilever", "Rectangular", "Strap"],
            correctAnswer: "Rectangular",
            explanation: "The type of footing used when two columns carry equal loads is Rectangular footing."
          },
          {
            id: 18,
            question: "Open foundation is used for ___.",
            options: ["Tall buildings", "Bridges", "Retaining walls", "Towers"],
            correctAnswer: "Bridges",
            explanation: "Open foundation is used for Bridges."
          },
          {
            id: 19,
            question: "Minimum depth of footing up to ground level is ___ mm.",
            options: ["300", "400", "500", "600"],
            correctAnswer: "500",
            explanation: "Minimum depth of footing up to ground level is 500 mm."
          },
          {
            id: 20,
            question: "If raft foundation rests on weak soil, the pressure distribution tends to be ___.",
            options: ["Triangular", "Parabolic", "Uniform", "Concentrated"],
            correctAnswer: "Uniform",
            explanation: "If raft foundation rests on weak soil, the pressure distribution tends to be Uniform."
          },
          {
            id: 21,
            question: "Number of piers required for a column is ___.",
            options: ["2", "3", "4", "5"],
            correctAnswer: "3",
            explanation: "Number of piers required for a column is 3."
          },
          {
            id: 22,
            question: "Dynamic cone depth up to 3 is ___.",
            options: ["BNc", "BNc/2", "BNc/3.5", "BNc/5"],
            correctAnswer: "BNc/3.5",
            explanation: "Dynamic cone depth up to 3 is BNc/3.5."
          }
        ]
      },
      {
        id: 6,
        title: "Bearing capacity and foundation settlements",
        description: "Bearing capacity (types, effects of various factors); modes of foundation failure; Terzaghi's general bearing capacity theory; ultimate bearing capacity of cohesion-less and cohesive soils; consolidation (concept, types and tests); settlement (types, nature, effects and calculations).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Consolidation settlement occurs due to expulsion of ___.",
            options: ["Air from voids", "Water voids", "Solids", "Organic matter"],
            correctAnswer: "Water voids",
            explanation: "Consolidation settlement occurs due to expulsion of Water voids."
          },
          {
            id: 2,
            question: "The Oedometer is used for ___.",
            options: ["Shear strength", "Permeability", "Consolidation", "Compaction"],
            correctAnswer: "Consolidation",
            explanation: "The Oedometer is used for Consolidation."
          },
          {
            id: 3,
            question: "In plate load test, the ultimate bearing capacity of clayey foundation is calculated as ___.",
            options: ["Qu(f) = Qu(p) x Bf/Bp", "Qu(f) = Qu(p) x (Bf/Bp)²", "Qu(f) = Qu(p)", "Qu(f) = Qu(p) x Bp/Bf"],
            correctAnswer: "Qu(f) = Qu(p)",
            explanation: "In plate load test, the ultimate bearing capacity of clayey foundation is calculated as Qu(f) = Qu(p)."
          },
          {
            id: 4,
            question: "As per IS code, the maximum permissible settlement for isolated foundation on sand is ___ mm.",
            options: ["25", "40", "50", "75"],
            correctAnswer: "40",
            explanation: "As per IS code, the maximum permissible settlement for isolated foundation on sand is 40 mm."
          },
          {
            id: 5,
            question: "Bearing capacity of square footing is ___.",
            options: ["Qu = cNc + γDNq + 0.5γBNγ", "Qu = 1.3cNc + γDNq + 0.4γBNγ", "Qu = 1.5cNc + γDNq + 0.3γBNγ", "Qu = 1.2cNc + γDNq + 0.6γBNγ"],
            correctAnswer: "Qu = 1.3cNc + γDNq + 0.4γBNγ",
            explanation: "Bearing capacity of square footing is Qu = 1.3cNc + γDNq + 0.4γBNγ."
          },
          {
            id: 6,
            question: "For purely cohesive soil, the bearing capacity is ___.",
            options: ["Qf = cNc", "Qf = 5.7c + σ̅", "Qf = 5.7c", "Qf = γDNq"],
            correctAnswer: "Qf = 5.7c + σ̅",
            explanation: "For purely cohesive soil, the bearing capacity is Qf = 5.7c + σ̅."
          },
          {
            id: 7,
            question: "Bearing capacity of circular footing is calculated as ___.",
            options: ["Qu = cNc + γDNq + 0.5γBNγ", "Qu = 1.2cNc + γDNq + 0.6γBNγ", "Qu = 1.3cNc + γDNq + 0.3γNγ", "Qu = 1.5cNc + γDNq"],
            correctAnswer: "Qu = 1.3cNc + γDNq + 0.3γNγ",
            explanation: "Bearing capacity of circular footing is calculated as Qu = 1.3cNc + γDNq + 0.3γNγ."
          },
          {
            id: 8,
            question: "The angle between a principal plane and plane of maximum shear is ___.",
            options: ["30° & 90°", "45° & 135°", "60° & 120°", "90° & 180°"],
            correctAnswer: "45° & 135°",
            explanation: "The angle between a principal plane and plane of maximum shear is 45° & 135°."
          },
          {
            id: 9,
            question: "Terzaghi's ultimate bearing capacity formula of rectangular footing is ___.",
            options: ["Qu = cNc + γDNq + 0.5BγNγ", "Qu = (1+0.3B/L)cNc + γDNq + 0.5(1-0.2B/L)BγNγ", "Qu = 1.3cNc + γDNq + 0.4γBNγ", "Qu = cNc + γDNq"],
            correctAnswer: "Qu = (1+0.3B/L)cNc + γDNq + 0.5(1-0.2B/L)BγNγ",
            explanation: "Terzaghi's ultimate bearing capacity formula of rectangular footing is Qu = (1+0.3B/L)cNc + γDNq + 0.5(1-0.2B/L)BγNγ."
          },
          {
            id: 10,
            question: "In plate load test, the ultimate bearing capacity for foundation in cohesionless soil is ___.",
            options: ["Qu(f) = qu(p)", "Qu(f) = qu(p) x Bf/Bp", "Qu(f) = qu(p) x (Bf/Bp)²", "Qu(f) = qu(p) x Bp/Bf"],
            correctAnswer: "Qu(f) = qu(p) x Bf/Bp",
            explanation: "In plate load test, the ultimate bearing capacity for foundation in cohesionless soil is Qu(f) = qu(p) x Bf/Bp."
          },
          {
            id: 11,
            question: "Gross area of footing depends on load from superstructure, bearing capacity of soil and ___.",
            options: ["Depth of foundation", "Type of soil", "Groundwater level", "Size of column"],
            correctAnswer: "Type of soil",
            explanation: "Gross area of footing depends on load from superstructure, bearing capacity of soil and Type of soil."
          },
          {
            id: 12,
            question: "As per IS code, maximum permissible settlement for isolated foundation on sand is ___ mm.",
            options: ["25", "40", "50", "75"],
            correctAnswer: "40",
            explanation: "As per IS code, maximum permissible settlement for isolated foundation on sand is 40 mm."
          },
          {
            id: 13,
            question: "For purely cohesive soil, bearing capacity is qf = ___.",
            options: ["5.7c", "5.7c + σ̄", "CNc + γDNq", "1.3cNc"],
            correctAnswer: "5.7c + σ̄",
            explanation: "For purely cohesive soil, bearing capacity is qf = 5.7c + σ̄."
          },
          {
            id: 14,
            question: "Soft rock bearing capacity is ___ KN/m².",
            options: ["220", "330", "440", "550"],
            correctAnswer: "440",
            explanation: "Soft rock bearing capacity is 440 KN/m²."
          },
          {
            id: 15,
            question: "Bearing capacity of square footing is Qu = ___.",
            options: ["CNc + γDNq + 0.5γBNγ", "1.3cNc + γDNq + 0.4γBNγ", "1.3cNc + γDNq + 0.3γBNγ", "CNc + γDNq + γBNγ"],
            correctAnswer: "1.3cNc + γDNq + 0.4γBNγ",
            explanation: "Bearing capacity of square footing is Qu = 1.3cNc + γDNq + 0.4γBNγ."
          },
          {
            id: 16,
            question: "Bearing capacity formula for cohesionless soil from plate load test is ___.",
            options: ["Qu(p)", "Qu(p)×(Bf/Bp)", "Qu(p)×Bf/Bp", "Qu(p)×(Bp/Bf)"],
            correctAnswer: "Qu(p)×Bf/Bp",
            explanation: "Bearing capacity formula for cohesionless soil from plate load test is Qu(p)×Bf/Bp."
          },
          {
            id: 17,
            question: "Bearing capacity of soil depends on grain size, size of footing and ___ of footing.",
            options: ["Material", "Color", "Shape", "Depth"],
            correctAnswer: "Shape",
            explanation: "Bearing capacity of soil depends on grain size, size of footing and Shape of footing."
          },
          {
            id: 18,
            question: "Bearing capacity of circular footing is Qu = ___.",
            options: ["CNc+γDNq+0.5γBNγ", "1.3cNc+γDNq+0.4γBNγ", "1.3cNc+γDNq+0.3γNγ", "CNc+γDNq+0.3γBNγ"],
            correctAnswer: "1.3cNc+γDNq+0.3γNγ",
            explanation: "Bearing capacity of circular footing is Qu = 1.3cNc+γDNq+0.3γNγ."
          },
          {
            id: 19,
            question: "Allowable bearing pressure depends on net safe bearing capacity and ___.",
            options: ["Type of soil", "Net safe settlement pressure", "Footing dimensions", "Column load"],
            correctAnswer: "Net safe settlement pressure",
            explanation: "Allowable bearing pressure depends on net safe bearing capacity and Net safe settlement pressure."
          },
          {
            id: 20,
            question: "The angle between a principal plane and plane of maximum shear is ___ & 135°.",
            options: ["30°", "45°", "60°", "90°"],
            correctAnswer: "45°",
            explanation: "The angle between a principal plane and plane of maximum shear is 45° & 135°."
          },
          {
            id: 21,
            question: "Terzaghi's ultimate bearing capacity formula for rectangular footing is qu = ___.",
            options: ["CNc + γDNq + 0.5γBNγ", "(1+0.3B/L)cNc + γDNq + 0.5(1-0.2B/L)BγNγ", "1.3cNc + γDNq + 0.4γBNγ", "(1+0.2B/L)cNc + γDNq + 0.5BγNγ"],
            correctAnswer: "(1+0.3B/L)cNc + γDNq + 0.5(1-0.2B/L)BγNγ",
            explanation: "Terzaghi's ultimate bearing capacity formula for rectangular footing is qu = (1+0.3B/L)cNc + γDNq + 0.5(1-0.2B/L)BγNγ."
          },
          {
            id: 22,
            question: "For liquids, capillary rise with increase in temperature will ___.",
            options: ["Increase", "Decrease", "Remain same", "Fluctuate"],
            correctAnswer: "Decrease",
            explanation: "For liquids, capillary rise with increase in temperature will Decrease."
          },
          {
            id: 23,
            question: "The viscosity of liquid ___ with increase in temperature.",
            options: ["Increases", "Decreases", "Remains same", "Doubles"],
            correctAnswer: "Decreases",
            explanation: "The viscosity of liquid Decreases with increase in temperature."
          },
          {
            id: 24,
            question: "The incompressibility condition in Navier-Stokes equation is ___.",
            options: ["∇×u=0", "∇.u=0", "∇²u=0", "∂u/∂t=0"],
            correctAnswer: "∇.u=0",
            explanation: "The incompressibility condition in Navier-Stokes equation is ∇.u=0."
          },
          {
            id: 25,
            question: "Momentum principle is NOT applicable to ___.",
            options: ["Pipe flow", "Open channel", "Venturi meter", "Turbines"],
            correctAnswer: "Venturi meter",
            explanation: "Momentum principle is NOT applicable to Venturi meter."
          },
          {
            id: 26,
            question: "The difference between total headline and hydraulic grade line represents ___.",
            options: ["Pressure head", "Elevation head", "Velocity head", "Datum head"],
            correctAnswer: "Velocity head",
            explanation: "The difference between total headline and hydraulic grade line represents Velocity head."
          },
          {
            id: 27,
            question: "Frictional resistance for fluids in motion is proportional to velocity in ___ flow.",
            options: ["Turbulent", "Transitional", "Laminar", "Compressible"],
            correctAnswer: "Laminar",
            explanation: "Frictional resistance for fluids in motion is proportional to velocity in Laminar flow."
          }
        ]
      }
    ]
  },
  {
    id: 3,
    title: "Basic Water Resources Engineering",
    code: "ACiE03",
    topics: [
      {
        id: 1,
        title: "Fluids and their properties",
        description: "Types of fluids; fluid properties (mass density, specific weight, specific gravity, specific volume, viscosity, compressibility, capillarity, surface tension, cavitation and vapour pressure.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Maximum density of water is at ___ degree Celsius.",
            options: ["0", "2", "4", "100"],
            correctAnswer: "4",
            explanation: "Maximum density of water is at 4 degree Celsius."
          },
          {
            id: 2,
            question: "A non-Newtonian fluid is one which ___ Newton's law of viscosity.",
            options: ["Follows", "Obeys", "Doesn't follow", "Partially follows"],
            correctAnswer: "Doesn't follow",
            explanation: "A non-Newtonian fluid is one which Doesn't follow Newton's law of viscosity."
          },
          {
            id: 3,
            question: "The spherical shape of water drops is due to its property of ___.",
            options: ["Viscosity", "Cohesion", "Surface tension", "Adhesion"],
            correctAnswer: "Surface tension",
            explanation: "The spherical shape of water drops is due to its property of Surface tension."
          },
          {
            id: 4,
            question: "The term for the sheet of water flowing over a weir is ___.",
            options: ["Surge", "Nappe", "Jump", "Flow"],
            correctAnswer: "Nappe",
            explanation: "The term for the sheet of water flowing over a weir is Nappe."
          },
          {
            id: 5,
            question: "When three pipes are connected in series, ___ is the same through each pipe.",
            options: ["Velocity", "Pressure", "Discharge", "Head loss"],
            correctAnswer: "Discharge",
            explanation: "When three pipes are connected in series, Discharge is the same through each pipe."
          },
          {
            id: 6,
            question: "Condition for supercritical flow is Fr ___.",
            options: ["= 1", "< 1", "> 1", "= 0"],
            correctAnswer: "> 1",
            explanation: "Condition for supercritical flow is Fr > 1."
          },
          {
            id: 7,
            question: "The branch of science which deals with the occurrence, circulation and distribution of waters of the earth is ___.",
            options: ["Hydrology", "Hydrogeology", "Oceanography", "Limnology"],
            correctAnswer: "Hydrology",
            explanation: "The branch of science which deals with the occurrence, circulation and distribution of waters of the earth is Hydrology."
          },
          {
            id: 8,
            question: "Discharge-stage relationship is known as ___ curve.",
            options: ["Flow duration", "Mass", "Rating", "Recession"],
            correctAnswer: "Rating",
            explanation: "Discharge-stage relationship is known as Rating curve."
          },
          {
            id: 9,
            question: "When the slope changes from a mild slope to a steep slope, ___ profile is formed.",
            options: ["M1S1", "M2S2", "M3S3", "M1S2"],
            correctAnswer: "M2S2",
            explanation: "When the slope changes from a mild slope to a steep slope, M2S2 profile is formed."
          },
          {
            id: 10,
            question: "The hydraulic radius for a wide rectangular channel section is ___.",
            options: ["B/2", "Y/2", "Y", "B"],
            correctAnswer: "Y",
            explanation: "The hydraulic radius for a wide rectangular channel section is Y."
          },
          {
            id: 11,
            question: "In case of most economical trapezoidal section, top width equals ___.",
            options: ["Base width", "Depth", "Sum of side slope", "Half perimeter"],
            correctAnswer: "Sum of side slope",
            explanation: "In case of most economical trapezoidal section, top width equals Sum of side slope."
          },
          {
            id: 12,
            question: "The form factor of a channel section is given by multiplying the square root of hydraulic depth and basin ___.",
            options: ["Perimeter", "Depth", "Area", "Width"],
            correctAnswer: "Area",
            explanation: "The form factor of a channel section is given by multiplying the square root of hydraulic depth and basin Area."
          },
          {
            id: 13,
            question: "The loss of head at pipe fitting of 90° elbow is given by ___.",
            options: ["0.5 V²/2g", "0.7 V²/2g", "0.9 V²/2g", "1.2 V²/2g"],
            correctAnswer: "0.9 V²/2g",
            explanation: "The loss of head at pipe fitting of 90° elbow is given by 0.9 V²/2g."
          },
          {
            id: 14,
            question: "The piezometric head for the static fluid ___.",
            options: ["Increases with depth", "Decreases with depth", "Remains constant at all points in the liquid", "Varies with velocity"],
            correctAnswer: "Remains constant at all points in the liquid",
            explanation: "The piezometric head for the static fluid Remains constant at all points in the liquid."
          },
          {
            id: 15,
            question: "Prandtl mixing length is ___ at the pipe wall.",
            options: ["Maximum", "Minimum", "Zero", "Infinite"],
            correctAnswer: "Zero",
            explanation: "Prandtl mixing length is Zero at the pipe wall."
          },
          {
            id: 16,
            question: "The frictional resistance for fluids in motion is proportional to the velocity in ___ flow.",
            options: ["Turbulent", "Supercritical", "Laminar", "Critical"],
            correctAnswer: "Laminar",
            explanation: "The frictional resistance for fluids in motion is proportional to the velocity in Laminar flow."
          },
          {
            id: 17,
            question: "The coefficient of friction for laminar flow is ___.",
            options: ["64/Re", "16/Re", "32/Re", "8/Re"],
            correctAnswer: "16/Re",
            explanation: "The coefficient of friction for laminar flow is 16/Re."
          },
          {
            id: 18,
            question: "Isohytes are the imaginary lines joining the points of equal ___.",
            options: ["Temperature", "Pressure", "Rainfall", "Elevation"],
            correctAnswer: "Rainfall",
            explanation: "Isohytes are the imaginary lines joining the points of equal Rainfall."
          },
          {
            id: 19,
            question: "The value of Hydraulic radius in most economical triangular channel section is ___.",
            options: ["Y/2", "Y/√2", "Y/2√2", "Y/4"],
            correctAnswer: "Y/2√2",
            explanation: "The value of Hydraulic radius in most economical triangular channel section is Y/2√2."
          },
          {
            id: 20,
            question: "The formula of sequent depth is ___.",
            options: ["Y2/y1 = 0.5{√(8Fr²+1)-1}", "Y2/y1 = √(2Fr)", "Y2/y1 = Fr²", "Y2/y1 = 2Fr-1"],
            correctAnswer: "Y2/y1 = 0.5{√(8Fr²+1)-1}",
            explanation: "The formula of sequent depth is Y2/y1 = 0.5{√(8Fr²+1)-1}."
          },
          {
            id: 21,
            question: "The construction of impounding reservoir is required when the rate of flow in the stream, in dry season is ___ the demand.",
            options: ["Equal to", "More than", "Less than", "Proportional to"],
            correctAnswer: "Less than",
            explanation: "The construction of impounding reservoir is required when the rate of flow in the stream, in dry season is Less than the demand."
          },
          {
            id: 22,
            question: "In critical flow, Q²T/gA³ = ___.",
            options: ["0", "0.5", "1", "2"],
            correctAnswer: "1",
            explanation: "In critical flow, Q²T/gA³ = 1."
          },
          {
            id: 23,
            question: "The kinematic similarity between model and prototype is similarity of ___.",
            options: ["Force pattern", "Pressure pattern", "Streamline pattern", "Velocity pattern"],
            correctAnswer: "Streamline pattern",
            explanation: "The kinematic similarity between model and prototype is similarity of Streamline pattern."
          },
          {
            id: 24,
            question: "The relation between absolute pressure, atmospheric pressure and gauge pressure is ___.",
            options: ["Pabs = Pgauge – Patm", "Pabs = Pgauge + Patm", "Pabs = Pgauge × Patm", "Pabs = Pgauge / Patm"],
            correctAnswer: "Pabs = Pgauge + Patm",
            explanation: "The relation between absolute pressure, atmospheric pressure and gauge pressure is Pabs = Pgauge + Patm."
          },
          {
            id: 25,
            question: "The pressure at a point in a fluid will not be same in all directions when the fluid is ___ and moving.",
            options: ["Ideal", "Compressible", "Viscous", "Non-viscous"],
            correctAnswer: "Viscous",
            explanation: "The pressure at a point in a fluid will not be same in all directions when the fluid is Viscous and moving."
          },
          {
            id: 26,
            question: "The discharge passing over ogee weir is proportional to H ___.",
            options: ["1", "1.5", "2", "2.5"],
            correctAnswer: "1.5",
            explanation: "The discharge passing over ogee weir is proportional to H 1.5."
          },
          {
            id: 27,
            question: "The relationship between time of concentration (Tc), inlet time (Te) and time of travel (Tf) is ___.",
            options: ["Tc = Te – Tf", "Tc = Te × Tf", "Tc = Te + Tf", "Tc = Te / Tf"],
            correctAnswer: "Tc = Te + Tf",
            explanation: "The relationship between time of concentration (Tc), inlet time (Te) and time of travel (Tf) is Tc = Te + Tf."
          },
          {
            id: 28,
            question: "The value of pressure inside a soap bubble having radius R is ___.",
            options: ["T/R", "2T/R", "4T/R", "8T/R"],
            correctAnswer: "4T/R",
            explanation: "The value of pressure inside a soap bubble having radius R is 4T/R."
          },
          {
            id: 29,
            question: "As per geography of Nepal, rivers are classified into ___ groups.",
            options: ["2", "3", "4", "5"],
            correctAnswer: "3",
            explanation: "As per geography of Nepal, rivers are classified into 3 groups."
          },
          {
            id: 30,
            question: "DHM 2004 method gives accurate flow characteristics in context of rivers of ___.",
            options: ["India", "China", "Nepal", "Bangladesh"],
            correctAnswer: "Nepal",
            explanation: "DHM 2004 method gives accurate flow characteristics in context of rivers of Nepal."
          },
          {
            id: 31,
            question: "The difference between the total headline and the hydraulic grade line represents the ___ head.",
            options: ["Pressure", "Potential", "Velocity", "Datum"],
            correctAnswer: "Velocity",
            explanation: "The difference between the total headline and the hydraulic grade line represents the Velocity head."
          },
          {
            id: 32,
            question: "The GM expression for floating bodies is ___.",
            options: ["GM = BG – I/V", "GM = I/V + BG", "GM = I/V – BG", "GM = BG/I"],
            correctAnswer: "GM = I/V – BG",
            explanation: "The GM expression for floating bodies is GM = I/V – BG."
          },
          {
            id: 33,
            question: "The rise of a liquid in a capillary tube depends on the ___ of the tube.",
            options: ["Outer diameter", "Wall thickness", "Inner radius", "Material"],
            correctAnswer: "Inner radius",
            explanation: "The rise of a liquid in a capillary tube depends on the Inner radius of the tube."
          },
          {
            id: 34,
            question: "Two capillary tubes P and Q are dipped in water. Height in P is 2/3 of height in Q. The ratio of their diameters is ___.",
            options: ["2:3", "3:2", "1:2", "2:1"],
            correctAnswer: "3:2",
            explanation: "Two capillary tubes P and Q are dipped in water. Height in P is 2/3 of height in Q. The ratio of their diameters is 3:2."
          },
          {
            id: 35,
            question: "For liquids, capillary rise (or fall) will ___ with rise in temperature.",
            options: ["Increase", "Decrease", "Remain same", "Fluctuate"],
            correctAnswer: "Decrease",
            explanation: "For liquids, capillary rise (or fall) will Decrease with rise in temperature."
          },
          {
            id: 36,
            question: "Match: A. Capillarity B. Vapor pressure C. Viscosity D. Specific gravity correspond respectively to ___.",
            options: ["Surface tension, cavitation, shear forces, density of water", "Cavitation, surface tension, density, shear forces", "Shear forces, density, cavitation, surface tension", "Density, shear forces, surface tension, cavitation"],
            correctAnswer: "Surface tension, cavitation, shear forces, density of water",
            explanation: "Match: A. Capillarity B. Vapor pressure C. Viscosity D. Specific gravity correspond respectively to Surface tension, cavitation, shear forces, density of water."
          },
          {
            id: 37,
            question: "A non-Newtonian fluid is one which ___.",
            options: ["Follows Newton's law of viscosity", "Doesn't follow Newton's law of viscosity", "Is always gas", "Has zero viscosity"],
            correctAnswer: "Doesn't follow Newton's law of viscosity",
            explanation: "A non-Newtonian fluid is one which Doesn't follow Newton's law of viscosity."
          },
          {
            id: 38,
            question: "Which of the following is an example of a non-Newtonian fluid?",
            options: ["Water", "Air", "Peanut butter", "Mercury"],
            correctAnswer: "Peanut butter",
            explanation: "Peanut butter is the correct answer."
          },
          {
            id: 39,
            question: "If critical shear stress of a channel is Tc, average shear stress required to move grain on bank is ___.",
            options: ["Tc", "0.5Tc", "0.75Tc", "1.25Tc"],
            correctAnswer: "0.75Tc",
            explanation: "If critical shear stress of a channel is Tc, average shear stress required to move grain on bank is 0.75Tc."
          },
          {
            id: 40,
            question: "Pressure at a point in a fluid will NOT be the same in all directions when the fluid is ___.",
            options: ["Static and at rest", "Incompressible", "Viscous and moving", "Ideal"],
            correctAnswer: "Viscous and moving",
            explanation: "Pressure at a point in a fluid will NOT be the same in all directions when the fluid is Viscous and moving."
          },
          {
            id: 41,
            question: "The piezometric head for a static fluid ___ at all points in the liquid.",
            options: ["Varies", "Remains constant", "Increases", "Decreases"],
            correctAnswer: "Remains constant",
            explanation: "The piezometric head for a static fluid Remains constant at all points in the liquid."
          },
          {
            id: 42,
            question: "The difference between total headline and hydraulic grade line represents the ___ head.",
            options: ["Pressure", "Elevation", "Velocity", "Datum"],
            correctAnswer: "Velocity",
            explanation: "The difference between total headline and hydraulic grade line represents the Velocity head."
          },
          {
            id: 43,
            question: "If area changes from A1 to A2 and velocity from V1 to V2, A1×V1=A2×V2 is called equation of ___.",
            options: ["Momentum", "Energy", "Continuity", "Bernoulli"],
            correctAnswer: "Continuity",
            explanation: "If area changes from A1 to A2 and velocity from V1 to V2, A1×V1=A2×V2 is called equation of Continuity."
          },
          {
            id: 44,
            question: "Fluids which undergo strain rates proportional to applied shear stress are termed ___ fluid.",
            options: ["Ideal", "Non-Newtonian", "Newtonian", "Bingham plastic"],
            correctAnswer: "Newtonian",
            explanation: "Fluids which undergo strain rates proportional to applied shear stress are termed Newtonian fluid."
          },
          {
            id: 45,
            question: "When slope changes from mild to steep, ___ profile is formed.",
            options: ["M1S1", "M2S2", "M3S3", "M1S2"],
            correctAnswer: "M2S2",
            explanation: "When slope changes from mild to steep, M2S2 profile is formed."
          },
          {
            id: 46,
            question: "Hydraulic radius in most economical triangular channel section is ___.",
            options: ["Y/√2", "Y/2√2", "Y/2", "Y√2"],
            correctAnswer: "Y/2√2",
            explanation: "Hydraulic radius in most economical triangular channel section is Y/2√2."
          },
          {
            id: 47,
            question: "Weighted perimeter for trapezoidal section with z, y, B is ___.",
            options: ["B + 2yz", "B + 2y√(1+z²)", "B + z√(y²+1)", "2B + yz"],
            correctAnswer: "B + 2y√(1+z²)",
            explanation: "Weighted perimeter for trapezoidal section with z, y, B is B + 2y√(1+z²)."
          },
          {
            id: 48,
            question: "In most economical trapezoidal section, top width equals ___.",
            options: ["Bottom width", "Sum of side slopes", "Twice bottom width", "Half the perimeter"],
            correctAnswer: "Sum of side slopes",
            explanation: "In most economical trapezoidal section, top width equals Sum of side slopes."
          },
          {
            id: 49,
            question: "Discharge over ogee weir is proportional to H ___.",
            options: ["1", "3/2", "2", "5/2"],
            correctAnswer: "3/2",
            explanation: "Discharge over ogee weir is proportional to H 3/2."
          },
          {
            id: 50,
            question: "The branch of science dealing with occurrence, circulation and distribution of waters of earth is ___.",
            options: ["Hydrology", "Hydraulics", "Limnology", "Oceanography"],
            correctAnswer: "Hydrology",
            explanation: "The branch of science dealing with occurrence, circulation and distribution of waters of earth is Hydrology."
          },
          {
            id: 51,
            question: "Isohytes are imaginary lines joining points of equal ___.",
            options: ["Temperature", "Pressure", "Rainfall", "Elevation"],
            correctAnswer: "Rainfall",
            explanation: "Isohytes are imaginary lines joining points of equal Rainfall."
          },
          {
            id: 52,
            question: "___ method gives accurate flow characteristics in the context of rivers of Nepal.",
            options: ["SCS", "DHM 2004", "Rational", "Unit hydrograph"],
            correctAnswer: "DHM 2004",
            explanation: "DHM 2004 method gives accurate flow characteristics in the context of rivers of Nepal."
          },
          {
            id: 53,
            question: "Recording type method is ___ accurate for rain gauging.",
            options: ["Least", "Moderately", "Very", "Equally"],
            correctAnswer: "Very",
            explanation: "Recording type method is Very accurate for rain gauging."
          },
          {
            id: 54,
            question: "Form factor of a channel section is given by multiplying square root of hydraulic depth and ___.",
            options: ["Length", "Width", "Perimeter", "Basin area"],
            correctAnswer: "Basin area",
            explanation: "Form factor of a channel section is given by multiplying square root of hydraulic depth and Basin area."
          },
          {
            id: 55,
            question: "When a block of ice floating on water melts, water level in the container ___.",
            options: ["Rises", "Falls", "Remains the same", "First rises then falls"],
            correctAnswer: "Remains the same",
            explanation: "When a block of ice floating on water melts, water level in the container Remains the same."
          },
          {
            id: 56,
            question: "The instrument used to measure gas pressure on a pipe is ___.",
            options: ["Bourdon gauge", "Piezometer", "U-tube manometer", "Venturi meter"],
            correctAnswer: "U-tube manometer",
            explanation: "The instrument used to measure gas pressure on a pipe is U-tube manometer."
          },
          {
            id: 57,
            question: "Construction of impounding reservoir is required when flow rate in dry season is ___ the demand.",
            options: ["Greater than", "Equal to", "Less than", "Double"],
            correctAnswer: "Less than",
            explanation: "Construction of impounding reservoir is required when flow rate in dry season is Less than the demand."
          }
        ]
      },
      {
        id: 2,
        title: "Hydrostatics",
        description: "Pressure and head; Pascal's law; pressure-depth relationship; manometers; pressure force and centre of pressure on submerged bodies (plane and curved surfaces, practical applications); pressure diagrams; buoyancy; stability of floating/submerged bodies.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Buoyant force is the ___ force on a body due to the fluid surrounding it.",
            options: ["Net upward", "Net downward", "Resultant", "Horizontal"],
            correctAnswer: "Resultant",
            explanation: "Buoyant force is the Resultant force on a body due to the fluid surrounding it."
          },
          {
            id: 2,
            question: "Buoyant force is the resultant force on a body due to ___.",
            options: ["Gravity", "Its weight", "The fluid surrounding it", "Its density"],
            correctAnswer: "The fluid surrounding it",
            explanation: "Buoyant force is the resultant force on a body due to The fluid surrounding it."
          },
          {
            id: 3,
            question: "U-tube manometer is used to measure pressure ___ between two points.",
            options: ["Sum", "Difference", "Ratio", "Gradient"],
            correctAnswer: "Difference",
            explanation: "U-tube manometer is used to measure pressure Difference between two points."
          }
        ]
      },
      {
        id: 3,
        title: "Hydro-kinematics and hydro-dynamics",
        description: "Classification of fluid flow; conservation of mass (continuity equation) and momentum equations and their applications; Bernoulli's equation and its application; flow measurement.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The coefficient of discharge for an orifice meter is in the range ___.",
            options: ["0.40 to 0.55", "0.62 to 0.65", "0.70 to 0.80", "0.85 to 0.95"],
            correctAnswer: "0.62 to 0.65",
            explanation: "The coefficient of discharge for an orifice meter is in the range 0.62 to 0.65."
          },
          {
            id: 2,
            question: "Nappe is a sheet of liquid flowing over a notch or a ___.",
            options: ["Dam", "Sluice", "Weir", "Spillway"],
            correctAnswer: "Weir",
            explanation: "Nappe is a sheet of liquid flowing over a notch or a Weir."
          },
          {
            id: 3,
            question: "The Bernoulli equation states energy is ___ for one streamline.",
            options: ["Variable", "Constant", "Zero", "Infinite"],
            correctAnswer: "Constant",
            explanation: "The Bernoulli equation states energy is Constant for one streamline."
          },
          {
            id: 4,
            question: "Coefficient of discharge for an orifice meter is in the range ___.",
            options: ["0.45 to 0.55", "0.62 to 0.65", "0.80 to 0.85", "0.95 to 0.99"],
            correctAnswer: "0.62 to 0.65",
            explanation: "Coefficient of discharge for an orifice meter is in the range 0.62 to 0.65."
          },
          {
            id: 5,
            question: "Water flowing steadily in a constant cross-sectional pipe — by Bernoulli's principle, pressure ___ with height.",
            options: ["Decreases", "Remains constant", "Increases", "Fluctuates"],
            correctAnswer: "Increases",
            explanation: "Water flowing steadily in a constant cross-sectional pipe — by Bernoulli's principle, pressure Increases with height."
          },
          {
            id: 6,
            question: "Pitot-Static tube measures ___ at a point of fluid in a stream.",
            options: ["Pressure", "Depth", "Velocity", "Discharge"],
            correctAnswer: "Velocity",
            explanation: "Pitot-Static tube measures Velocity at a point of fluid in a stream."
          },
          {
            id: 7,
            question: "The continuity equation is valid for a steady, 2D, ___ flow.",
            options: ["Compressible", "Viscous", "Turbulent", "Incompressible"],
            correctAnswer: "Incompressible",
            explanation: "The continuity equation is valid for a steady, 2D, Incompressible flow."
          }
        ]
      },
      {
        id: 4,
        title: "Pipe flow",
        description: "Types, governing equations, major and minor head losses; HGL and TEL lines; design; pipe network problems; unsteady flow in pipes and relief devices.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The hydraulic grade line HGL in pipe flow is always ___ the centre line of pipe.",
            options: ["Below", "At", "Above", "Parallel to"],
            correctAnswer: "Above",
            explanation: "The hydraulic grade line HGL in pipe flow is always Above the centre line of pipe."
          },
          {
            id: 2,
            question: "The head loss at the exit of the pipe is ___.",
            options: ["0.5v²/2g", "V²/g", "V²/2g", "2v²/2g"],
            correctAnswer: "V²/2g",
            explanation: "The head loss at the exit of the pipe is V²/2g."
          },
          {
            id: 3,
            question: "The Darcy-Weisbach formula for head loss (hf) due to friction is given by ___.",
            options: ["Flv²/2gd", "Flv/gd", "Flv²/gd", "Fv²/2gd"],
            correctAnswer: "Flv²/2gd",
            explanation: "The Darcy-Weisbach formula for head loss (hf) due to friction is given by Flv²/2gd."
          },
          {
            id: 4,
            question: "The Darcy-Weisbach head loss formula h = flQ²/12.1D⁵ is given by ___.",
            options: ["Chezy", "Manning", "Darcy-Weisbach", "Hazen-Williams"],
            correctAnswer: "Darcy-Weisbach",
            explanation: "The Darcy-Weisbach head loss formula h = flQ²/12.1D⁵ is given by Darcy-Weisbach."
          },
          {
            id: 5,
            question: "Head loss will be small in case of ___ crested weir.",
            options: ["Sharp", "Broad", "Ogee", "Round"],
            correctAnswer: "Broad",
            explanation: "Head loss will be small in case of Broad crested weir."
          },
          {
            id: 6,
            question: "Darcy-Weisbach formula for head loss (hf) due to friction is given by ___.",
            options: ["Flv/2gd", "Flv²/2gd", "Flv²/gd", "Fv²/2gd"],
            correctAnswer: "Flv²/2gd",
            explanation: "Darcy-Weisbach formula for head loss (hf) due to friction is given by Flv²/2gd."
          },
          {
            id: 7,
            question: "Head loss will be small in case of ___ weir.",
            options: ["Sharp crested", "Broad crested", "Ogee", "Triangular"],
            correctAnswer: "Broad crested",
            explanation: "Head loss will be small in case of Broad crested weir."
          },
          {
            id: 8,
            question: "The head loss is minimum in ___ weir.",
            options: ["Sharp crested", "Ogee", "Broad crested", "Triangular"],
            correctAnswer: "Broad crested",
            explanation: "The head loss is minimum in Broad crested weir."
          },
          {
            id: 9,
            question: "Head loss at pipe fitting of 90° elbow is ___.",
            options: ["0.5V²/2g", "0.7V²/2g", "0.9V²/2g", "1.2V²/2g"],
            correctAnswer: "0.9V²/2g",
            explanation: "Head loss at pipe fitting of 90° elbow is 0.9V²/2g."
          },
          {
            id: 10,
            question: "Head loss at the exit of the pipe is ___.",
            options: ["V²/4g", "V²/2g", "V²/g", "2V²/g"],
            correctAnswer: "V²/2g",
            explanation: "Head loss at the exit of the pipe is V²/2g."
          }
        ]
      },
      {
        id: 5,
        title: "Open channel flow",
        description: "Geometrical properties; various types of flows; energy and momentum principles (Specific Energy and Specific Force); Types of gradually varied flow profiles; hydraulic jump (types, theory for horizontal and rectangular) flow in mobile boundary channel (design principles/approaches; inception motion condition; Shield diagram).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Froude number for steady jump is ___.",
            options: ["1.0–1.7", "1.7–2.5", "4.5–9", "Greater than 9"],
            correctAnswer: "4.5–9",
            explanation: "Froude number for steady jump is 4.5–9."
          },
          {
            id: 2,
            question: "In case of open channel flow, at critical depth, the discharge is ___ for a given specific energy.",
            options: ["Minimum", "Zero", "Maximum", "Variable"],
            correctAnswer: "Maximum",
            explanation: "In case of open channel flow, at critical depth, the discharge is Maximum for a given specific energy."
          },
          {
            id: 3,
            question: "At critical depth of flow of water in open channels, the specific energy is ___.",
            options: ["Maximum", "Zero", "Minimum", "Constant"],
            correctAnswer: "Minimum",
            explanation: "At critical depth of flow of water in open channels, the specific energy is Minimum."
          },
          {
            id: 4,
            question: "The portion between two successive flow lines is known as ___.",
            options: ["Flow tube", "Flow net", "Flow channel", "Stream band"],
            correctAnswer: "Flow channel",
            explanation: "The portion between two successive flow lines is known as Flow channel."
          },
          {
            id: 5,
            question: "If Manning's n is doubled then slope should be changed to ___.",
            options: ["Double", "Triple", "Quadruple", "Half"],
            correctAnswer: "Quadruple",
            explanation: "If Manning's n is doubled then slope should be changed to Quadruple."
          },
          {
            id: 6,
            question: "Length of hydraulic jump is equal to ___ times the jump height.",
            options: ["2–4", "5–7", "8–10", "10–12"],
            correctAnswer: "5–7",
            explanation: "Length of hydraulic jump is equal to 5–7 times the jump height."
          },
          {
            id: 7,
            question: "When the flow in an open channel is gradually varied, the flow is said to be steady ___ flow.",
            options: ["Uniform", "Critical", "Non-uniform", "Subcritical"],
            correctAnswer: "Non-uniform",
            explanation: "When the flow in an open channel is gradually varied, the flow is said to be steady Non-uniform flow."
          },
          {
            id: 8,
            question: "The length parameter in a Froude number indicates ___.",
            options: ["Total depth", "Hydraulic mean depth", "Width", "Wetted perimeter"],
            correctAnswer: "Hydraulic mean depth",
            explanation: "The length parameter in a Froude number indicates Hydraulic mean depth."
          },
          {
            id: 9,
            question: "In open channel flow at critical depth, discharge is ___ for a given specific energy.",
            options: ["Zero", "Minimum", "Maximum", "Constant"],
            correctAnswer: "Maximum",
            explanation: "In open channel flow at critical depth, discharge is Maximum for a given specific energy."
          },
          {
            id: 10,
            question: "At critical depth of flow in open channels, specific energy is ___.",
            options: ["Maximum", "Minimum", "Zero", "Undefined"],
            correctAnswer: "Minimum",
            explanation: "At critical depth of flow in open channels, specific energy is Minimum."
          },
          {
            id: 11,
            question: "Fr value for a steady hydraulic jump is ___.",
            options: ["1.0–1.7", "1.7–2.5", "4.5–9", "9–20"],
            correctAnswer: "4.5–9",
            explanation: "Fr value for a steady hydraulic jump is 4.5–9."
          },
          {
            id: 12,
            question: "If Manning's n is doubled, slope should be changed to ___.",
            options: ["Double", "Triple", "Quadruple", "Halved"],
            correctAnswer: "Quadruple",
            explanation: "If Manning's n is doubled, slope should be changed to Quadruple."
          },
          {
            id: 13,
            question: "In open channel flow, alternate depths are depths occurring at the same ___.",
            options: ["Velocity", "Froude number", "Specific energy", "Discharge"],
            correctAnswer: "Specific energy",
            explanation: "In open channel flow, alternate depths are depths occurring at the same Specific energy."
          },
          {
            id: 14,
            question: "In defining Froude number, the depth parameter used is ___ depth.",
            options: ["Normal", "Critical", "Hydraulic mean", "Conjugate"],
            correctAnswer: "Hydraulic mean",
            explanation: "In defining Froude number, the depth parameter used is Hydraulic mean depth."
          },
          {
            id: 15,
            question: "The portion between two successive flow lines is known as ___ channel.",
            options: ["Stream", "Flow", "Control", "Main"],
            correctAnswer: "Flow",
            explanation: "The portion between two successive flow lines is known as Flow channel."
          },
          {
            id: 16,
            question: "Length of hydraulic jump equals ___ times the jump height.",
            options: ["2–3", "3–5", "5–7", "8–10"],
            correctAnswer: "5–7",
            explanation: "Length of hydraulic jump equals 5–7 times the jump height."
          },
          {
            id: 17,
            question: "Froude number of triangular channel of depth y with side slope 2H:1V is ___.",
            options: ["V/√(gy)", "V/√(g×y/2)", "V/√(2gy)", "V×√(2/gy)"],
            correctAnswer: "V/√(g×y/2)",
            explanation: "Froude number of triangular channel of depth y with side slope 2H:1V is V/√(g×y/2)."
          },
          {
            id: 18,
            question: "When flow in an open channel is gradually varied, flow is said to be steady ___ flow.",
            options: ["Uniform", "Non-uniform", "Critical", "Supercritical"],
            correctAnswer: "Non-uniform",
            explanation: "When flow in an open channel is gradually varied, flow is said to be steady Non-uniform flow."
          },
          {
            id: 19,
            question: "Dimension of Chezy's coefficient C in [MLT] notation is ___.",
            options: ["L^(1/2)T^(-1)", "ML^(-1)T", "M°LT^(-1)", "L^(3/2)T^(-1)"],
            correctAnswer: "L^(1/2)T^(-1)",
            explanation: "Dimension of Chezy's coefficient C in [MLT] notation is L^(1/2)T^(-1)."
          },
          {
            id: 20,
            question: "For a given discharge in an open channel, two depths with the same specific energy are ___ depths.",
            options: ["Critical", "Normal", "Conjugate", "Alternate"],
            correctAnswer: "Alternate",
            explanation: "For a given discharge in an open channel, two depths with the same specific energy are Alternate depths."
          }
        ]
      },
      {
        id: 6,
        title: "Hydrology",
        description: "Hydrologic cycle and water balance components; flow measurement and rating curves; hydrographs analysis and synthetic unit hydrographs; rainfall-runoff analysis; flood hydrology (flood frequency analysis and design flood); groundwater hydrology.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The double mass curve technique is used to ___.",
            options: ["Find average rainfall over years", "Estimate missing rainfall data", "Check the consistency of rain gauge records", "Find minimum number of rain gauges"],
            correctAnswer: "Check the consistency of rain gauge records",
            explanation: "The double mass curve technique is used to Check the consistency of rain gauge records."
          },
          {
            id: 2,
            question: "The most accurate method to determine average precipitation depth over an area is ___.",
            options: ["Arithmetic mean", "Thiessen polygon", "Isohyetal map method", "Grid method"],
            correctAnswer: "Isohyetal map method",
            explanation: "The most accurate method to determine average precipitation depth over an area is Isohyetal map method."
          },
          {
            id: 3,
            question: "Precipitation caused by lifting of an air mass due to the pressure difference is called ___ precipitation.",
            options: ["Orographic", "Convective", "Frontal", "Cyclonic"],
            correctAnswer: "Cyclonic",
            explanation: "Precipitation caused by lifting of an air mass due to the pressure difference is called Cyclonic precipitation."
          },
          {
            id: 4,
            question: "Recession limb of a hydrograph is independent of ___.",
            options: ["Basin characteristics", "Soil characteristics", "Storm characteristics", "Vegetation"],
            correctAnswer: "Storm characteristics",
            explanation: "Recession limb of a hydrograph is independent of Storm characteristics."
          },
          {
            id: 5,
            question: "Ordinate of Unit hydrograph is obtained by dividing ordinate of DRH by ___.",
            options: ["Duration", "Area", "Run off depth", "Base flow"],
            correctAnswer: "Run off depth",
            explanation: "Ordinate of Unit hydrograph is obtained by dividing ordinate of DRH by Run off depth."
          },
          {
            id: 6,
            question: "Rational method is applicable for duration of rainfall ___ time of concentration.",
            options: ["Greater than", "Less than", "Equal to", "Twice the"],
            correctAnswer: "Equal to",
            explanation: "Rational method is applicable for duration of rainfall Equal to time of concentration."
          },
          {
            id: 7,
            question: "The equation of rational formula for flood discharge (m³/s) is ___.",
            options: ["CIA/100", "CIA/36", "CIA", "10CIA"],
            correctAnswer: "CIA/36",
            explanation: "The equation of rational formula for flood discharge (m³/s) is CIA/36."
          },
          {
            id: 8,
            question: "As compared to fan shaped catchment, the fern shaped catchment will have ___ stream.",
            options: ["Shorter", "Same", "Longer", "Meandering"],
            correctAnswer: "Longer",
            explanation: "As compared to fan shaped catchment, the fern shaped catchment will have Longer stream."
          },
          {
            id: 9,
            question: "In WECS/DHM method, the formula used for flood forecasting of return period of 2 years is ___.",
            options: ["1.2456(A3000+1)^0.8783", "1.8767(A3000+1)^0.8783", "2.1234(A3000+1)^0.8783", "1.5678(A3000+1)^0.8783"],
            correctAnswer: "1.8767(A3000+1)^0.8783",
            explanation: "In WECS/DHM method, the formula used for flood forecasting of return period of 2 years is 1.8767(A3000+1)^0.8783."
          },
          {
            id: 10,
            question: "The double mass curve technique is used to check the ___ of rain gauge records.",
            options: ["Accuracy", "Missing data", "Consistency", "Average rainfall"],
            correctAnswer: "Consistency",
            explanation: "The double mass curve technique is used to check the Consistency of rain gauge records."
          },
          {
            id: 11,
            question: "Compared to fan shaped catchment, fern shaped catchment will have ___ stream.",
            options: ["Shorter", "Wider", "Longer", "Deeper"],
            correctAnswer: "Longer",
            explanation: "Compared to fan shaped catchment, fern shaped catchment will have Longer stream."
          },
          {
            id: 12,
            question: "The most accurate method to determine average precipitation depth over an area is ___ method.",
            options: ["Thiessen polygon", "Arithmetic mean", "Isohyetal map", "Station average"],
            correctAnswer: "Isohyetal map",
            explanation: "The most accurate method to determine average precipitation depth over an area is Isohyetal map method."
          },
          {
            id: 13,
            question: "Precipitation caused by lifting of an air mass due to pressure difference is called ___ precipitation.",
            options: ["Orographic", "Convective", "Cyclonic", "Frontal"],
            correctAnswer: "Cyclonic",
            explanation: "Precipitation caused by lifting of an air mass due to pressure difference is called Cyclonic precipitation."
          },
          {
            id: 14,
            question: "Cold frontal precipitation is formed when an advancing cold air mass meets ___.",
            options: ["Cold air", "Warm air", "Humid air", "Dry air"],
            correctAnswer: "Warm air",
            explanation: "Cold frontal precipitation is formed when an advancing cold air mass meets Warm air."
          },
          {
            id: 15,
            question: "Cold frontal precipitation means ___ catchment area with heavy precipitation.",
            options: ["Large", "Medium", "Small", "Negligible"],
            correctAnswer: "Small",
            explanation: "Cold frontal precipitation means Small catchment area with heavy precipitation."
          },
          {
            id: 16,
            question: "Precipitation falling during growing period of a crop that meets evapotranspiration needs is known as ___ rainfall.",
            options: ["Total", "Gross", "Effective", "Net"],
            correctAnswer: "Effective",
            explanation: "Precipitation falling during growing period of a crop that meets evapotranspiration needs is known as Effective rainfall."
          },
          {
            id: 17,
            question: "Rational formula for flood discharge (m³/s) is Q = ___, where A is in hectares.",
            options: ["CIA", "CIA/360", "CIA/36", "CIA×360"],
            correctAnswer: "CIA/36",
            explanation: "Rational formula for flood discharge (m³/s) is Q = CIA/36, where A is in hectares."
          },
          {
            id: 18,
            question: "In WECS/DHM method, flood forecasting for 2-year return period uses formula ___ (A3000+1)^0.8783.",
            options: ["1.2767", "1.5767", "1.8767", "2.1767"],
            correctAnswer: "1.8767",
            explanation: "In WECS/DHM method, flood forecasting for 2-year return period uses formula 1.8767 (A3000+1)^0.8783."
          }
        ]
      }
    ]
  },
  {
    id: 4,
    title: "Structural Mechanics",
    code: "ACiE04",
    topics: [
      {
        id: 1,
        title: "Shear forces and bending moments",
        description: "Axial forces, shear forces, and bending moments; loads and load superposition; relationship and diagram Interpretation (AF, SF, BM).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "A force is completely defined by:",
            options: ["Magnitude only", "Direction only", "Magnitude, direction, and point of application", "Time duration"],
            correctAnswer: "Magnitude, direction, and point of application",
            explanation: "Force is a vector requiring magnitude, direction, and point of application."
          },
          {
            id: 2,
            question: "Resultant of two forces at angle θ is:",
            options: ["F₁ + F₂", "F₁ - F₂", "√(F₁² + F₂² + 2F₁F₂cosθ)", "F₁F₂"],
            correctAnswer: "√(F₁² + F₂² + 2F₁F₂cosθ)",
            explanation: "Resultant R = √(F₁² + F₂² + 2F₁F₂cosθ) by parallelogram law."
          },
          {
            id: 3,
            question: "Moment of a force about a point is:",
            options: ["Force magnitude", "Force × perpendicular distance", "Force × time", "Force / distance"],
            correctAnswer: "Force × perpendicular distance",
            explanation: "Moment M = F × d (force times perpendicular distance from point)."
          },
          {
            id: 4,
            question: "A couple consists of:",
            options: ["Single force", "Two parallel forces of equal magnitude opposite direction", "Two forces at angle", "Distributed force"],
            correctAnswer: "Two parallel forces of equal magnitude opposite direction",
            explanation: "Couple produces rotation without translation; equal opposite parallel forces."
          },
          {
            id: 5,
            question: "For equilibrium, sum of forces should be:",
            options: ["Maximum", "Minimum", "Zero", "Equal to applied force"],
            correctAnswer: "Zero",
            explanation: "Translational equilibrium: ΣF = 0; no acceleration."
          },
          {
            id: 6,
            question: "For rotational equilibrium, sum of moments should be:",
            options: ["Maximum", "Minimum", "Zero", "Equal to torque"],
            correctAnswer: "Zero",
            explanation: "Rotational equilibrium: ΣM = 0; no angular acceleration."
          },
          {
            id: 7,
            question: "Free body diagram shows:",
            options: ["All forces on isolated object", "Only applied forces", "Deformations only", "Stresses only"],
            correctAnswer: "All forces on isolated object",
            explanation: "FBD includes all external forces and moments acting on isolated object."
          },
          {
            id: 8,
            question: "In method of joints, we analyze:",
            options: ["Entire truss", "Each joint individually", "Only external forces", "Stresses in members"],
            correctAnswer: "Each joint individually",
            explanation: "Method of joints isolates each joint and applies equilibrium equations."
          },
          {
            id: 9,
            question: "Method of sections is used to find:",
            options: ["Support reactions", "Forces in specific members", "Deformations", "Material properties"],
            correctAnswer: "Forces in specific members",
            explanation: "Section method cuts through members of interest to find internal forces."
          },
          {
            id: 10,
            question: "Support reactions are found using:",
            options: ["Only FBD", "Conditions of equilibrium", "Material properties", "Strain measurements"],
            correctAnswer: "Conditions of equilibrium",
            explanation: "Reactions determined using ΣF = 0 and ΣM = 0 equations."
          },
          {
            id: 11,
            question: "Bending moment is:",
            options: ["Shear force", "Load on beam", "Internal moment causing bending", "Reaction only"],
            correctAnswer: "Internal moment causing bending",
            explanation: "BM = internal moment that bends the beam; causes curvature."
          },
          {
            id: 12,
            question: "Shear force is:",
            options: ["Bending moment", "Internal force parallel to section", "Reaction only", "Applied load"],
            correctAnswer: "Internal force parallel to section",
            explanation: "SF is internal force parallel to cross-section; resists shear."
          },
          {
            id: 13,
            question: "The relationship dV/dx = -w means:",
            options: ["Load doesn't affect shear", "Shear changes due to distributed load", "Shear is constant", "No connection"],
            correctAnswer: "Shear changes due to distributed load",
            explanation: "Rate of change of SF = -load intensity; load causes SF change."
          },
          {
            id: 14,
            question: "For a cantilever beam with load at free end, maximum BM occurs at:",
            options: ["Free end", "Fixed end", "Mid-span", "Any point"],
            correctAnswer: "Fixed end",
            explanation: "Cantilever: BM is zero at free end and maximum at fixed support."
          },
          {
            id: 15,
            question: "If the shear force along a section of a beam is zero, the bending moment at the section is either ___ or minimum.",
            options: ["Zero", "Negative", "Maximum", "Constant"],
            correctAnswer: "Maximum",
            explanation: "If the shear force along a section of a beam is zero, the bending moment at the section is either Maximum or minimum."
          },
          {
            id: 16,
            question: "Relation between SF and M is S = ___.",
            options: ["M/dx", "DM/dx", "D²M/dx²", "∫M dx"],
            correctAnswer: "DM/dx",
            explanation: "Relation between SF and M is S = DM/dx."
          },
          {
            id: 17,
            question: "Positive bending moment has shape of convex ___.",
            options: ["Upward", "Sideways", "Downward", "Inward"],
            correctAnswer: "Downward",
            explanation: "Positive bending moment has shape of convex Downward."
          },
          {
            id: 18,
            question: "If a simply supported beam carries a UDL across the entire span, then the shear force will change ___.",
            options: ["Parabolically", "Constantly", "Linearly", "Cubically"],
            correctAnswer: "Linearly",
            explanation: "If a simply supported beam carries a UDL across the entire span, then the shear force will change Linearly."
          },
          {
            id: 19,
            question: "If a beam is subjected to a constant bending moment along its length, then the shear force will be ___ at all sections along the beam.",
            options: ["Maximum", "Constant", "Zero", "Minimum"],
            correctAnswer: "Zero",
            explanation: "If a beam is subjected to a constant bending moment along its length, then the shear force will be Zero at all sections along the beam."
          },
          {
            id: 20,
            question: "Relation of E, G and μ is μ = ___.",
            options: ["E/2G", "E/2G-1", "2G/E-1", "G/2E"],
            correctAnswer: "E/2G-1",
            explanation: "Relation of E, G and μ is μ = E/2G-1."
          },
          {
            id: 21,
            question: "The maximum shear stress is ___ times the average shear stress for rectangular beams.",
            options: ["1.0", "1.25", "1.5", "2.0"],
            correctAnswer: "1.5",
            explanation: "The maximum shear stress is 1.5 times the average shear stress for rectangular beams."
          },
          {
            id: 22,
            question: "Creep is the gradual increase of plastic strain with time at ___ load.",
            options: ["Increasing", "Decreasing", "Variable", "Constant"],
            correctAnswer: "Constant",
            explanation: "Creep is the gradual increase of plastic strain with time at Constant load."
          },
          {
            id: 23,
            question: "The bending moment at end supports of a simply supported beam is ___.",
            options: ["Maximum", "Minimum", "Zero", "Equal to WL/8"],
            correctAnswer: "Zero",
            explanation: "The bending moment at end supports of a simply supported beam is Zero."
          },
          {
            id: 24,
            question: "The stiffness of a member if the farther end is hinged is ___.",
            options: ["4EI/L", "3EI/L", "2EI/L", "EI/L"],
            correctAnswer: "3EI/L",
            explanation: "The stiffness of a member if the farther end is hinged is 3EI/L."
          },
          {
            id: 25,
            question: "The maximum bending moment due to a train of wheel loads on a simply supported girder always occurs under a ___ load.",
            options: ["Distributed", "Uniform", "Wheel", "Triangular"],
            correctAnswer: "Wheel",
            explanation: "The maximum bending moment due to a train of wheel loads on a simply supported girder always occurs under a Wheel load."
          },
          {
            id: 26,
            question: "The ratio of linear stress to linear strain is called modulus of ___.",
            options: ["Rigidity", "Resilience", "Elasticity", "Rupture"],
            correctAnswer: "Elasticity",
            explanation: "The ratio of linear stress to linear strain is called modulus of Elasticity."
          },
          {
            id: 27,
            question: "For RCC structure, the shape of shear stress diagram is ___ above neutral axis and rectangular below neutral axis.",
            options: ["Triangular", "Linear", "Parabolic", "Uniform"],
            correctAnswer: "Parabolic",
            explanation: "For RCC structure, the shape of shear stress diagram is Parabolic above neutral axis and rectangular below neutral axis."
          },
          {
            id: 28,
            question: "The horizontal thrust in a two hinged semi-circular arch subjected to UDL of w kN/m over left half span will be ___.",
            options: ["WR/π", "2wR/3π", "WR/2π", "4wR/3π"],
            correctAnswer: "2wR/3π",
            explanation: "The horizontal thrust in a two hinged semi-circular arch subjected to UDL of w kN/m over left half span will be 2wR/3π."
          },
          {
            id: 29,
            question: "The maximum compressive strain in concrete in case of bending compression is taken as ___.",
            options: ["0.002", "0.0025", "0.0035", "0.004"],
            correctAnswer: "0.0035",
            explanation: "The maximum compressive strain in concrete in case of bending compression is taken as 0.0035."
          },
          {
            id: 30,
            question: "The loading rate used in compressive strength test is ___ N/mm² per minute.",
            options: ["7", "10", "14", "20"],
            correctAnswer: "14",
            explanation: "The loading rate used in compressive strength test is 14 N/mm² per minute."
          },
          {
            id: 31,
            question: "Fatigue cracking failure is due to tensile strain ___ surface.",
            options: ["Above", "At", "Below", "On"],
            correctAnswer: "Below",
            explanation: "Fatigue cracking failure is due to tensile strain Below surface."
          },
          {
            id: 32,
            question: "Strain energy in a simply supported beam loaded with point load w at center is ___.",
            options: ["W²l³/48EI", "W²l³/96EI", "W²l³/192EI", "W²l³/24EI"],
            correctAnswer: "W²l³/96EI",
            explanation: "Strain energy in a simply supported beam loaded with point load w at center is W²l³/96EI."
          },
          {
            id: 33,
            question: "The absolute maximum shear force in simply supported beam with UDL is ___.",
            options: ["At center", "At quarter span", "Near support", "At end"],
            correctAnswer: "Near support",
            explanation: "The absolute maximum shear force in simply supported beam with UDL is Near support."
          },
          {
            id: 34,
            question: "The bending moment in an arch is zero when the line of thrust coincides with the line of the ___.",
            options: ["Centroid", "Neutral axis", "Axis", "Soffit"],
            correctAnswer: "Axis",
            explanation: "The bending moment in an arch is zero when the line of thrust coincides with the line of the Axis."
          },
          {
            id: 35,
            question: "The degree of static indeterminacy of propped cantilever beam is ___.",
            options: ["0", "1", "2", "3"],
            correctAnswer: "1",
            explanation: "The degree of static indeterminacy of propped cantilever beam is 1."
          },
          {
            id: 36,
            question: "Stiffness of the end A if the far end B is vertical guided roller is ___.",
            options: ["4EI/L", "3EI/L", "2EI/L", "EI/L"],
            correctAnswer: "EI/L",
            explanation: "Stiffness of the end A if the far end B is vertical guided roller is EI/L."
          },
          {
            id: 37,
            question: "Modulus of rigidity is defined as the ratio of shear stress and shear ___.",
            options: ["Modulus", "Stress", "Strain", "Force"],
            correctAnswer: "Strain",
            explanation: "Modulus of rigidity is defined as the ratio of shear stress and shear Strain."
          },
          {
            id: 38,
            question: "For DPC at plinth level, ___ grade of concrete is used.",
            options: ["M10", "M15", "M20", "M25"],
            correctAnswer: "M15",
            explanation: "For DPC at plinth level, M15 grade of concrete is used."
          },
          {
            id: 39,
            question: "A simply supported beam is subjected to a concentrated load at the midpoint. The shape of BMD is ___.",
            options: ["Parabola", "Rectangle", "Triangle", "Trapezoid"],
            correctAnswer: "Triangle",
            explanation: "A simply supported beam is subjected to a concentrated load at the midpoint. The shape of BMD is Triangle."
          },
          {
            id: 40,
            question: "Maximum BM due to train of wheel loads on simply supported girder always occurs ___.",
            options: ["At midspan", "At quarter point", "Under a wheel load", "At support"],
            correctAnswer: "Under a wheel load",
            explanation: "Maximum BM due to train of wheel loads on simply supported girder always occurs Under a wheel load."
          },
          {
            id: 41,
            question: "When BM is constant over beam, shear force will be ___ over entire span.",
            options: ["Maximum", "Minimum", "Uniform", "Zero"],
            correctAnswer: "Zero",
            explanation: "When BM is constant over beam, shear force will be Zero over entire span."
          },
          {
            id: 42,
            question: "Ratio of linear stress to linear strain is called modulus of ___.",
            options: ["Rigidity", "Elasticity", "Resilience", "Toughness"],
            correctAnswer: "Elasticity",
            explanation: "Ratio of linear stress to linear strain is called modulus of Elasticity."
          },
          {
            id: 43,
            question: "If m1 and m2 are members of two individual trusses in a compound truss, truss is determinate if m = ___.",
            options: ["M1+m2", "M1+m2+1", "M1+m2+3", "M1+m2+2"],
            correctAnswer: "M1+m2+3",
            explanation: "If m1 and m2 are members of two individual trusses in a compound truss, truss is determinate if m = M1+m2+3."
          },
          {
            id: 44,
            question: "The property of elongation of material under tensile load is called ___.",
            options: ["Malleability", "Resilience", "Ductility", "Toughness"],
            correctAnswer: "Ductility",
            explanation: "The property of elongation of material under tensile load is called Ductility."
          },
          {
            id: 45,
            question: "If SFD of simply supported beam is parabolic, load on beam is ___ varying distributed load.",
            options: ["Uniformly", "Triangularly", "Linearly", "Parabolically"],
            correctAnswer: "Linearly",
            explanation: "If SFD of simply supported beam is parabolic, load on beam is Linearly varying distributed load."
          },
          {
            id: 46,
            question: "Distribution factor for ith member ki at a joint is ki / ___.",
            options: ["Σk", "Σk²", "Σk/n", "K_max"],
            correctAnswer: "Σk",
            explanation: "Distribution factor for ith member ki at a joint is ki / Σk."
          },
          {
            id: 47,
            question: "Relation G = E/[2(1+μ)] is between ___.",
            options: ["E, G, K", "E, G, μ", "G, K, μ", "E, K, μ"],
            correctAnswer: "E, G, μ",
            explanation: "Relation G = E/[2(1+μ)] is between E, G, μ."
          },
          {
            id: 48,
            question: "The maximum stress material can resist is called ___ stress.",
            options: ["Yield", "Working", "Ultimate", "Permissible"],
            correctAnswer: "Ultimate",
            explanation: "The maximum stress material can resist is called Ultimate stress."
          },
          {
            id: 49,
            question: "Relationship between flexural strength and characteristic strength is fcr = ___.",
            options: ["0.5√fck", "0.6√fck", "0.7√fck", "0.8√fck"],
            correctAnswer: "0.7√fck",
            explanation: "Relationship between flexural strength and characteristic strength is fcr = 0.7√fck."
          },
          {
            id: 50,
            question: "Pullout Test is NOT a ___ test of concrete.",
            options: ["Workability", "Slump", "Tensile strength", "Compressive strength"],
            correctAnswer: "Tensile strength",
            explanation: "Pullout Test is NOT a Tensile strength test of concrete."
          },
          {
            id: 51,
            question: "Fatigue cracking failure is due to ___ strain below surface.",
            options: ["Compressive", "Shear", "Tensile", "Bending"],
            correctAnswer: "Tensile",
            explanation: "Fatigue cracking failure is due to Tensile strain below surface."
          },
          {
            id: 52,
            question: "Self-weight refers to ___ static load of a structure.",
            options: ["Variable", "Temporary", "Permanent", "Dynamic"],
            correctAnswer: "Permanent",
            explanation: "Self-weight refers to Permanent static load of a structure."
          },
          {
            id: 53,
            question: "Vertical reaction for arch with load W at distance a, total span 2l, is ___.",
            options: ["W×a/l", "Wa/2l", "W×2l/a", "Wl/2a"],
            correctAnswer: "Wa/2l",
            explanation: "Vertical reaction for arch with load W at distance a, total span 2l, is Wa/2l."
          },
          {
            id: 54,
            question: "Degree of static indeterminacy of propped cantilever beam is ___.",
            options: ["0", "1", "2", "3"],
            correctAnswer: "1",
            explanation: "Degree of static indeterminacy of propped cantilever beam is 1."
          },
          {
            id: 55,
            question: "Load longer than span covers simply supported beam entirely — max BM at ___.",
            options: ["Support", "Quarter span", "Center", "Any section"],
            correctAnswer: "Center",
            explanation: "Load longer than span covers simply supported beam entirely — max BM at Center."
          },
          {
            id: 56,
            question: "If shear force is constant throughout the section, then BM is ___.",
            options: ["Constant", "Parabolic", "Zero", "Linear"],
            correctAnswer: "Linear",
            explanation: "If shear force is constant throughout the section, then BM is Linear."
          },
          {
            id: 57,
            question: "For UDL longer than span moving left to right, max BM at mid-section occurs when UDL occupies ___ span.",
            options: ["Left half", "Right half", "Quarter", "Whole"],
            correctAnswer: "Whole",
            explanation: "For UDL longer than span moving left to right, max BM at mid-section occurs when UDL occupies Whole span."
          },
          {
            id: 58,
            question: "For simply supported beam with UDL w and span L having max BM=M, if span doubled, new max BM is ___.",
            options: ["M", "2M", "4M", "8M"],
            correctAnswer: "4M",
            explanation: "For simply supported beam with UDL w and span L having max BM=M, if span doubled, new max BM is 4M."
          },
          {
            id: 59,
            question: "Max compressive strain in concrete in bending compression is taken as ___.",
            options: ["0.002", "0.003", "0.0035", "0.004"],
            correctAnswer: "0.0035",
            explanation: "Max compressive strain in concrete in bending compression is taken as 0.0035."
          },
          {
            id: 60,
            question: "Shear force diagram of cantilever with point load at free end is ___.",
            options: ["Triangle", "Parabola", "Zero", "Rectangle"],
            correctAnswer: "Rectangle",
            explanation: "Shear force diagram of cantilever with point load at free end is Rectangle."
          },
          {
            id: 61,
            question: "Cable for prestressed concrete simply supported beam with UDL should ideally be ___ with zero eccentricity at ends.",
            options: ["Straight", "Parabolic", "Circular", "Hyperbolic"],
            correctAnswer: "Parabolic",
            explanation: "Cable for prestressed concrete simply supported beam with UDL should ideally be Parabolic with zero eccentricity at ends."
          },
          {
            id: 62,
            question: "Simply supported beam with varying load from zero to w at other end — SF is zero at distance x from least loaded point where x = ___.",
            options: ["A/2", "A/√2", "A/√3", "A/3"],
            correctAnswer: "A/√3",
            explanation: "Simply supported beam with varying load from zero to w at other end — SF is zero at distance x from least loaded point where x = A/√3."
          },
          {
            id: 63,
            question: "For RCC structure, shape of shear stress diagram is ___.",
            options: ["Linear throughout", "Rectangular throughout", "Parabolic above neutral axis, rectangular below", "Triangular"],
            correctAnswer: "Parabolic above neutral axis, rectangular below",
            explanation: "For RCC structure, shape of shear stress diagram is Parabolic above neutral axis, rectangular below."
          },
          {
            id: 64,
            question: "Maximum BM due to train of wheel loads on a simply supported girder always occurs ___.",
            options: ["At midspan", "At quarter span", "Under a wheel load", "At support"],
            correctAnswer: "Under a wheel load",
            explanation: "Maximum BM due to train of wheel loads on a simply supported girder always occurs Under a wheel load."
          },
          {
            id: 65,
            question: "When bending moment is constant over the beam, shear force will be ___ over the entire span.",
            options: ["Maximum", "Minimum", "Uniform", "Zero"],
            correctAnswer: "Zero",
            explanation: "When bending moment is constant over the beam, shear force will be Zero over the entire span."
          },
          {
            id: 66,
            question: "If m1, m2 are members of two individual trusses in a compound truss, truss is determinate if m = ___.",
            options: ["M1+m2", "M1+m2+1", "M1+m2+3", "M1+m2+2"],
            correctAnswer: "M1+m2+3",
            explanation: "If m1, m2 are members of two individual trusses in a compound truss, truss is determinate if m = M1+m2+3."
          },
          {
            id: 67,
            question: "The property in which elongation of material occurs due to tensile load is called ___.",
            options: ["Malleability", "Resilience", "Ductility", "Toughness"],
            correctAnswer: "Ductility",
            explanation: "The property in which elongation of material occurs due to tensile load is called Ductility."
          },
          {
            id: 68,
            question: "If shear force diagram of a simply supported beam is parabolic, then load on beam is ___ varying distributed load.",
            options: ["Uniformly", "Triangularly", "Linearly", "Parabolically"],
            correctAnswer: "Linearly",
            explanation: "If shear force diagram of a simply supported beam is parabolic, then load on beam is Linearly varying distributed load."
          },
          {
            id: 69,
            question: "If ki is the stiffness of ith member at a joint, distribution factor for that member is ki / ___.",
            options: ["Σk", "Σk²", "Σk/n", "K_max"],
            correctAnswer: "Σk",
            explanation: "If ki is the stiffness of ith member at a joint, distribution factor for that member is ki / Σk."
          },
          {
            id: 70,
            question: "Fatigue cracking failure is due to ___ strain below the surface.",
            options: ["Compressive", "Shear", "Tensile", "Bending"],
            correctAnswer: "Tensile",
            explanation: "Fatigue cracking failure is due to Tensile strain below the surface."
          },
          {
            id: 71,
            question: "Self-weight refers to the ___ static load of a structure.",
            options: ["Variable", "Temporary", "Permanent", "Dynamic"],
            correctAnswer: "Permanent",
            explanation: "Self-weight refers to the Permanent static load of a structure."
          },
          {
            id: 72,
            question: "Vertical reaction for an arch with load W at distance a, total span 2l, is ___.",
            options: ["W×a/l", "Wa/2l", "W×2l/a", "Wl/2a"],
            correctAnswer: "Wa/2l",
            explanation: "Vertical reaction for an arch with load W at distance a, total span 2l, is Wa/2l."
          },
          {
            id: 73,
            question: "A load longer than span covers the simply supported beam entirely; maximum bending moment is at ___.",
            options: ["Support", "Quarter span", "Center", "Any section"],
            correctAnswer: "Center",
            explanation: "A load longer than span covers the simply supported beam entirely; maximum bending moment is at Center."
          },
          {
            id: 74,
            question: "When UDL longer than the span of girder moves left to right, maximum BM at mid-section occurs when UDL occupies ___ span.",
            options: ["Left half", "Right half", "Quarter", "Whole"],
            correctAnswer: "Whole",
            explanation: "When UDL longer than the span of girder moves left to right, maximum BM at mid-section occurs when UDL occupies Whole span."
          },
          {
            id: 75,
            question: "For simply supported beam with UDL w and span L having max BM=M, if span is doubled, new max BM is ___.",
            options: ["M", "2M", "4M", "8M"],
            correctAnswer: "4M",
            explanation: "For simply supported beam with UDL w and span L having max BM=M, if span is doubled, new max BM is 4M."
          },
          {
            id: 76,
            question: "Maximum compressive strain in concrete in bending compression is taken as ___.",
            options: ["0.002", "0.003", "0.0035", "0.004"],
            correctAnswer: "0.0035",
            explanation: "Maximum compressive strain in concrete in bending compression is taken as 0.0035."
          },
          {
            id: 77,
            question: "Shear force diagram of cantilever beam with point load at the free end is ___.",
            options: ["Triangle", "Parabola", "Zero everywhere", "Rectangle"],
            correctAnswer: "Rectangle",
            explanation: "Shear force diagram of cantilever beam with point load at the free end is Rectangle."
          },
          {
            id: 78,
            question: "Cable for prestressed concrete simply supported beam with UDL over entire span should ideally be ___ with zero eccentricity at ends.",
            options: ["Straight", "Parabolic", "Circular", "Hyperbolic"],
            correctAnswer: "Parabolic",
            explanation: "Cable for prestressed concrete simply supported beam with UDL over entire span should ideally be Parabolic with zero eccentricity at ends."
          },
          {
            id: 79,
            question: "Simply supported beam with varying load from zero to w at the other end (length a); SF is zero at distance x from the least loaded point where x = ___.",
            options: ["A/2", "A/√2", "A/√3", "A/3"],
            correctAnswer: "A/√3",
            explanation: "Simply supported beam with varying load from zero to w at the other end (length a); SF is zero at distance x from the least loaded point where x = A/√3."
          }
        ]
      },
      {
        id: 2,
        title: "Stress and strain analysis",
        description: "Normal and shear stresses; principal stresses and principal planes; maximum shear stress and corresponding plane; stress-strain curves; torsion.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Normal stress is:",
            options: ["Shear force / area", "Normal force / area", "Deformation", "Elastic property"],
            correctAnswer: "Normal force / area",
            explanation: "σ = P/A (normal stress = force perpendicular to area / area)."
          },
          {
            id: 2,
            question: "Normal strain is:",
            options: ["Stress / area", "Change in length / original length", "Angle change", "Lateral deformation"],
            correctAnswer: "Change in length / original length",
            explanation: "ε = ΔL/L (normal strain = deformation / original length)."
          },
          {
            id: 3,
            question: "Shear strain is measured in:",
            options: ["Units of length", "Force per area", "Angle in radians", "Percentage"],
            correctAnswer: "Angle in radians",
            explanation: "Shear strain γ is angular deformation, measured in radians."
          },
          {
            id: 4,
            question: "Hooke's law states:",
            options: ["Stress is always equal to strain", "Stress is proportional to strain", "Strain is independent of stress", "Stress = constant"],
            correctAnswer: "Stress is proportional to strain",
            explanation: "σ = Eε within elastic limit (E is Young's modulus)."
          },
          {
            id: 5,
            question: "Young's modulus (E) measures:",
            options: ["Elasticity in tension/compression", "Elasticity in shear", "Elasticity in volume", "Lateral deformation"],
            correctAnswer: "Elasticity in tension/compression",
            explanation: "E = σ/ε (tensile or compressive elasticity)."
          },
          {
            id: 6,
            question: "Poisson's ratio is:",
            options: ["Lateral strain / longitudinal strain", "Longitudinal strain / lateral strain", "Stress / strain", "Always positive"],
            correctAnswer: "Lateral strain / longitudinal strain",
            explanation: "ν = lateral strain / longitudinal strain; typically 0.25-0.33 for materials."
          },
          {
            id: 7,
            question: "Bulk modulus (K) measures:",
            options: ["Tensile elasticity", "Shear elasticity", "Volume change resistance", "All elasticity types"],
            correctAnswer: "Volume change resistance",
            explanation: "Bulk modulus: material's resistance to volume change under pressure."
          },
          {
            id: 8,
            question: "Principal stresses are:",
            options: ["Maximum and minimum stresses", "Applied stresses only", "Shear stresses", "Any stresses"],
            correctAnswer: "Maximum and minimum stresses",
            explanation: "Principal stresses are extreme normal stresses at planes with zero shear."
          },
          {
            id: 9,
            question: "Mohr's circle graphically represents:",
            options: ["Strain only", "Stress transformation and principal stresses", "Material properties", "Time variation"],
            correctAnswer: "Stress transformation and principal stresses",
            explanation: "Mohr's circle shows stress transformation; principal stresses at top/bottom."
          },
          {
            id: 10,
            question: "For a 2D stress state, number of independent stress components:",
            options: ["1", "2", "3", "4"],
            correctAnswer: "3",
            explanation: "2D stress: σₓ, σᵧ, τₓᵧ (shear stress is same in both directions)."
          },
          {
            id: 11,
            question: "Ultimate tensile strength (UTS) is:",
            options: ["Maximum load before fracture / area", "Yield stress", "Breaking stress", "Elastic limit"],
            correctAnswer: "Maximum load before fracture / area",
            explanation: "UTS is the maximum stress the material can withstand before failure."
          },
          {
            id: 12,
            question: "Yield stress is:",
            options: ["Maximum stress", "Stress at plastic deformation begins", "Stress at rupture", "Proportional limit"],
            correctAnswer: "Stress at plastic deformation begins",
            explanation: "Yield stress (Sy) is where material begins permanent plastic deformation."
          },
          {
            id: 13,
            question: "Factor of safety is:",
            options: ["Stress / allowable stress", "Failure stress / working stress", "Always 1", "Design choice"],
            correctAnswer: "Failure stress / working stress",
            explanation: "FOS = Ultimate stress / Allowable working stress; typically 1.5-3."
          },
          {
            id: 14,
            question: "Ductile material shows:",
            options: ["No plastic deformation", "Large plastic deformation before failure", "Immediate brittle failure", "No warning"],
            correctAnswer: "Large plastic deformation before failure",
            explanation: "Ductile materials exhibit plastic strain; fail after warning (deformation)."
          },
          {
            id: 15,
            question: "Brittle material fails:",
            options: ["After yielding", "Suddenly without warning", "With large deformation", "Elastically"],
            correctAnswer: "Suddenly without warning",
            explanation: "Brittle materials fracture suddenly with little or no plastic deformation."
          },
          {
            id: 16,
            question: "Proof stress is:",
            options: ["Ultimate stress", "Stress producing permanent set of 0.1-0.2%", "Yield stress", "Elastic limit"],
            correctAnswer: "Stress producing permanent set of 0.1-0.2%",
            explanation: "Proof stress: stress causing specified permanent deformation (e.g., 0.2%)."
          },
          {
            id: 17,
            question: "Elastic limit is:",
            options: ["Maximum stress", "Highest stress without permanent deformation", "Plastic region", "Failure point"],
            correctAnswer: "Highest stress without permanent deformation",
            explanation: "Beyond elastic limit, material retains permanent deformation after unloading."
          },
          {
            id: 18,
            question: "Stress concentration factor (Kt) accounts for:",
            options: ["Material weakness", "Geometric discontinuities (holes, notches)", "Temperature", "Time"],
            correctAnswer: "Geometric discontinuities (holes, notches)",
            explanation: "Kt: ratio of local stress to nominal stress due to geometric stress raisers."
          },
          {
            id: 19,
            question: "Resilience is:",
            options: ["Ability to absorb energy elastically", "Ability to sustain load", "Toughness", "Brittleness"],
            correctAnswer: "Ability to absorb energy elastically",
            explanation: "Resilience: energy absorbed per unit volume in elastic region."
          },
          {
            id: 20,
            question: "Toughness measures:",
            options: ["Elastic capacity", "Total energy absorbed before failure", "Hardness", "Brittleness"],
            correctAnswer: "Total energy absorbed before failure",
            explanation: "Toughness: total work (area under stress-strain curve) before fracture."
          },
          {
            id: 21,
            question: "Torsion causes:",
            options: ["Bending", "Twisting and shear stress", "Compression", "No stress"],
            correctAnswer: "Twisting and shear stress",
            explanation: "Torsion: twisting action causes shear stress in shaft material."
          },
          {
            id: 22,
            question: "Angle of twist is given by:",
            options: ["θ = TL/GJ", "θ = T/G", "θ = L/J", "θ = T×L"],
            correctAnswer: "θ = TL/GJ",
            explanation: "Angle of twist θ = TL/GJ (torque × length / shear modulus × polar moment)."
          },
          {
            id: 23,
            question: "Polar moment of inertia (J) for solid circular shaft is:",
            options: ["πd³/32", "πd⁴/32", "πd⁴/64", "πd²/16"],
            correctAnswer: "πd⁴/32",
            explanation: "Solid shaft: J = πd⁴/32 or πr⁴/2 (polar moment about axis)."
          },
          {
            id: 24,
            question: "Shear stress in torsion is:",
            options: ["τ = T/J", "τ = Tr/J", "τ = T/A", "τ = J/T"],
            correctAnswer: "τ = Tr/J",
            explanation: "τ = Tr/J; maximum at outer surface (r = R for solid shaft)."
          },
          {
            id: 25,
            question: "For hollow circular shaft, polar moment J is:",
            options: ["π(d₀⁴)/32", "π(d₀⁴ - dᵢ⁴)/32", "π(d₀² - dᵢ²)/16", "π(d₀ - dᵢ)⁴/32"],
            correctAnswer: "π(d₀⁴ - dᵢ⁴)/32",
            explanation: "Hollow: J = π(D⁴ - d⁴)/32 (outer and inner diameters)."
          },
          {
            id: 26,
            question: "Power transmission by shaft: P = ",
            options: ["T × L", "T × ω", "ω / T", "T / ω"],
            correctAnswer: "T × ω",
            explanation: "Power P = T × ω (torque × angular velocity)."
          },
          {
            id: 27,
            question: "Maximum shear stress in shaft with combined bending and torsion:",
            options: ["Shear stress only", "Bending stress + Torsional stress", "Larger of two stresses", "Combined equivalent stress"],
            correctAnswer: "Combined equivalent stress",
            explanation: "Combined: use equivalent stress theories (von Mises, Tresca) for design."
          },
          {
            id: 28,
            question: "At the neutral axis of bending combined with torsion:",
            options: ["Bending stress is maximum", "Torsional shear is maximum", "Both are maximum", "Stress is minimum"],
            correctAnswer: "Torsional shear is maximum",
            explanation: "At NA, bending normal stress = 0; torsional shear is maximum."
          },
          {
            id: 29,
            question: "Shear modulus (G) relates to Young's modulus (E) by:",
            options: ["G = 2E", "G = E/2(1+ν)", "G = E/(1+ν)", "G = E(1+ν)"],
            correctAnswer: "G = E/2(1+ν)",
            explanation: "G = E/2(1+ν) where ν is Poisson's ratio."
          },
          {
            id: 30,
            question: "Critical section for shaft design with combined loading is where:",
            options: ["Torque is maximum", "Bending moment is maximum", "Combined equivalent stress is maximum", "Stress is zero"],
            correctAnswer: "Combined equivalent stress is maximum",
            explanation: "Design at section with maximum equivalent combined stress."
          },
          {
            id: 31,
            question: "Principal planes are subjected to ___ stresses only.",
            options: ["Shear", "Normal", "Bending", "Torsional"],
            correctAnswer: "Normal",
            explanation: "Principal planes are subjected to Normal stresses only."
          },
          {
            id: 32,
            question: "A circular shaft is subjected to torsion, the stress at the center of shaft is ___.",
            options: ["Maximum", "Minimum", "Zero", "Equal to surface stress"],
            correctAnswer: "Zero",
            explanation: "A circular shaft is subjected to torsion, the stress at the center of shaft is Zero."
          },
          {
            id: 33,
            question: "The correct sequence of stress-strain curve is ___.",
            options: ["EL, PL, YP, Breaking Point", "PL, EL, YP, Breaking Point", "YP, PL, EL, Breaking Point", "PL, YP, EL, Breaking Point"],
            correctAnswer: "PL, EL, YP, Breaking Point",
            explanation: "The correct sequence of stress-strain curve is PL, EL, YP, Breaking Point."
          },
          {
            id: 34,
            question: "The maximum shear stress induced in a member which is subjected to an axial load is equal to ___ of maximum normal stress.",
            options: ["Equal", "One-third", "Half", "Double"],
            correctAnswer: "Half",
            explanation: "The maximum shear stress induced in a member which is subjected to an axial load is equal to Half of maximum normal stress."
          },
          {
            id: 35,
            question: "Shear modulus of elasticity is the ratio of shearing stress and shearing ___.",
            options: ["Modulus", "Force", "Stress", "Strain"],
            correctAnswer: "Strain",
            explanation: "Shear modulus of elasticity is the ratio of shearing stress and shearing Strain."
          },
          {
            id: 36,
            question: "The maximum normal stress formula for combined tensile and shear stress is ___.",
            options: ["Σx/2 + √(σx²+4τxy²)", "Σx + √(σx²+τxy²)", "Σx/2 – √(σx²+4τxy²)", "Σx+1/2 × √(σx²+4τxy²)"],
            correctAnswer: "Σx+1/2 × √(σx²+4τxy²)",
            explanation: "The maximum normal stress formula for combined tensile and shear stress is Σx+1/2 × √(σx²+4τxy²)."
          },
          {
            id: 37,
            question: "Shear modulus of elasticity is ratio of shearing stress and shearing ___.",
            options: ["Modulus", "Stress", "Strain", "Deformation"],
            correctAnswer: "Strain",
            explanation: "Shear modulus of elasticity is ratio of shearing stress and shearing Strain."
          },
          {
            id: 38,
            question: "In limit state design, Hooke's law is valid up to ___ limit.",
            options: ["Elastic", "Plastic", "Ultimate", "Proportional"],
            correctAnswer: "Proportional",
            explanation: "In limit state design, Hooke's law is valid up to Proportional limit."
          },
          {
            id: 39,
            question: "Major principal stresses on diagonal plane = (fx+fy)/2 + ½ × ___.",
            options: ["√((fx-fy)²+4τv²)", "√((fx+fy)²+4τ²)", "(fx-fy)+4τv²", "√(fx²+fy²+4τv²)"],
            correctAnswer: "√((fx-fy)²+4τv²)",
            explanation: "Major principal stresses on diagonal plane = (fx+fy)/2 + ½ × √((fx-fy)²+4τv²)."
          },
          {
            id: 40,
            question: "Correct sequence of stress-strain curve is PL, EL, YP, ___.",
            options: ["Failure point", "Breaking point", "Ultimate point", "Necking point"],
            correctAnswer: "Breaking point",
            explanation: "Correct sequence of stress-strain curve is PL, EL, YP, Breaking point."
          },
          {
            id: 41,
            question: "Shear stress at outermost fibers of circular shaft under torsion is ___.",
            options: ["Zero", "Average", "Maximum", "Undefined"],
            correctAnswer: "Maximum",
            explanation: "Shear stress at outermost fibers of circular shaft under torsion is Maximum."
          },
          {
            id: 42,
            question: "When a body is subjected to direct tensile stress σx and shear stress τxy, maximum normal stress is ___.",
            options: ["Σx/2 + √(σx²+4τxy²)/2", "Σx + √(σx²+4τxy²)/2", "Σx/2 + √(σx²+τxy²)", "Σx + √(σx²+4τxy²)/4"],
            correctAnswer: "Σx/2 + √(σx²+4τxy²)/2",
            explanation: "When a body is subjected to direct tensile stress σx and shear stress τxy, maximum normal stress is Σx/2 + √(σx²+4τxy²)/2."
          },
          {
            id: 43,
            question: "Modulus of rigidity is defined as the ratio of shear ___ and shear strain.",
            options: ["Modulus", "Stress", "Elasticity", "Force"],
            correctAnswer: "Stress",
            explanation: "Modulus of rigidity is defined as the ratio of shear Stress and shear strain."
          },
          {
            id: 44,
            question: "Major principal stress on diagonal plane is expressed as (fx+fy)/2 + 1/2 × ___.",
            options: ["√((fx-fy)²+4τv²)", "√((fx+fy)²+4τ²)", "(fx-fy)+4τv²", "√(fx²+fy²+4τv²)"],
            correctAnswer: "√((fx-fy)²+4τv²)",
            explanation: "Major principal stress on diagonal plane is expressed as (fx+fy)/2 + 1/2 × √((fx-fy)²+4τv²)."
          },
          {
            id: 45,
            question: "The relation between Young's Modulus (E), shear modulus (G) and Poisson's ratio (μ) is ___.",
            options: ["G = E×2(1+μ)", "G = E/[2(1+μ)]", "G = E/[2(1-μ)]", "G = E×(1-μ)/2"],
            correctAnswer: "G = E/[2(1+μ)]",
            explanation: "The relation between Young's Modulus (E), shear modulus (G) and Poisson's ratio (μ) is G = E/[2(1+μ)]."
          },
          {
            id: 46,
            question: "Shear stress at outermost fibers of a circular shaft under torsion is ___.",
            options: ["Zero", "Average", "Maximum", "Undefined"],
            correctAnswer: "Maximum",
            explanation: "Shear stress at outermost fibers of a circular shaft under torsion is Maximum."
          }
        ]
      },
      {
        id: 3,
        title: "Theory of flexure and columns",
        description: "Co-planar and pure bending; elastic curve; angle of rotation; radius of curvature and flexural stiffness; deflection; bending stress; Euler's formula for long column.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Bending stress formula is:",
            options: ["σ = P/A", "σ = M/I × y", "σ = F/A", "σ = τ"],
            correctAnswer: "σ = M/I × y",
            explanation: "Bending stress σ = M/I × y (moment/inertia × distance from NA)."
          },
          {
            id: 2,
            question: "Shear stress distribution in rectangular section is:",
            options: ["Uniform", "Parabolic", "Linear", "Triangular"],
            correctAnswer: "Parabolic",
            explanation: "Shear stress varies parabolically; maximum at neutral axis, zero at top/bottom."
          },
          {
            id: 3,
            question: "Neutral axis is where:",
            options: ["Stress is maximum", "Stress is zero", "Bending moment is zero", "Shear force is zero"],
            correctAnswer: "Stress is zero",
            explanation: "Neutral axis (NA) in bending has zero normal stress; at centroid of section."
          },
          {
            id: 4,
            question: "Maximum deflection in simply supported beam (UDL) occurs at:",
            options: ["Support", "Mid-span", "End", "Depends on load"],
            correctAnswer: "Mid-span",
            explanation: "For symmetric loading on SS beam, maximum deflection is at center."
          },
          {
            id: 5,
            question: "Deflection of cantilever with end load P is:",
            options: ["PL²/2EI", "PL³/3EI", "PL⁴/8EI", "Depends on section"],
            correctAnswer: "PL³/3EI",
            explanation: "Cantilever deflection: δ = PL³/3EI at free end."
          },
          {
            id: 6,
            question: "Combined bending and axial stress occurs:",
            options: ["Bending only", "Axial load with eccentric application", "Shear only", "Never"],
            correctAnswer: "Axial load with eccentric application",
            explanation: "Eccentric load causes both axial and bending stresses; combined analysis needed."
          },
          {
            id: 7,
            question: "Euler's formula for column buckling (hinged ends) is:",
            options: ["Pcr = π²EI/L²", "Pcr = π²EI/4L²", "Pcr = π²EI/2L²", "Pcr = EI/L²"],
            correctAnswer: "Pcr = π²EI/L²",
            explanation: "Euler: Pcr = π²EI/L² (for both ends hinged/free to rotate)."
          },
          {
            id: 8,
            question: "Slenderness ratio is defined as:",
            options: ["L/r", "L²/r", "r/L", "L × r"],
            correctAnswer: "L/r",
            explanation: "Slenderness ratio λ = L/r (length / radius of gyration)."
          },
          {
            id: 9,
            question: "Column buckling mode is:",
            options: ["Tensile failure", "Lateral instability leading to failure", "Crushing only", "No failure"],
            correctAnswer: "Lateral instability leading to failure",
            explanation: "Buckling: sudden lateral deflection and collapse under critical load."
          },
          {
            id: 10,
            question: "For column with fixed ends, effective length is:",
            options: ["L", "L/2", "2L", "L/√2"],
            correctAnswer: "L/2",
            explanation: "Fixed-fixed: effective length Le = L/2 (more stable than hinged ends)."
          },
          {
            id: 11,
            question: "Johnson's formula is used when:",
            options: ["Slenderness ratio is very high", "Slenderness ratio is low to moderate", "Column is very thin", "Always"],
            correctAnswer: "Slenderness ratio is low to moderate",
            explanation: "Johnson formula used for intermediate columns; Euler for very slender."
          },
          {
            id: 12,
            question: "Eccentrically loaded column fails due to:",
            options: ["Axial load only", "Bending only", "Combined axial + bending stress", "Shear only"],
            correctAnswer: "Combined axial + bending stress",
            explanation: "Eccentric load: combined direct and bending stresses; analysis needed."
          },
          {
            id: 13,
            question: "Core or kern of a section is:",
            options: ["Entire section", "Region where load produces compression throughout", "Center only", "Outer fibers"],
            correctAnswer: "Region where load produces compression throughout",
            explanation: "Kern: area where axial load causes only compressive stress (no tension)."
          },
          {
            id: 14,
            question: "For a simply supported beam, a neutral axis is where bending stress is ___ and shear stress maximum.",
            options: ["Maximum", "Constant", "Zero", "Minimum"],
            correctAnswer: "Zero",
            explanation: "For a simply supported beam, a neutral axis is where bending stress is Zero and shear stress maximum."
          },
          {
            id: 15,
            question: "The deflection at the center of a simply supported beam when a concentrated load P is acting at its center is ___.",
            options: ["PL³/24EI", "PL³/48EI", "PL³/96EI", "PL³/192EI"],
            correctAnswer: "PL³/48EI",
            explanation: "The deflection at the center of a simply supported beam when a concentrated load P is acting at its center is PL³/48EI."
          },
          {
            id: 16,
            question: "The deflection of a cantilever beam subjected to a point load W at its free end is ___.",
            options: ["WL³/3EI", "WL³/6EI", "WL³/8EI", "WL³/12EI"],
            correctAnswer: "WL³/3EI",
            explanation: "The deflection of a cantilever beam subjected to a point load W at its free end is WL³/3EI."
          },
          {
            id: 17,
            question: "The deflection at center of fixed beam with total load W applied uniformly over its length L is ___.",
            options: ["WL³/192EI", "WL³/384EI", "WL³/48EI", "WL³/96EI"],
            correctAnswer: "WL³/384EI",
            explanation: "The deflection at center of fixed beam with total load W applied uniformly over its length L is WL³/384EI."
          },
          {
            id: 18,
            question: "One end of a column is kept free and other end fixed, then ratio of Leff to L is ___.",
            options: ["0.5", "0.7", "1", "2"],
            correctAnswer: "2",
            explanation: "One end of a column is kept free and other end fixed, then ratio of Leff to L is 2."
          },
          {
            id: 19,
            question: "The deflection at the center of fixed beam carrying a point load at mid-span is ___.",
            options: ["WL³/48EI", "WL³/96EI", "WL³/192EI", "WL³/384EI"],
            correctAnswer: "WL³/192EI",
            explanation: "The deflection at the center of fixed beam carrying a point load at mid-span is WL³/192EI."
          },
          {
            id: 20,
            question: "The maximum energy which can be stored in a body up to the elastic limit is called ___ resilience.",
            options: ["Modulus of", "Proof", "Total", "None of the above"],
            correctAnswer: "Proof",
            explanation: "The maximum energy which can be stored in a body up to the elastic limit is called Proof resilience."
          },
          {
            id: 21,
            question: "The shape factor of rectangular section is ___.",
            options: ["1.0", "1.25", "1.5", "2.0"],
            correctAnswer: "1.5",
            explanation: "The shape factor of rectangular section is 1.5."
          },
          {
            id: 22,
            question: "The equation of flexure is ___.",
            options: ["M/I = σ/y = E/R", "M/y = σ/I = E/R", "M/E = σ/y = I/R", "M/R = σ/I = E/y"],
            correctAnswer: "M/I = σ/y = E/R",
            explanation: "The equation of flexure is M/I = σ/y = E/R."
          },
          {
            id: 23,
            question: "At the point of contraflexure, the bending moment ___.",
            options: ["Is maximum", "Is minimum", "Is zero", "Changes sign"],
            correctAnswer: "Changes sign",
            explanation: "At the point of contraflexure, the bending moment Changes sign."
          },
          {
            id: 24,
            question: "Euler's buckling load for one end fixed and other hinged is given by ___.",
            options: ["Π²EI/L²", "2π²EI/L²", "4π²EI/L²", "Π²EI/4L²"],
            correctAnswer: "2π²EI/L²",
            explanation: "Euler's buckling load for one end fixed and other hinged is given by 2π²EI/L²."
          },
          {
            id: 25,
            question: "The shape factor of cross section with diamond shape under flexure is ___.",
            options: ["1.5", "2.0", "2.5", "3.0"],
            correctAnswer: "2.0",
            explanation: "The shape factor of cross section with diamond shape under flexure is 2.0."
          },
          {
            id: 26,
            question: "The minimum clear cover for column is ___.",
            options: ["20 mm", "25 mm", "40 mm", "50 mm"],
            correctAnswer: "40 mm",
            explanation: "The minimum clear cover for column is 40 mm."
          },
          {
            id: 27,
            question: "In crippling load equation for a column of length L, the equivalent length for a case of both the ends fixed is ___.",
            options: ["L", "L/√2", "L/2", "2L"],
            correctAnswer: "L/2",
            explanation: "In crippling load equation for a column of length L, the equivalent length for a case of both the ends fixed is L/2."
          },
          {
            id: 28,
            question: "The effective length of a column with both ends fixed is ___.",
            options: ["L", "L/2", "2L", "√2L"],
            correctAnswer: "L/2",
            explanation: "The effective length of a column with both ends fixed is L/2."
          },
          {
            id: 29,
            question: "The equation of flexure is M/I = σ/y = ___.",
            options: ["E", "E/R", "G", "G/R"],
            correctAnswer: "E/R",
            explanation: "The equation of flexure is M/I = σ/y = E/R."
          },
          {
            id: 30,
            question: "At point of contraflexure, bending moment ___.",
            options: ["Is zero", "Is maximum", "Is minimum", "Changes sign"],
            correctAnswer: "Changes sign",
            explanation: "At point of contraflexure, bending moment Changes sign."
          },
          {
            id: 31,
            question: "Shape factor of cross section with diamond shape under flexure is ___.",
            options: ["1.5", "1.7", "2.0", "2.5"],
            correctAnswer: "2.0",
            explanation: "Shape factor of cross section with diamond shape under flexure is 2.0."
          },
          {
            id: 32,
            question: "Euler's buckling load for one end fixed and other hinged is ___.",
            options: ["Π²EI/4L²", "Π²EI/L²", "2π²EI/L²", "4π²EI/L²"],
            correctAnswer: "2π²EI/L²",
            explanation: "Euler's buckling load for one end fixed and other hinged is 2π²EI/L²."
          },
          {
            id: 33,
            question: "Point of contraflexure is point where bending moment ___.",
            options: ["Is zero only", "Is maximum", "Changes sign", "Is minimum only"],
            correctAnswer: "Changes sign",
            explanation: "Point of contraflexure is point where bending moment Changes sign."
          },
          {
            id: 34,
            question: "Effective length of column with both ends fixed is ___.",
            options: ["L", "L/√2", "L/2", "2L"],
            correctAnswer: "L/2",
            explanation: "Effective length of column with both ends fixed is L/2."
          },
          {
            id: 35,
            question: "Minimum clear cover for column is ___ mm.",
            options: ["25", "30", "40", "50"],
            correctAnswer: "40",
            explanation: "Minimum clear cover for column is 40 mm."
          },
          {
            id: 36,
            question: "Deflection at center of fixed beam carrying a point load at mid-span is ___.",
            options: ["WL³/48EI", "WL³/96EI", "WL³/192EI", "WL³/384EI"],
            correctAnswer: "WL³/192EI",
            explanation: "Deflection at center of fixed beam carrying a point load at mid-span is WL³/192EI."
          },
          {
            id: 37,
            question: "Maximum energy stored in a body up to elastic limit is called ___ resilience.",
            options: ["Impact", "Modulus of", "Proof", "Total"],
            correctAnswer: "Proof",
            explanation: "Maximum energy stored in a body up to elastic limit is called Proof resilience."
          },
          {
            id: 38,
            question: "At point of contraflexure, the bending moment ___.",
            options: ["Is zero only", "Is maximum", "Is minimum", "Changes sign"],
            correctAnswer: "Changes sign",
            explanation: "At point of contraflexure, the bending moment Changes sign."
          },
          {
            id: 39,
            question: "The point of contraflexure is the point where bending moment ___.",
            options: ["Is zero only", "Is maximum", "Changes sign", "Is minimum only"],
            correctAnswer: "Changes sign",
            explanation: "The point of contraflexure is the point where bending moment Changes sign."
          }
        ]
      },
      {
        id: 4,
        title: "Determinate structures-1",
        description: "Degree of determinacy, Energy Methods, Virtual Work Method, Deflection of beams and portal frame.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "In the conjugate beam method, the fixed support in actual beam is considered as ___ support in the conjugate beam.",
            options: ["Fixed", "Hinged", "Roller", "Free"],
            correctAnswer: "Free",
            explanation: "In the conjugate beam method, the fixed support in actual beam is considered as Free support in the conjugate beam."
          },
          {
            id: 2,
            question: "The degree of kinematic indeterminacy of pin jointed plane frame is ___.",
            options: ["2j-3", "2j+3", "J-3", "3j-2"],
            correctAnswer: "2j-3",
            explanation: "The degree of kinematic indeterminacy of pin jointed plane frame is 2j-3."
          },
          {
            id: 3,
            question: "Castigliano's first theorem is applicable when the system behaves ___.",
            options: ["Plastically", "Rigidly", "Elastically", "Inelastically"],
            correctAnswer: "Elastically",
            explanation: "Castigliano's first theorem is applicable when the system behaves Elastically."
          },
          {
            id: 4,
            question: "Degree of kinematic indeterminacy of pin jointed plane frame is ___.",
            options: ["J-3", "2j-3", "3j-2", "J-2"],
            correctAnswer: "2j-3",
            explanation: "Degree of kinematic indeterminacy of pin jointed plane frame is 2j-3."
          },
          {
            id: 5,
            question: "In the conjugate beam method, fixed support in the actual beam is considered as ___ support in the conjugate beam.",
            options: ["Fixed", "Roller", "Free", "Pinned"],
            correctAnswer: "Free",
            explanation: "In the conjugate beam method, fixed support in the actual beam is considered as Free support in the conjugate beam."
          }
        ]
      },
      {
        id: 5,
        title: "Determinate structures-2",
        description: "Influence Lines for Simple Structures with point loads and UDL; analysis of two hinged arches.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "In influence line diagrams (ILD), points remain fixed, position of ___ changes.",
            options: ["Support", "Moment", "Load", "Reaction"],
            correctAnswer: "Load",
            explanation: "In influence line diagrams (ILD), points remain fixed, position of Load changes."
          },
          {
            id: 2,
            question: "In a two hinged arch, the moment will be zero when the thrust axis and the ___ axis coincide.",
            options: ["Centroidal", "Neutral", "Hinge", "Arch"],
            correctAnswer: "Hinge",
            explanation: "In a two hinged arch, the moment will be zero when the thrust axis and the Hinge axis coincide."
          },
          {
            id: 3,
            question: "Two hinge arches is a/an ___ structure.",
            options: ["Determinate", "Mechanism", "Indeterminate", "Stable"],
            correctAnswer: "Indeterminate",
            explanation: "Two hinge arches is a/an Indeterminate structure."
          },
          {
            id: 4,
            question: "The ILD of a three hinged arch of span L and rise h due to horizontal thrust H is triangle with its maximum ordinate at center equals to ___.",
            options: ["L/2h", "L/4h", "L/8h", "L/h"],
            correctAnswer: "L/4h",
            explanation: "The ILD of a three hinged arch of span L and rise h due to horizontal thrust H is triangle with its maximum ordinate at center equals to L/4h."
          },
          {
            id: 5,
            question: "The ILD for reaction at fixed support of cantilever beam is ___ ordinate throughout the span.",
            options: ["Zero", "0.5", "1", "Variable"],
            correctAnswer: "1",
            explanation: "The ILD for reaction at fixed support of cantilever beam is 1 ordinate throughout the span."
          },
          {
            id: 6,
            question: "The maximum shear force in three hinged parabolic arch usually occurs at ___.",
            options: ["Crown", "Quarter span", "Springing's", "Third span"],
            correctAnswer: "Springing's",
            explanation: "The maximum shear force in three hinged parabolic arch usually occurs at Springing's."
          },
          {
            id: 7,
            question: "If 'L' is the span of a three hinged arch, 'h' is the rise and 'W' is the UDL per unit length over the entire span, the horizontal reaction at each support is given by ___.",
            options: ["WL²/4h", "WL²/8h", "WL²/16h", "WL²/2h"],
            correctAnswer: "WL²/8h",
            explanation: "If 'L' is the span of a three hinged arch, 'h' is the rise and 'W' is the UDL per unit length over the entire span, the horizontal reaction at each support is given by WL²/8h."
          },
          {
            id: 8,
            question: "Parabolic two hinged arch with concentrated load W at crown — horizontal thrust is ___.",
            options: ["WL/8h", "WL/16h", "25WL/128h", "WL/4h"],
            correctAnswer: "25WL/128h",
            explanation: "Parabolic two hinged arch with concentrated load W at crown — horizontal thrust is 25WL/128h."
          },
          {
            id: 9,
            question: "In ILD: points remain fixed, position of ___ changes.",
            options: ["Support", "Beam", "Load", "Reaction"],
            correctAnswer: "Load",
            explanation: "In ILD: points remain fixed, position of Load changes."
          },
          {
            id: 10,
            question: "In two hinged parabolic arch with UVL zero at one end and w at other, horizontal thrust is ___.",
            options: ["WL²/8H", "WL²/12H", "WL²/16H", "WL²/24H"],
            correctAnswer: "WL²/16H",
            explanation: "In two hinged parabolic arch with UVL zero at one end and w at other, horizontal thrust is WL²/16H."
          },
          {
            id: 11,
            question: "ILD for shear force at a section on a cantilever will be ___ extending between free end and section.",
            options: ["Triangle", "Trapezoid", "Parabola", "Rectangle"],
            correctAnswer: "Rectangle",
            explanation: "ILD for shear force at a section on a cantilever will be Rectangle extending between free end and section."
          },
          {
            id: 12,
            question: "For three hinged arch, horizontal reaction at each support for UDL w over entire span is ___.",
            options: ["WL/8h", "WL/4h", "WL²/8h", "WL²/4h"],
            correctAnswer: "WL²/8h",
            explanation: "For three hinged arch, horizontal reaction at each support for UDL w over entire span is WL²/8h."
          },
          {
            id: 13,
            question: "Max shear force in three hinged parabolic arch usually occurs at ___.",
            options: ["Crown", "Midspan", "Springing's", "Quarter span"],
            correctAnswer: "Springing's",
            explanation: "Max shear force in three hinged parabolic arch usually occurs at Springing's."
          },
          {
            id: 14,
            question: "In two hinged parabolic arch, temperature increase will ___ horizontal thrust.",
            options: ["Decrease", "Not affect", "Increase", "Eliminate"],
            correctAnswer: "Increase",
            explanation: "In two hinged parabolic arch, temperature increase will Increase horizontal thrust."
          },
          {
            id: 15,
            question: "For a two hinged arch with constant EI, horizontal thrust H in terms of beam moment M is given by ___.",
            options: ["∫My ds / ∫y² ds/EI", "∫My dy/dx / ∫y² ds/EI", "∫M ds / ∫y ds", "∫My / ∫y²"],
            correctAnswer: "∫My dy/dx / ∫y² ds/EI",
            explanation: "For a two hinged arch with constant EI, horizontal thrust H in terms of beam moment M is given by ∫My dy/dx / ∫y² ds/EI."
          },
          {
            id: 16,
            question: "ILD of three hinged arch (span L, rise h) due to horizontal thrust H is a triangle with max ordinate at center equal to ___.",
            options: ["L/2h", "L/4h", "L/8h", "H/4L"],
            correctAnswer: "L/4h",
            explanation: "ILD of three hinged arch (span L, rise h) due to horizontal thrust H is a triangle with max ordinate at center equal to L/4h."
          },
          {
            id: 17,
            question: "In a two-hinged arch, moment will be zero when thrust axis and ___ axis coincide.",
            options: ["Shear", "Hinge", "Roller", "Fixed"],
            correctAnswer: "Hinge",
            explanation: "In a two-hinged arch, moment will be zero when thrust axis and Hinge axis coincide."
          },
          {
            id: 18,
            question: "ILD for reaction at fixed support of cantilever beam is ___ ordinate throughout the span.",
            options: ["0", "0.5", "1", "2"],
            correctAnswer: "1",
            explanation: "ILD for reaction at fixed support of cantilever beam is 1 ordinate throughout the span."
          },
          {
            id: 19,
            question: "Parabolic two hinged arch loaded with concentrated load W at crown — horizontal thrust is ___.",
            options: ["WL/8h", "WL/16h", "25WL/128h", "WL/4h"],
            correctAnswer: "25WL/128h",
            explanation: "Parabolic two hinged arch loaded with concentrated load W at crown — horizontal thrust is 25WL/128h."
          },
          {
            id: 20,
            question: "In ILD (Influence Line Diagrams), points remain fixed and the position of ___ changes.",
            options: ["Support", "Beam", "Load", "Reaction"],
            correctAnswer: "Load",
            explanation: "In ILD (Influence Line Diagrams), points remain fixed and the position of Load changes."
          },
          {
            id: 21,
            question: "In a two hinged parabolic arch with UVL zero at one end and w at other, horizontal thrust formula is ___.",
            options: ["WL²/8H", "WL²/12H", "WL²/16H", "WL²/24H"],
            correctAnswer: "WL²/16H",
            explanation: "In a two hinged parabolic arch with UVL zero at one end and w at other, horizontal thrust formula is WL²/16H."
          },
          {
            id: 22,
            question: "ILD for shear force at a section on a cantilever will be a ___ extending between free end and section.",
            options: ["Triangle", "Trapezoid", "Parabola", "Rectangle"],
            correctAnswer: "Rectangle",
            explanation: "ILD for shear force at a section on a cantilever will be a Rectangle extending between free end and section."
          },
          {
            id: 23,
            question: "For three hinged arch span L, rise h, UDL w per unit length over entire span, horizontal reaction at each support is ___.",
            options: ["WL/8h", "WL/4h", "WL²/8h", "WL²/4h"],
            correctAnswer: "WL²/8h",
            explanation: "For three hinged arch span L, rise h, UDL w per unit length over entire span, horizontal reaction at each support is WL²/8h."
          },
          {
            id: 24,
            question: "Maximum shear force in three hinged parabolic arch usually occurs at ___.",
            options: ["Crown", "Midspan", "Springing's", "Quarter span"],
            correctAnswer: "Springing's",
            explanation: "Maximum shear force in three hinged parabolic arch usually occurs at Springing's."
          },
          {
            id: 25,
            question: "In a two hinged parabolic arch, an increase in temperature will ___ the horizontal thrust.",
            options: ["Decrease", "Not affect", "Increase", "Eliminate"],
            correctAnswer: "Increase",
            explanation: "In a two hinged parabolic arch, an increase in temperature will Increase the horizontal thrust."
          }
        ]
      },
      {
        id: 6,
        title: "Indeterminate structures",
        description: "Flexibility Method, Two-Hinged Parabolic Arches, Slope Deflection Method, Moment Distribution Method, Stiffness method, Influence Lines for Continuous Beams, Elementary Plastic analysis.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Stiffness matrix method is also called ___ method.",
            options: ["Force", "Flexibility", "Displacement", "Energy"],
            correctAnswer: "Displacement",
            explanation: "Stiffness matrix method is also called Displacement method."
          },
          {
            id: 2,
            question: "The simultaneous equations of slope deflection method can be solved by iteration in ___ method.",
            options: ["Three moment", "Column analogy", "Moment distribution", "Stiffness"],
            correctAnswer: "Moment distribution",
            explanation: "The simultaneous equations of slope deflection method can be solved by iteration in Moment distribution method."
          },
          {
            id: 3,
            question: "Moment distribution method is introduced by ___.",
            options: ["Turner", "Cross", "Hardy cross", "Clapeyron"],
            correctAnswer: "Hardy cross",
            explanation: "Moment distribution method is introduced by Hardy cross."
          },
          {
            id: 4,
            question: "In a plastic analysis of structures, the segment between any two successive plastic hinges is assumed to deform as a ___ material.",
            options: ["Elastic", "Plastic", "Rigid", "Viscous"],
            correctAnswer: "Rigid",
            explanation: "In a plastic analysis of structures, the segment between any two successive plastic hinges is assumed to deform as a Rigid material."
          },
          {
            id: 5,
            question: "Moment distribution method was introduced by ___.",
            options: ["Castigliano", "Hardy Cross", "Euler", "Mohr"],
            correctAnswer: "Hardy Cross",
            explanation: "Moment distribution method was introduced by Hardy Cross."
          }
        ]
      }
    ]
  },
  {
    id: 5,
    title: "Design of Structures",
    code: "ACiE05",
    topics: [
      {
        id: 1,
        title: "Loads and load combinations",
        description: "Dead Load, Imposed Load, Wind Load, Snow Load, Earthquake Load.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Dead load + wind load + earthquake load combination is ___.",
            options: ["Always required", "Optional", "Not possible", "Mandatory in seismic zones"],
            correctAnswer: "Not possible",
            explanation: "Dead load + wind load + earthquake load combination is Not possible."
          },
          {
            id: 2,
            question: "IS 875 part I provides ___ load.",
            options: ["Live", "Wind", "Snow", "Dead"],
            correctAnswer: "Dead",
            explanation: "IS 875 part I provides Dead load."
          },
          {
            id: 3,
            question: "The IS code for live/imposed load calculation is ___ part 2.",
            options: ["IS 456", "IS 875", "IS 800", "IS 1893"],
            correctAnswer: "IS 875",
            explanation: "The IS code for live/imposed load calculation is IS 875 part 2."
          },
          {
            id: 4,
            question: "The relation between intensity of wind pressure P and Velocity V is taken as P ∝ ___.",
            options: ["V", "V½", "V²", "V³"],
            correctAnswer: "V²",
            explanation: "The relation between intensity of wind pressure P and Velocity V is taken as P ∝ V²."
          },
          {
            id: 5,
            question: "The speed of wind in hilly area of Nepal above 3000 m is taken as ___ m/s.",
            options: ["40", "47", "55", "60"],
            correctAnswer: "55",
            explanation: "The speed of wind in hilly area of Nepal above 3000 m is taken as 55 m/s."
          },
          {
            id: 6,
            question: "The snow load is calculated as S = ___.",
            options: ["ΜSo", "So/μ", "Μ+So", "So-μ"],
            correctAnswer: "ΜSo",
            explanation: "The snow load is calculated as S = ΜSo."
          },
          {
            id: 7,
            question: "In roof truss, the value of snow load is taken as ___ N/m².",
            options: ["1.5", "2.0", "2.5", "3.0"],
            correctAnswer: "2.5",
            explanation: "In roof truss, the value of snow load is taken as 2.5 N/m²."
          }
        ]
      },
      {
        id: 2,
        title: "Concrete technology",
        description: "Concrete technology (materials, properties, mix design, testing, quality control, and codes (IS and NS)).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Slump test gives good results for ___ mixes.",
            options: ["Lean", "Dry", "Rich", "Stiff"],
            correctAnswer: "Rich",
            explanation: "Slump test gives good results for Rich mixes."
          },
          {
            id: 2,
            question: "Slump test of concrete is a measure of its ___.",
            options: ["Strength", "Workability", "Consistency", "Durability"],
            correctAnswer: "Consistency",
            explanation: "Slump test of concrete is a measure of its Consistency."
          },
          {
            id: 3,
            question: "The strength of concrete mainly depends on ___.",
            options: ["Aggregate type", "Cement content", "Water-cement ratio", "Admixture"],
            correctAnswer: "Water-cement ratio",
            explanation: "The strength of concrete mainly depends on Water-cement ratio."
          },
          {
            id: 4,
            question: "Super plasticizer is used in concrete to reduce quantity of ___ water.",
            options: ["Curing", "Bleeding", "Mixing", "Ponding"],
            correctAnswer: "Mixing",
            explanation: "Super plasticizer is used in concrete to reduce quantity of Mixing water."
          },
          {
            id: 5,
            question: "Quick Setting Cement is used for ___ construction.",
            options: ["Hot weather", "Cold weather", "Underwater", "High strength"],
            correctAnswer: "Underwater",
            explanation: "Quick Setting Cement is used for Underwater construction."
          },
          {
            id: 6,
            question: "The maximum compressive strain in concrete in axial compression is taken as ___.",
            options: ["0.001", "0.002", "0.003", "0.0035"],
            correctAnswer: "0.002",
            explanation: "The maximum compressive strain in concrete in axial compression is taken as 0.002."
          },
          {
            id: 7,
            question: "The pH value of water used in making cement concrete should not be less than ___.",
            options: ["4", "5", "6", "7"],
            correctAnswer: "6",
            explanation: "The pH value of water used in making cement concrete should not be less than 6."
          },
          {
            id: 8,
            question: "The maximum influence on steel is ___.",
            options: ["Manganese", "Silicon", "Carbon", "Nickel"],
            correctAnswer: "Carbon",
            explanation: "The maximum influence on steel is Carbon."
          },
          {
            id: 9,
            question: "Grout is a mixture of water, ___ and sand.",
            options: ["Lime", "Gypsum", "Cement", "Fly ash"],
            correctAnswer: "Cement",
            explanation: "Grout is a mixture of water, Cement and sand."
          },
          {
            id: 10,
            question: "The cylinder strength of the concrete is less than the cube strength because of the difference in the ___ ratio of the specimens.",
            options: ["Water-cement", "Aspect", "Slenderness", "Area"],
            correctAnswer: "Slenderness",
            explanation: "The cylinder strength of the concrete is less than the cube strength because of the difference in the Slenderness ratio of the specimens."
          },
          {
            id: 11,
            question: "The mixture of cement sand and coarse aggregate is increased by ___ % to get dry volume of concrete.",
            options: ["25–30", "35–40", "50–55", "60–65"],
            correctAnswer: "50–55",
            explanation: "The mixture of cement sand and coarse aggregate is increased by 50–55 % to get dry volume of concrete."
          },
          {
            id: 12,
            question: "Relationship between flexural strength and characteristic strength is ___.",
            options: ["Fcr=0.5√fck", "Fcr=0.6√fck", "Fcr=0.7√fck", "Fcr=0.8√fck"],
            correctAnswer: "Fcr=0.7√fck",
            explanation: "Relationship between flexural strength and characteristic strength is Fcr=0.7√fck."
          },
          {
            id: 13,
            question: "Compacting is done to remove ___.",
            options: ["Water", "Cement", "Air bubbles", "Aggregates"],
            correctAnswer: "Air bubbles",
            explanation: "Compacting is done to remove Air bubbles."
          },
          {
            id: 14,
            question: "High strength bolt is used for both slip resistant and ___ type connection.",
            options: ["Moment", "Friction", "Bearing", "Weld"],
            correctAnswer: "Bearing",
            explanation: "High strength bolt is used for both slip resistant and Bearing type connection."
          }
        ]
      },
      {
        id: 3,
        title: "RCC structures-1",
        description: "Working stress and limit state methods; design of beams and slabs; analysis of RC beams and slabs in bending, shear, deflection, bond and end anchorage; RCC; NS & IS codes.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Those in which the concrete reaches its collapse strain earlier than the steel reaches its yield strain is ___ reinforced.",
            options: ["Under", "Balanced", "Over", "Doubly"],
            correctAnswer: "Over",
            explanation: "Those in which the concrete reaches its collapse strain earlier than the steel reaches its yield strain is Over reinforced."
          },
          {
            id: 2,
            question: "The maximum area of tension reinforcement in beams shall not exceed ___.",
            options: ["0.02", "0.04", "0.06", "0.08"],
            correctAnswer: "0.04",
            explanation: "The maximum area of tension reinforcement in beams shall not exceed 0.04."
          },
          {
            id: 3,
            question: "The minimum cover for bars in RCC slabs should be ___ mm or diameter of bars.",
            options: ["10", "15", "20", "25"],
            correctAnswer: "15",
            explanation: "The minimum cover for bars in RCC slabs should be 15 mm or diameter of bars."
          },
          {
            id: 4,
            question: "The maximum tensile stress for limit state design of R.C beam is ___ fy.",
            options: ["0.67", "0.80", "0.87", "0.95"],
            correctAnswer: "0.87",
            explanation: "The maximum tensile stress for limit state design of R.C beam is 0.87 fy."
          },
          {
            id: 5,
            question: "If diameter of reinforcement bar is d, the anchorage value of the U type hook alone will be ___.",
            options: ["8d", "12d", "16d", "20d"],
            correctAnswer: "16d",
            explanation: "If diameter of reinforcement bar is d, the anchorage value of the U type hook alone will be 16d."
          },
          {
            id: 6,
            question: "The minimum area of tensile reinforcement provided in beam is ___.",
            options: ["0.85bD/fy", "0.12bD/fy", "0.15bD/fy", "0.20bD/fy"],
            correctAnswer: "0.85bD/fy",
            explanation: "The minimum area of tensile reinforcement provided in beam is 0.85bD/fy."
          },
          {
            id: 7,
            question: "The Lap length of reinforcement in compression shall not be less than ___ ϕ.",
            options: ["16", "20", "24", "30"],
            correctAnswer: "24",
            explanation: "The Lap length of reinforcement in compression shall not be less than 24 ϕ."
          },
          {
            id: 8,
            question: "Shear reinforcement is provided in RC section to counteract ___ and shear failure.",
            options: ["Compression crack", "Tension crack", "Crack and shear failure", "Bending failure"],
            correctAnswer: "Crack and shear failure",
            explanation: "Shear reinforcement is provided in RC section to counteract Crack and shear failure and shear failure."
          },
          {
            id: 9,
            question: "Steel is preferred over other materials in reinforcement because the coefficient of thermal expansion of steel and concrete is almost ___.",
            options: ["Zero", "Different", "Same", "Proportional"],
            correctAnswer: "Same",
            explanation: "Steel is preferred over other materials in reinforcement because the coefficient of thermal expansion of steel and concrete is almost Same."
          },
          {
            id: 10,
            question: "Web crippling in steel beam occurs due to failure of web under ___ load.",
            options: ["Distributed", "Bending", "Concentrated", "Dynamic"],
            correctAnswer: "Concentrated",
            explanation: "Web crippling in steel beam occurs due to failure of web under Concentrated load."
          },
          {
            id: 11,
            question: "The Lap length of reinforcement in compression shall not be less than ___ × Diameter of bar.",
            options: ["16", "20", "24", "30"],
            correctAnswer: "24",
            explanation: "The Lap length of reinforcement in compression shall not be less than 24 × Diameter of bar."
          },
          {
            id: 12,
            question: "Nominal mix required for roofing of RCC is ___ grade of concrete.",
            options: ["M15", "M20", "M25", "M30"],
            correctAnswer: "M20",
            explanation: "Nominal mix required for roofing of RCC is M20 grade of concrete."
          },
          {
            id: 13,
            question: "In slab, the minimum thickness is designed to resist ___.",
            options: ["Bending", "Deflection", "Shear", "Tension"],
            correctAnswer: "Shear",
            explanation: "In slab, the minimum thickness is designed to resist Shear."
          },
          {
            id: 14,
            question: "Bending moment in a beam is not a function of ___ of the beam.",
            options: ["Span", "Load", "Support conditions", "Cross section"],
            correctAnswer: "Cross section",
            explanation: "Bending moment in a beam is not a function of Cross section of the beam."
          },
          {
            id: 15,
            question: "The The length required for full transfer of bar stress to concrete is called ___ length.",
            options: ["Anchorage", "Embedment", "Development", "Transfer"],
            correctAnswer: "Development",
            explanation: "The The length required for full transfer of bar stress to concrete is called Development length."
          },
          {
            id: 16,
            question: "The shear reinforcement in RCC is mainly provided to resist ___ tension.",
            options: ["Direct", "Axial", "Diagonal", "Lateral"],
            correctAnswer: "Diagonal",
            explanation: "The shear reinforcement in RCC is mainly provided to resist Diagonal tension."
          },
          {
            id: 17,
            question: "The section in which the concrete reaches its collapse strain earlier than steel reaching yield strain is known as ___ reinforced section.",
            options: ["Under", "Balanced", "Over", "Doubly"],
            correctAnswer: "Over",
            explanation: "The section in which the concrete reaches its collapse strain earlier than steel reaching yield strain is known as Over reinforced section."
          }
        ]
      },
      {
        id: 4,
        title: "RCC structures-2",
        description: "Design of columns and isolated/combined footings; pre-stressed concrete; NS & IS codes.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The maximum percentage of longitudinal reinforcement in the column in practice is ___.",
            options: ["0.02", "0.04", "0.06", "0.08"],
            correctAnswer: "0.04",
            explanation: "The maximum percentage of longitudinal reinforcement in the column in practice is 0.04."
          },
          {
            id: 2,
            question: "The maximum theoretical percentage of longitudinal reinforcement in a RCC column is ___ % of gross area.",
            options: ["4", "6", "8", "10"],
            correctAnswer: "6",
            explanation: "The maximum theoretical percentage of longitudinal reinforcement in a RCC column is 6 % of gross area."
          },
          {
            id: 3,
            question: "The minimum cube strength of concrete used for a pre-stressed member is ___ kg/cm².",
            options: ["250", "300", "350", "400"],
            correctAnswer: "350",
            explanation: "The minimum cube strength of concrete used for a pre-stressed member is 350 kg/cm²."
          },
          {
            id: 4,
            question: "The most economical section for a column is ___ section.",
            options: ["Solid circular", "Hollow rectangular", "I-section", "Tubular"],
            correctAnswer: "Tubular",
            explanation: "The most economical section for a column is Tubular section."
          },
          {
            id: 5,
            question: "Minimum % reinforcement required for footing for Fe415 grade steel is ___.",
            options: ["0.08", "0.10", "0.12", "0.15"],
            correctAnswer: "0.12",
            explanation: "Minimum % reinforcement required for footing for Fe415 grade steel is 0.12."
          },
          {
            id: 6,
            question: "The formwork of column sides can be removed in ___ hrs.",
            options: ["12", "18", "24", "48"],
            correctAnswer: "24",
            explanation: "The formwork of column sides can be removed in 24 hrs."
          },
          {
            id: 7,
            question: "The purpose of reinforcement in pre-stressed concrete is to impart initial ___ stress in concrete.",
            options: ["Tensile", "Shear", "Compressive", "Bending"],
            correctAnswer: "Compressive",
            explanation: "The purpose of reinforcement in pre-stressed concrete is to impart initial Compressive stress in concrete."
          }
        ]
      },
      {
        id: 5,
        title: "Steel structures",
        description: "Standard and built-up sections; design of bolted and welded connections; design of simple elements such as ties, struts, axially loaded columns, and column bases; NS and IS codes.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The angle of inclination of the lacing bar with the longitudinal axis of the column should preferably be between ___ and 70°.",
            options: ["20°", "30°", "40°", "50°"],
            correctAnswer: "40°",
            explanation: "The angle of inclination of the lacing bar with the longitudinal axis of the column should preferably be between 40° and 70°."
          },
          {
            id: 2,
            question: "The strength of the column with helical reinforcement shall be ___ times the strength of a similar column with lateral ties.",
            options: ["0.95", "1.0", "1.05", "1.10"],
            correctAnswer: "1.05",
            explanation: "The strength of the column with helical reinforcement shall be 1.05 times the strength of a similar column with lateral ties."
          },
          {
            id: 3,
            question: "A laced column is ___ than battened column for same load.",
            options: ["Weaker", "Same strength", "Stronger", "Lighter"],
            correctAnswer: "Stronger",
            explanation: "A laced column is Stronger than battened column for same load."
          },
          {
            id: 4,
            question: "A fillet weld whose axis is parallel to the direction of the applied load is known as ___ fillet weld.",
            options: ["End", "Transverse", "Oblique", "Side"],
            correctAnswer: "Side",
            explanation: "A fillet weld whose axis is parallel to the direction of the applied load is known as Side fillet weld."
          },
          {
            id: 5,
            question: "For the reversal of stresses, the most suitable bolt is ___ grip bolt.",
            options: ["Anchor", "Bearing", "Friction", "Snug tight"],
            correctAnswer: "Friction",
            explanation: "For the reversal of stresses, the most suitable bolt is Friction grip bolt."
          },
          {
            id: 6,
            question: "The effective length of a fillet weld should not be less than ___ times the weld size.",
            options: ["2", "3", "4", "5"],
            correctAnswer: "4",
            explanation: "The effective length of a fillet weld should not be less than 4 times the weld size."
          },
          {
            id: 7,
            question: "Minimum edge distance and end distance for rolled, machine flame cut is ___ × hole diameter.",
            options: ["1.0", "1.25", "1.5", "2.0"],
            correctAnswer: "1.5",
            explanation: "Minimum edge distance and end distance for rolled, machine flame cut is 1.5 × hole diameter."
          },
          {
            id: 8,
            question: "A laced column is ___ than battened column for same load, unsupported length and end conditions.",
            options: ["Weaker", "Equal in strength", "Stronger", "Unpredictable"],
            correctAnswer: "Stronger",
            explanation: "A laced column is Stronger than battened column for same load, unsupported length and end conditions."
          },
          {
            id: 9,
            question: "The overlap of batten plates with the main members in welded connections should be more than ___.",
            options: ["2t", "3t", "4t", "5t"],
            correctAnswer: "4t",
            explanation: "The overlap of batten plates with the main members in welded connections should be more than 4t."
          },
          {
            id: 10,
            question: "Spot welding is used when two plates are placed ___.",
            options: ["Side by side", "At angle", "One below the other", "End to end"],
            correctAnswer: "One below the other",
            explanation: "Spot welding is used when two plates are placed One below the other."
          }
        ]
      },
      {
        id: 6,
        title: "Timber and masonry structures",
        description: "Design principles of timber beams and columns; Design of masonry structures (Mandatory rules of thumb, Nepal Building Code (NBC), properties), Failure modes of masonry structure, mud mortar, lime mortar and cement mortar and its properties.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Strength of timber is maximum in the direction ___ to grain.",
            options: ["Perpendicular", "Diagonal", "Parallel", "At 45°"],
            correctAnswer: "Parallel",
            explanation: "Strength of timber is maximum in the direction Parallel to grain."
          },
          {
            id: 2,
            question: "NBC-203 code deals with earthquake resistant design for low strength ___.",
            options: ["RCC", "Steel", "Masonry", "Timber"],
            correctAnswer: "Masonry",
            explanation: "NBC-203 code deals with earthquake resistant design for low strength Masonry."
          },
          {
            id: 3,
            question: "In non-parallel system of seismic design, 100% design seismic force of one direction and ___% design seismic force of orthogonal direction is considered.",
            options: ["10", "20", "30", "40"],
            correctAnswer: "30",
            explanation: "In non-parallel system of seismic design, 100% design seismic force of one direction and 30% design seismic force of orthogonal direction is considered."
          },
          {
            id: 4,
            question: "For masonry built in 1:1:6 cement-lime-sand mix mortar, the horizontal shear stress permissible on the area of a mortar bed joint is ___ MPa.",
            options: ["0.10", "0.15", "0.20", "0.25"],
            correctAnswer: "0.15",
            explanation: "For masonry built in 1:1:6 cement-lime-sand mix mortar, the horizontal shear stress permissible on the area of a mortar bed joint is 0.15 MPa."
          },
          {
            id: 5,
            question: "Gable band in the house is provided at ___ level.",
            options: ["Plinth", "Lintel", "Sill", "Roof"],
            correctAnswer: "Roof",
            explanation: "Gable band in the house is provided at Roof level."
          }
        ]
      }
    ]
  },
  {
    id: 6,
    title: "Water Supply, Sanitation and Environment",
    code: "ACiE06",
    topics: [
      {
        id: 1,
        title: "Water sources, water quality and water demand",
        description: "Sources of water (surface and groundwater) and their selection; impurities in water (suspended, colloidal, dissolved); hardness and alkalinity; living organisms in water; water-related diseases and prevention measures; drinking water quality standards; water demand estimation.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "___ contain water with the maximum amount of turbidity.",
            options: ["Springs", "Wells", "Rivers", "Reservoirs"],
            correctAnswer: "Rivers",
            explanation: "Rivers contain water with the maximum amount of turbidity."
          },
          {
            id: 2,
            question: "The per capita demand of water is calculated in liters per person per ___.",
            options: ["Hour", "Shift", "Day", "Week"],
            correctAnswer: "Day",
            explanation: "The per capita demand of water is calculated in liters per person per Day."
          },
          {
            id: 3,
            question: "Blue baby syndrome (methemoglobinemia) is caused due to ___.",
            options: ["Fluoride", "Chlorine", "Nitrate", "Iron"],
            correctAnswer: "Nitrate",
            explanation: "Blue baby syndrome (methemoglobinemia) is caused due to Nitrate."
          },
          {
            id: 4,
            question: "Permissible pH value for public water supply ranges between ___.",
            options: ["5.5 to 7.5", "6.0 to 8.0", "6.5 to 8.5", "7.0 to 9.0"],
            correctAnswer: "6.5 to 8.5",
            explanation: "Permissible pH value for public water supply ranges between 6.5 to 8.5."
          },
          {
            id: 5,
            question: "Turbidity of water is expressed in ___.",
            options: ["NTU", "Mg/L", "BOD", "COD"],
            correctAnswer: "NTU",
            explanation: "Turbidity of water is expressed in NTU."
          },
          {
            id: 6,
            question: "___ method is used to measure the color of water.",
            options: ["Lovibond", "Tintometer", "Colorimetric", "Spectrophotometric"],
            correctAnswer: "Tintometer",
            explanation: "Tintometer method is used to measure the color of water."
          },
          {
            id: 7,
            question: "A disease which is widespread and can reach globally is termed as ___.",
            options: ["Epidemic", "Endemic", "Pandemic", "Sporadic"],
            correctAnswer: "Pandemic",
            explanation: "A disease which is widespread and can reach globally is termed as Pandemic."
          },
          {
            id: 8,
            question: "___ increase method is preferred for rapidly growing population.",
            options: ["Arithmetic", "Geometric", "Geometrical", "Incremental"],
            correctAnswer: "Geometrical",
            explanation: "Geometrical increase method is preferred for rapidly growing population."
          },
          {
            id: 9,
            question: "The chemical generally used for controlling algae is ___ sulphate.",
            options: ["Ferrous", "Alum", "Copper", "Zinc"],
            correctAnswer: "Copper",
            explanation: "The chemical generally used for controlling algae is Copper sulphate."
          },
          {
            id: 10,
            question: "The type of water supply system generally used in hilly region is ___ flow system.",
            options: ["Pumped", "Pressurized", "Gravity", "Tidal"],
            correctAnswer: "Gravity",
            explanation: "The type of water supply system generally used in hilly region is Gravity flow system."
          },
          {
            id: 11,
            question: "The formula for overall efficiency of HRTF is ___.",
            options: ["E1 × E2", "E1 + E2", "E1 + E2(1-E1)", "E1 – E2"],
            correctAnswer: "E1 + E2(1-E1)",
            explanation: "The formula for overall efficiency of HRTF is E1 + E2(1-E1)."
          },
          {
            id: 12,
            question: "___ is not generated in waste treatment processes.",
            options: ["CO₂", "Methane", "Noise", "Sludge"],
            correctAnswer: "Noise",
            explanation: "Noise is not generated in waste treatment processes."
          },
          {
            id: 13,
            question: "The number of goals of sustainable development is ___.",
            options: ["12", "15", "17", "21"],
            correctAnswer: "17",
            explanation: "The number of goals of sustainable development is 17."
          },
          {
            id: 14,
            question: "Earthquakes and landslides are categorized as ___ hazards.",
            options: ["Climatic", "Geological", "Hydrological", "Biological"],
            correctAnswer: "Geological",
            explanation: "Earthquakes and landslides are categorized as Geological hazards."
          },
          {
            id: 15,
            question: "Alum can be regenerated by adding ___ acid.",
            options: ["Hydrochloric", "Nitric", "Sulfuric", "Phosphoric"],
            correctAnswer: "Sulfuric",
            explanation: "Alum can be regenerated by adding Sulfuric acid."
          },
          {
            id: 16,
            question: "According to DWSS, the water required for fire-fighting should not be more than ___ lpcd.",
            options: ["0.5", "1", "2", "5"],
            correctAnswer: "1",
            explanation: "According to DWSS, the water required for fire-fighting should not be more than 1 lpcd."
          },
          {
            id: 17,
            question: "The field capacity of a soil depends upon ___ tension in soil and porosity of soil.",
            options: ["Matric", "Osmotic", "Capillary", "Gravity"],
            correctAnswer: "Capillary",
            explanation: "The field capacity of a soil depends upon Capillary tension in soil and porosity of soil."
          },
          {
            id: 18,
            question: "Available moisture may be defined as the difference in water content of the soil between field capacity and permanent ___.",
            options: ["Saturation", "Wetting", "Wilting", "Irrigation"],
            correctAnswer: "Wilting",
            explanation: "Available moisture may be defined as the difference in water content of the soil between field capacity and permanent Wilting."
          },
          {
            id: 19,
            question: "The structure provided to discharge extra water from canal is canal ___.",
            options: ["Fall", "Regulator", "Escape", "Head works"],
            correctAnswer: "Escape",
            explanation: "The structure provided to discharge extra water from canal is canal Escape."
          },
          {
            id: 20,
            question: "Water may not contain much impurities if its source is ___.",
            options: ["River", "Pond", "Spring along hill slopes", "Lake"],
            correctAnswer: "Spring along hill slopes",
            explanation: "Water may not contain much impurities if its source is Spring along hill slopes."
          },
          {
            id: 21,
            question: "Water from reservoirs comes under the category of ___ water.",
            options: ["Ground", "Surface", "Spring", "Sub-surface"],
            correctAnswer: "Surface",
            explanation: "Water from reservoirs comes under the category of Surface water."
          },
          {
            id: 22,
            question: "Per capita demand of water is calculated in liters per person per ___.",
            options: ["Hour", "Shift", "Day", "Week"],
            correctAnswer: "Day",
            explanation: "Per capita demand of water is calculated in liters per person per Day."
          },
          {
            id: 23,
            question: "Pathogens are ___ bacteria.",
            options: ["Beneficial", "Harmless", "Harmful", "Neutral"],
            correctAnswer: "Harmful",
            explanation: "Pathogens are Harmful bacteria."
          },
          {
            id: 24,
            question: "Thermophilic bacteria grow more at high temperature of ___ °C.",
            options: ["10 to 20", "20 to 40", "40 to 70", "70 to 100"],
            correctAnswer: "40 to 70",
            explanation: "Thermophilic bacteria grow more at high temperature of 40 to 70 °C."
          },
          {
            id: 25,
            question: "Prevention of Trachoma depends upon the ___ of water.",
            options: ["Only quantity", "Only quality", "Quantity and quality", "Temperature"],
            correctAnswer: "Quantity and quality",
            explanation: "Prevention of Trachoma depends upon the Quantity and quality of water."
          },
          {
            id: 26,
            question: "Trachoma can be avoided by providing ___.",
            options: ["Chlorinated water", "Clean water", "Hard water", "Saline water"],
            correctAnswer: "Clean water",
            explanation: "Trachoma can be avoided by providing Clean water."
          },
          {
            id: 27,
            question: "1 TCU is equivalent to color produced by ___ in 1L of distilled water.",
            options: ["1 mg platinum cobalt", "1 mg silica", "1 ppm chlorine", "1 mg iron"],
            correctAnswer: "1 mg platinum cobalt",
            explanation: "1 TCU is equivalent to color produced by 1 mg platinum cobalt in 1L of distilled water."
          },
          {
            id: 28,
            question: "The effect on pH when bleaching powder is added is ___.",
            options: ["Increase", "Decrease", "No change", "Fluctuate"],
            correctAnswer: "Decrease",
            explanation: "The effect on pH when bleaching powder is added is Decrease."
          },
          {
            id: 29,
            question: "By boiling water, hardness can be removed if it is due to ___.",
            options: ["Calcium sulphate", "Calcium bicarbonate", "Magnesium sulphate", "Calcium chloride"],
            correctAnswer: "Calcium bicarbonate",
            explanation: "By boiling water, hardness can be removed if it is due to Calcium bicarbonate."
          },
          {
            id: 30,
            question: "Jar test is used to measure ___.",
            options: ["Optimum chlorine dose", "Turbidity directly", "Optimum coagulant dose", "PH"],
            correctAnswer: "Optimum coagulant dose",
            explanation: "Jar test is used to measure Optimum coagulant dose."
          },
          {
            id: 31,
            question: "Providing safe drinking water helps to prevent ___ disease.",
            options: ["Airborne", "Contact", "Water borne", "Skin"],
            correctAnswer: "Water borne",
            explanation: "Providing safe drinking water helps to prevent Water borne disease."
          },
          {
            id: 32,
            question: "E. coli typically die in water if pH value is ___.",
            options: ["6.5", "7.5", "8.5", "9.5"],
            correctAnswer: "9.5",
            explanation: "E. coli typically die in water if pH value is 9.5."
          },
          {
            id: 33,
            question: "NTU is the measure of ___.",
            options: ["Hardness", "Turbidity", "Alkalinity", "Acidity"],
            correctAnswer: "Turbidity",
            explanation: "NTU is the measure of Turbidity."
          },
          {
            id: 34,
            question: "The effect on pH of water in ponds due to presence of algae is ___.",
            options: ["Alkalinity decreases at day, increases at night", "Alkalinity increases at day, decreases at night", "No change throughout day", "PH remains constant"],
            correctAnswer: "Alkalinity increases at day, decreases at night",
            explanation: "The effect on pH of water in ponds due to presence of algae is Alkalinity increases at day, decreases at night."
          },
          {
            id: 35,
            question: "E-coli are harmless organisms but their presence in water indicates presence of ___ bacteria.",
            options: ["Thermophilic", "Pathogenic", "Beneficial", "Aerobic"],
            correctAnswer: "Pathogenic",
            explanation: "E-coli are harmless organisms but their presence in water indicates presence of Pathogenic bacteria."
          },
          {
            id: 36,
            question: "Reducer fitting is used to connect pipes of ___ diameter.",
            options: ["Same", "Different", "Equal", "Unknown"],
            correctAnswer: "Different",
            explanation: "Reducer fitting is used to connect pipes of Different diameter."
          },
          {
            id: 37,
            question: "If three pipes are connected in series, then ___ is same for all.",
            options: ["Pressure", "Head loss", "Discharge", "Velocity"],
            correctAnswer: "Discharge",
            explanation: "If three pipes are connected in series, then Discharge is same for all."
          },
          {
            id: 38,
            question: "Elbow pipe fitting provides a deviation of ___° in the pipework system.",
            options: ["45", "60", "90", "180"],
            correctAnswer: "90",
            explanation: "Elbow pipe fitting provides a deviation of 90° in the pipework system."
          },
          {
            id: 39,
            question: "Steel pipe is strong in resisting ___ stress but weak when stressed from outside.",
            options: ["Outside", "Inside", "Bending", "Torsional"],
            correctAnswer: "Inside",
            explanation: "Steel pipe is strong in resisting Inside stress but weak when stressed from outside."
          },
          {
            id: 40,
            question: "Expansion joint is mostly used at places where pipe ___ due to change in atmospheric temperature.",
            options: ["Expands", "Contracts", "Ruptures", "Bends"],
            correctAnswer: "Contracts",
            explanation: "Expansion joint is mostly used at places where pipe Contracts due to change in atmospheric temperature."
          },
          {
            id: 41,
            question: "Opening spacing of bars in case of coarse screen is ___ mm.",
            options: ["20", "30", "40", "50"],
            correctAnswer: "50",
            explanation: "Opening spacing of bars in case of coarse screen is 50 mm."
          },
          {
            id: 42,
            question: "Formula for overall efficiency of HRTF is ___.",
            options: ["E1 × E2", "E1 + E2", "E1 + E2(1-E1)", "E1 – E2"],
            correctAnswer: "E1 + E2(1-E1)",
            explanation: "Formula for overall efficiency of HRTF is E1 + E2(1-E1)."
          },
          {
            id: 43,
            question: "Main objective of toxicity assessment is to estimate ___.",
            options: ["Water hardness", "How much of a substance does what kind of harm", "BOD level", "PH balance"],
            correctAnswer: "How much of a substance does what kind of harm",
            explanation: "Main objective of toxicity assessment is to estimate How much of a substance does what kind of harm."
          },
          {
            id: 44,
            question: "If D.O. concentration falls to zero in any natural drainage, it indicates the zone of ___.",
            options: ["Recovery", "Active decomposition", "Clean water", "Oxidation"],
            correctAnswer: "Active decomposition",
            explanation: "If D.O. concentration falls to zero in any natural drainage, it indicates the zone of Active decomposition."
          },
          {
            id: 45,
            question: "Surfactant causes greasing in ___.",
            options: ["Sedimentation", "Filtration", "Flocculation", "Disinfection"],
            correctAnswer: "Flocculation",
            explanation: "Surfactant causes greasing in Flocculation."
          },
          {
            id: 46,
            question: "Variability in the rate of return is known as ___.",
            options: ["Return", "Risk", "Yield", "Margin"],
            correctAnswer: "Risk",
            explanation: "Variability in the rate of return is known as Risk."
          },
          {
            id: 47,
            question: "'Risk management' is a process that includes evaluation of ___.",
            options: ["Budgets only", "Policy alternatives", "Staff performance", "Schedules only"],
            correctAnswer: "Policy alternatives",
            explanation: "'Risk management' is a process that includes evaluation of Policy alternatives."
          },
          {
            id: 48,
            question: "Forest fire and drought lie in ___ category.",
            options: ["Geological condition", "Biological condition", "Climatic condition", "Technological hazard"],
            correctAnswer: "Climatic condition",
            explanation: "Forest fire and drought lie in Climatic condition category."
          },
          {
            id: 49,
            question: "In pipe flow, the minor loss due to sudden contraction is due to ___.",
            options: ["Sudden enlargement", "Expansion of flow after sudden contraction", "Friction", "Gradual change"],
            correctAnswer: "Expansion of flow after sudden contraction",
            explanation: "In pipe flow, the minor loss due to sudden contraction is due to Expansion of flow after sudden contraction."
          },
          {
            id: 50,
            question: "Alum can be regenerated by adding ___.",
            options: ["Lime", "Sulfuric acid", "Sodium hydroxide", "Chlorine"],
            correctAnswer: "Sulfuric acid",
            explanation: "Alum can be regenerated by adding Sulfuric acid."
          },
          {
            id: 51,
            question: "Night soil is ___.",
            options: ["Animal waste", "Human excreta", "Industrial waste", "Kitchen waste"],
            correctAnswer: "Human excreta",
            explanation: "Night soil is Human excreta."
          },
          {
            id: 52,
            question: "According to DWSS, water required for fire-fighting should not be more than ___ lpcd.",
            options: ["0.5", "1", "2", "5"],
            correctAnswer: "1",
            explanation: "According to DWSS, water required for fire-fighting should not be more than 1 lpcd."
          },
          {
            id: 53,
            question: "In a pipe network, the algebraic sum of piezometric head drops around each elementary circuit must be ___.",
            options: ["Maximum", "Minimum", "Zero", "Equal to total head"],
            correctAnswer: "Zero",
            explanation: "In a pipe network, the algebraic sum of piezometric head drops around each elementary circuit must be Zero."
          },
          {
            id: 54,
            question: "Environmental impact assessment has ___ types of levels.",
            options: ["2", "3", "4", "5"],
            correctAnswer: "4",
            explanation: "Environmental impact assessment has 4 types of levels."
          },
          {
            id: 55,
            question: "The recent disastrous earthquake in Nepal occurred in the ___ region.",
            options: ["Eastern", "Central", "Western", "Southern"],
            correctAnswer: "Western",
            explanation: "The recent disastrous earthquake in Nepal occurred in the Western region."
          },
          {
            id: 56,
            question: "Suspended particles are considered when they are less than ___ mg.",
            options: ["5", "10", "15", "20"],
            correctAnswer: "10",
            explanation: "Suspended particles are considered when they are less than 10 mg."
          }
        ]
      },
      {
        id: 2,
        title: "Intake and distribution systems",
        description: "Types of intakes, factor affecting while selection of location of intake; types and purposes of pipe materials, joints, valves and fittings; break pressure tanks; service reservoirs and their capacity determination; design of branch and looped water distribution systems.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Hardy cross method is used to solve the problem of pipe ___.",
            options: ["Flow", "Pressure", "Network", "Velocity"],
            correctAnswer: "Network",
            explanation: "Hardy cross method is used to solve the problem of pipe Network."
          },
          {
            id: 2,
            question: "Transmission main in water supply system is designed for maximum ___ demand.",
            options: ["Hourly", "Daily", "Weekly", "Monthly"],
            correctAnswer: "Daily",
            explanation: "Transmission main in water supply system is designed for maximum Daily demand."
          },
          {
            id: 3,
            question: "___ valves are provided at summits in water supply pipelines.",
            options: ["Gate", "Check", "Air relief", "Butterfly"],
            correctAnswer: "Air relief",
            explanation: "Air relief valves are provided at summits in water supply pipelines."
          },
          {
            id: 4,
            question: "___ distribution system is used in irregularly developed old cities.",
            options: ["Grid iron", "Ring", "Radial", "Dead end"],
            correctAnswer: "Dead end",
            explanation: "Dead end distribution system is used in irregularly developed old cities."
          },
          {
            id: 5,
            question: "Altitude valves are used for supplying water to ___.",
            options: ["Underground tanks", "Elevated tanks or standpipes", "Wells", "Reservoirs only"],
            correctAnswer: "Elevated tanks or standpipes",
            explanation: "Altitude valves are used for supplying water to Elevated tanks or standpipes."
          },
          {
            id: 6,
            question: "In distribution system, drain valves are provided at ___.",
            options: ["High points", "Summits", "Low points", "Intersections"],
            correctAnswer: "Low points",
            explanation: "In distribution system, drain valves are provided at Low points."
          },
          {
            id: 7,
            question: "In water supply system, blow off valve is provided at ___ of pipeline.",
            options: ["Top", "Middle", "Bottom", "Summit"],
            correctAnswer: "Bottom",
            explanation: "In water supply system, blow off valve is provided at Bottom of pipeline."
          },
          {
            id: 8,
            question: "Air valves or air-relief valves are provided at ___.",
            options: ["Depressions", "Summits", "Mid-points", "Valves only"],
            correctAnswer: "Summits",
            explanation: "Air valves or air-relief valves are provided at Summits."
          },
          {
            id: 9,
            question: "In a meandering river, the intake should be placed at the ___ side for optimal water quality and flow.",
            options: ["Convex", "Concave", "Straight", "Middle"],
            correctAnswer: "Concave",
            explanation: "In a meandering river, the intake should be placed at the Concave side for optimal water quality and flow."
          },
          {
            id: 10,
            question: "Intake in water supply system should not be located in ___ channel.",
            options: ["Main river", "Navigation", "Tributary", "Spring"],
            correctAnswer: "Navigation",
            explanation: "Intake in water supply system should not be located in Navigation channel."
          },
          {
            id: 11,
            question: "Air relief valves are used to discharge ___ from water pipelines.",
            options: ["Sediment", "Water", "Air", "Silt"],
            correctAnswer: "Air",
            explanation: "Air relief valves are used to discharge Air from water pipelines."
          }
        ]
      },
      {
        id: 3,
        title: "Water treatment process and technologies",
        description: "Various treatment process and their purposes; screening; plain sedimentation; sedimentation with coagulation; flocculation; filtration; disinfection; softening; and miscellaneous treatments (aeration, removal of iron and manganese, removal of color/odour/taste).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Membrane filter technique is a better test to identify ___.",
            options: ["Viruses", "Coliforms", "Protozoa", "Algae"],
            correctAnswer: "Coliforms",
            explanation: "Membrane filter technique is a better test to identify Coliforms."
          },
          {
            id: 2,
            question: "The rate of filtration in rapid sand filtration is ___ l/hr/m².",
            options: ["100 to 200", "500 to 1000", "3000 to 6000", "10000 to 15000"],
            correctAnswer: "3000 to 6000",
            explanation: "The rate of filtration in rapid sand filtration is 3000 to 6000 l/hr/m²."
          },
          {
            id: 3,
            question: "In a slow sand filter, the thickness of sand bed is ___ cm.",
            options: ["30 to 50", "60 to 80", "90 to 110", "120 to 150"],
            correctAnswer: "90 to 110",
            explanation: "In a slow sand filter, the thickness of sand bed is 90 to 110 cm."
          },
          {
            id: 4,
            question: "The permissible limit of free residual chlorine is ___ ppm.",
            options: ["0.1", "0.2", "0.5", "1.0"],
            correctAnswer: "0.2",
            explanation: "The permissible limit of free residual chlorine is 0.2 ppm."
          },
          {
            id: 5,
            question: "Surface overflow rate (SOR) of plain sedimentation tank is ___ lit/day/m².",
            options: ["5000 to 10000", "12000 to 18000", "20000 to 30000", "35000 to 50000"],
            correctAnswer: "12000 to 18000",
            explanation: "Surface overflow rate (SOR) of plain sedimentation tank is 12000 to 18000 lit/day/m²."
          },
          {
            id: 6,
            question: "Vacuum filters are used for ___.",
            options: ["Aeration", "Dewatering of sludge", "Disinfection", "Coagulation"],
            correctAnswer: "Dewatering of sludge",
            explanation: "Vacuum filters are used for Dewatering of sludge."
          },
          {
            id: 7,
            question: "Which is NOT used as media for trickling filters?",
            options: ["Rock", "Plastic", "Paper", "Slag"],
            correctAnswer: "Paper",
            explanation: "Paper is the correct answer."
          },
          {
            id: 8,
            question: "Short-circuiting occurring in a sedimentation tank is represented by ___.",
            options: ["Overflow rate", "Displacement efficiency", "Retention time", "Settling velocity"],
            correctAnswer: "Displacement efficiency",
            explanation: "Short-circuiting occurring in a sedimentation tank is represented by Displacement efficiency."
          },
          {
            id: 9,
            question: "Hydraulic loading for a high rate trickling filter varies between ___ ML per hectare per day.",
            options: ["50 to 100", "110 to 330", "400 to 600", "700 to 900"],
            correctAnswer: "110 to 330",
            explanation: "Hydraulic loading for a high rate trickling filter varies between 110 to 330 ML per hectare per day."
          },
          {
            id: 10,
            question: "Rate of filtration in rapid sand filtration is ___ l/hr/m².",
            options: ["100 to 200", "500 to 1000", "3000 to 6000", "10000 to 15000"],
            correctAnswer: "3000 to 6000",
            explanation: "Rate of filtration in rapid sand filtration is 3000 to 6000 l/hr/m²."
          },
          {
            id: 11,
            question: "In a slow sand filter, thickness of sand bed is ___ cm.",
            options: ["30 to 50", "60 to 80", "90 to 110", "120 to 150"],
            correctAnswer: "90 to 110",
            explanation: "In a slow sand filter, thickness of sand bed is 90 to 110 cm."
          },
          {
            id: 12,
            question: "Permissible limit of free residual chlorine is ___ ppm.",
            options: ["0.1", "0.2", "0.5", "1.0"],
            correctAnswer: "0.2",
            explanation: "Permissible limit of free residual chlorine is 0.2 ppm."
          },
          {
            id: 13,
            question: "In filtration, amount of dissolved solid passing through filters is the difference between total solid and ___.",
            options: ["Volatile solid", "Fixed solid", "Suspended solid", "Colloidal solid"],
            correctAnswer: "Suspended solid",
            explanation: "In filtration, amount of dissolved solid passing through filters is the difference between total solid and Suspended solid."
          },
          {
            id: 14,
            question: "Effluent from a high rate trickling filter is ___ and not fully oxidized.",
            options: ["Clear", "Brown", "Black", "White"],
            correctAnswer: "Brown",
            explanation: "Effluent from a high rate trickling filter is Brown and not fully oxidized."
          }
        ]
      },
      {
        id: 4,
        title: "Design and construction of sewers",
        description: "Estimation of quantity of waste water; sewerage system and types; design criteria of sewers; shapes of sewers; sewer materials; design of sewers for separate and combined systems; construction of sewers and sewer appurtenances.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "If a circular sewer is partially full and depth is increased, then wetted ___ increases.",
            options: ["Area", "Perimeter", "Velocity", "Depth"],
            correctAnswer: "Perimeter",
            explanation: "If a circular sewer is partially full and depth is increased, then wetted Perimeter increases."
          },
          {
            id: 2,
            question: "Inverted siphon (Depressed Sewer) is provided when a sewer ___ a river.",
            options: ["Runs parallel to", "Crosses", "Runs away from", "Enters"],
            correctAnswer: "Crosses",
            explanation: "Inverted siphon (Depressed Sewer) is provided when a sewer Crosses a river."
          },
          {
            id: 3,
            question: "The cover of manhole is made by ___ iron.",
            options: ["Wrought", "Cast", "Galvanized", "Stainless"],
            correctAnswer: "Cast",
            explanation: "The cover of manhole is made by Cast iron."
          },
          {
            id: 4,
            question: "Inverted siphon (depressed sewer) is provided when a sewer ___.",
            options: ["Runs parallel to a river", "Crosses a river", "Enters a river", "Runs away from a river"],
            correctAnswer: "Crosses a river",
            explanation: "Inverted siphon (depressed sewer) is provided when a sewer Crosses a river."
          },
          {
            id: 5,
            question: "A manhole is classified as shallow if its depth is between ___ m.",
            options: ["0.3 to 0.5", "0.5 to 0.7", "0.7 to 0.9", "1.0 to 1.2"],
            correctAnswer: "0.7 to 0.9",
            explanation: "A manhole is classified as shallow if its depth is between 0.7 to 0.9 m."
          },
          {
            id: 6,
            question: "Inverted syphon sewer is also called ___ sewer.",
            options: ["Interceptor", "Depressed", "Main", "Outfall"],
            correctAnswer: "Depressed",
            explanation: "Inverted syphon sewer is also called Depressed sewer."
          },
          {
            id: 7,
            question: "Slope of a sewer is given in the direction of ___ of ground.",
            options: ["Flattest slope", "Natural slope", "Steepest slope", "Reverse slope"],
            correctAnswer: "Natural slope",
            explanation: "Slope of a sewer is given in the direction of Natural slope of ground."
          },
          {
            id: 8,
            question: "Intercepting sewer is the sewer that collects water from ___.",
            options: ["A single outlet", "A number of lateral sewers or outlets", "Storm drains only", "House drains only"],
            correctAnswer: "A number of lateral sewers or outlets",
            explanation: "Intercepting sewer is the sewer that collects water from A number of lateral sewers or outlets."
          },
          {
            id: 9,
            question: "The cover of manhole is made of ___.",
            options: ["RCC", "PVC", "Cast iron", "Aluminum"],
            correctAnswer: "Cast iron",
            explanation: "The cover of manhole is made of Cast iron."
          },
          {
            id: 10,
            question: "Manhole covers are generally made circular to prevent ___.",
            options: ["Heat loss", "Falling of cover into the manhole", "Corrosion", "Rusting"],
            correctAnswer: "Falling of cover into the manhole",
            explanation: "Manhole covers are generally made circular to prevent Falling of cover into the manhole."
          }
        ]
      },
      {
        id: 5,
        title: "Treatment and disposal of wastewater",
        description: "Characteristics and examination of sewage; decomposition of wastewater; BOD and COD; primary treatment processes and design of grit chamber; secondary or biological treatment process; sewage filtration; activated sludge process; oxidation ponds; waste water disposal by dilution (oxygen sag curve; Streeter Phelp's equation); waste water disposal by land treatment; sludge and solid waste disposal methods; latrine and septic tank.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The velocity of flow of sewage in a combined sewer should not be less than ___ m/s.",
            options: ["0.45", "0.60", "0.75", "1.00"],
            correctAnswer: "0.75",
            explanation: "The velocity of flow of sewage in a combined sewer should not be less than 0.75 m/s."
          },
          {
            id: 2,
            question: "The detention time for septic tank is ___ hours.",
            options: ["12", "16", "24", "48"],
            correctAnswer: "24",
            explanation: "The detention time for septic tank is 24 hours."
          },
          {
            id: 3,
            question: "The pH value of fresh sewage is usually ___ 7.",
            options: ["Less than", "Equal to", "More than", "Independent of"],
            correctAnswer: "More than",
            explanation: "The pH value of fresh sewage is usually More than 7."
          },
          {
            id: 4,
            question: "The minimum amount of DO required for the life survival of aquatic animals is ___ mg/l.",
            options: ["1", "2", "4", "8"],
            correctAnswer: "4",
            explanation: "The minimum amount of DO required for the life survival of aquatic animals is 4 mg/l."
          },
          {
            id: 5,
            question: "The minimum depth of septic tank as per design consideration is ___ m.",
            options: ["0.9", "1.0", "1.2", "1.5"],
            correctAnswer: "1.2",
            explanation: "The minimum depth of septic tank as per design consideration is 1.2 m."
          },
          {
            id: 6,
            question: "The oxygen sag curve was developed by ___ method.",
            options: ["Phelps-Streeter", "Streeter Phelps", "Mancini", "Edwards"],
            correctAnswer: "Streeter Phelps",
            explanation: "The oxygen sag curve was developed by Streeter Phelps method."
          },
          {
            id: 7,
            question: "Activated sludge process is an example of aerobic ___ growth process.",
            options: ["Attached", "Fixed film", "Suspended", "Trickling"],
            correctAnswer: "Suspended",
            explanation: "Activated sludge process is an example of aerobic Suspended growth process."
          },
          {
            id: 8,
            question: "The value of ratio of BOD/COD of domestic wastewater before treatment is ___.",
            options: ["0.1 to 0.3", "0.3 to 0.8", "1.0 to 1.5", "2.0 to 3.0"],
            correctAnswer: "0.3 to 0.8",
            explanation: "The value of ratio of BOD/COD of domestic wastewater before treatment is 0.3 to 0.8."
          },
          {
            id: 9,
            question: "The minimum width of toilet door is ___ mm.",
            options: ["600", "650", "700", "750"],
            correctAnswer: "750",
            explanation: "The minimum width of toilet door is 750 mm."
          },
          {
            id: 10,
            question: "Fresh sewage is generally ___.",
            options: ["Neutral", "Acidic", "Alkaline", "Salty"],
            correctAnswer: "Alkaline",
            explanation: "Fresh sewage is generally Alkaline."
          },
          {
            id: 11,
            question: "Grit is an inert matter of specific gravity ___.",
            options: ["1.50", "2.00", "2.65", "3.00"],
            correctAnswer: "2.65",
            explanation: "Grit is an inert matter of specific gravity 2.65."
          },
          {
            id: 12,
            question: "___ is a wastewater that comes from kitchen, washing places and wash basin.",
            options: ["Night soil", "Sewage", "Sullage", "Effluent"],
            correctAnswer: "Sullage",
            explanation: "Sullage is a wastewater that comes from kitchen, washing places and wash basin."
          },
          {
            id: 13,
            question: "The minimum size of grit particles that can be removed in grit chamber is ___ mm.",
            options: ["0.10", "0.15", "0.20", "0.30"],
            correctAnswer: "0.20",
            explanation: "The minimum size of grit particles that can be removed in grit chamber is 0.20 mm."
          },
          {
            id: 14,
            question: "COD/BOD ratio of treated domestic sewage is ___.",
            options: ["0.5–1.0", "1.0–1.25", "1.25–2.5", "3.0–4.0"],
            correctAnswer: "1.25–2.5",
            explanation: "COD/BOD ratio of treated domestic sewage is 1.25–2.5."
          },
          {
            id: 15,
            question: "The diameter of vent pipe used in VIP latrine is ___ mm.",
            options: ["25", "40", "50", "75"],
            correctAnswer: "50",
            explanation: "The diameter of vent pipe used in VIP latrine is 50 mm."
          },
          {
            id: 16,
            question: "Livestock demand should not exceed ___ % of total domestic demand.",
            options: ["10", "15", "20", "25"],
            correctAnswer: "20",
            explanation: "Livestock demand should not exceed 20 % of total domestic demand."
          },
          {
            id: 17,
            question: "The velocity at which particles settle down is ___ m/s.",
            options: ["0.1", "0.2", "0.3", "0.5"],
            correctAnswer: "0.3",
            explanation: "The velocity at which particles settle down is 0.3 m/s."
          },
          {
            id: 18,
            question: "Dissolved oxygen is ___ significantly affected by chlorination in water.",
            options: ["Significantly", "Strongly", "Not", "Always"],
            correctAnswer: "Not",
            explanation: "Dissolved oxygen is Not significantly affected by chlorination in water."
          },
          {
            id: 19,
            question: "Velocity of flow of sewage in a combined sewer should not be less than ___ m/s.",
            options: ["0.45", "0.60", "0.75", "1.00"],
            correctAnswer: "0.75",
            explanation: "Velocity of flow of sewage in a combined sewer should not be less than 0.75 m/s."
          },
          {
            id: 20,
            question: "In finding fixed inorganic solid in sludge, temperature used is ___°C ± 50 for 15 minutes.",
            options: ["350", "450", "550", "650"],
            correctAnswer: "550",
            explanation: "In finding fixed inorganic solid in sludge, temperature used is 550°C ± 50 for 15 minutes."
          },
          {
            id: 21,
            question: "Detention period in a septic tank is assumed ___.",
            options: ["10 minutes", "20 minutes", "30 minutes", "60 minutes"],
            correctAnswer: "30 minutes",
            explanation: "Detention period in a septic tank is assumed 30 minutes."
          },
          {
            id: 22,
            question: "Minimum DO required for life survival of aquatic animals is ___ mg/l.",
            options: ["1", "2", "4", "8"],
            correctAnswer: "4",
            explanation: "Minimum DO required for life survival of aquatic animals is 4 mg/l."
          },
          {
            id: 23,
            question: "Minimum depth of septic tank as per design consideration is ___ m.",
            options: ["0.9", "1.0", "1.2", "1.5"],
            correctAnswer: "1.2",
            explanation: "Minimum depth of septic tank as per design consideration is 1.2 m."
          },
          {
            id: 24,
            question: "Ratio of BOD/COD of domestic wastewater before treatment is ___.",
            options: ["0.1 to 0.3", "0.3 to 0.8", "1.0 to 1.5", "2.0 to 3.0"],
            correctAnswer: "0.3 to 0.8",
            explanation: "Ratio of BOD/COD of domestic wastewater before treatment is 0.3 to 0.8."
          },
          {
            id: 25,
            question: "Minimum width of toilet door is ___ mm.",
            options: ["600", "650", "700", "750"],
            correctAnswer: "750",
            explanation: "Minimum width of toilet door is 750 mm."
          },
          {
            id: 26,
            question: "Sullage is wastewater that comes from ___.",
            options: ["Toilets", "Kitchen, washing places and wash basin", "Storm drains", "Industrial units"],
            correctAnswer: "Kitchen, washing places and wash basin",
            explanation: "Sullage is wastewater that comes from Kitchen, washing places and wash basin."
          },
          {
            id: 27,
            question: "___ is NOT the characteristic of hazardous waste.",
            options: ["Toxicity", "Reactivity", "Degradable", "Ignitability"],
            correctAnswer: "Degradable",
            explanation: "Degradable is NOT the characteristic of hazardous waste."
          },
          {
            id: 28,
            question: "Minimum size of grit particles that can be removed in grit chamber is ___ mm.",
            options: ["0.10", "0.15", "0.20", "0.30"],
            correctAnswer: "0.20",
            explanation: "Minimum size of grit particles that can be removed in grit chamber is 0.20 mm."
          },
          {
            id: 29,
            question: "In which phase is detailed risk analysis done?",
            options: ["Response phase", "Recovery phase", "Planning phase", "Implementation phase"],
            correctAnswer: "Planning phase",
            explanation: "Planning phase is the correct answer."
          },
          {
            id: 30,
            question: "COD/BOD ratio of detreated domestic sewage is ___.",
            options: ["0.5-1.0", "1.0-1.25", "1.25-2.5", "2.5-3.5"],
            correctAnswer: "1.25-2.5",
            explanation: "COD/BOD ratio of detreated domestic sewage is 1.25-2.5."
          },
          {
            id: 31,
            question: "The sewer used to convey wastewater from one or more lateral sewer is ___ sewer.",
            options: ["Lateral", "Main", "Branch", "Trunk"],
            correctAnswer: "Main",
            explanation: "The sewer used to convey wastewater from one or more lateral sewer is Main sewer."
          },
          {
            id: 32,
            question: "Presence of free ammonia in wastewater represents ___.",
            options: ["Undecomposed organic matter", "Oxidized nitrogen", "Heavy metals", "High alkalinity"],
            correctAnswer: "Undecomposed organic matter",
            explanation: "Presence of free ammonia in wastewater represents Undecomposed organic matter."
          },
          {
            id: 33,
            question: "Disposal of hazardous waste should not be done directly at ___.",
            options: ["Treatment plants", "Incinerators", "Dumping", "Recycling centers"],
            correctAnswer: "Dumping",
            explanation: "Disposal of hazardous waste should not be done directly at Dumping."
          },
          {
            id: 34,
            question: "Diameter of vent pipe used in VIP latrine is ___ mm.",
            options: ["25", "50", "75", "100"],
            correctAnswer: "50",
            explanation: "Diameter of vent pipe used in VIP latrine is 50 mm."
          },
          {
            id: 35,
            question: "Self-purification process does NOT depend upon ___.",
            options: ["Temperature", "Dissolved oxygen", "Aquatic species", "Velocity of stream"],
            correctAnswer: "Aquatic species",
            explanation: "Self-purification process does NOT depend upon Aquatic species."
          }
        ]
      },
      {
        id: 6,
        title: "Concept of environmental assessment",
        description: "BES; IEE; EIA; government's act, rules/regulations/procedures for BES/IEE/EIA; Types of disaster and its mitigation.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "EIA is a systematic process used to evaluate the ___ consequences of a proposed project.",
            options: ["Social", "Economic", "Environmental", "Political"],
            correctAnswer: "Environmental",
            explanation: "EIA is a systematic process used to evaluate the Environmental consequences of a proposed project."
          },
          {
            id: 2,
            question: "The first environmental act introduced in Nepal was in ___.",
            options: ["1990", "1993", "1997", "2000"],
            correctAnswer: "1997",
            explanation: "The first environmental act introduced in Nepal was in 1997."
          },
          {
            id: 3,
            question: "The first step involving in EIA is ___.",
            options: ["Screening", "Scoping", "Impact prediction", "Monitoring"],
            correctAnswer: "Scoping",
            explanation: "The first step involving in EIA is Scoping."
          },
          {
            id: 4,
            question: "The egg shaped sewer is best preferred on ___ system.",
            options: ["Separate", "Storm", "Combined", "Gravity"],
            correctAnswer: "Combined",
            explanation: "The egg shaped sewer is best preferred on Combined system."
          },
          {
            id: 5,
            question: "Definition of mitigation in risk management is the implementation of strategies to ___.",
            options: ["Increase the risk", "Reduce the impact or likelihood of identified risks", "Eliminate all risks", "Transfer the risk"],
            correctAnswer: "Reduce the impact or likelihood of identified risks",
            explanation: "Definition of mitigation in risk management is the implementation of strategies to Reduce the impact or likelihood of identified risks."
          },
          {
            id: 6,
            question: "Vulnerability analysis comes in which part of the Disaster Management Cycle?",
            options: ["Preparedness", "Response", "Mitigation", "Recovery"],
            correctAnswer: "Mitigation",
            explanation: "Mitigation is the correct answer."
          },
          {
            id: 7,
            question: "Mitigation denotes reduction of risk to a ___ level.",
            options: ["Zero", "Maximum", "Threshold", "Critical"],
            correctAnswer: "Threshold",
            explanation: "Mitigation denotes reduction of risk to a Threshold level."
          },
          {
            id: 8,
            question: "The first environmental act in Nepal was introduced in ___.",
            options: ["1990", "1995", "1997", "2000"],
            correctAnswer: "1997",
            explanation: "The first environmental act in Nepal was introduced in 1997."
          },
          {
            id: 9,
            question: "Which ministry is related to National Disaster and risk management?",
            options: ["Ministry of Finance", "Ministry of Home Affairs", "Ministry of Education", "Ministry of Health"],
            correctAnswer: "Ministry of Home Affairs",
            explanation: "Ministry of Home Affairs is the correct answer."
          },
          {
            id: 10,
            question: "The first step involved in EIA is ___.",
            options: ["Screening", "Scoping", "Review", "Monitoring"],
            correctAnswer: "Scoping",
            explanation: "The first step involved in EIA is Scoping."
          },
          {
            id: 11,
            question: "Full form of BES in Environment Study is ___.",
            options: ["Basic Environment Studies", "Brief Environment Studies", "Broad Environment Standards", "Best Environment Standards"],
            correctAnswer: "Brief Environment Studies",
            explanation: "Full form of BES in Environment Study is Brief Environment Studies."
          },
          {
            id: 12,
            question: "All relevant stakeholder's concerns being incorporated is ___ in EIA report.",
            options: ["Always included", "Not included", "Optional", "Required to be excluded"],
            correctAnswer: "Not included",
            explanation: "All relevant stakeholder's concerns being incorporated is Not included in EIA report."
          },
          {
            id: 13,
            question: "The egg shaped sewer is best preferred for ___ sewer system.",
            options: ["Separate", "Storm", "Combined", "Sanitary"],
            correctAnswer: "Combined",
            explanation: "The egg shaped sewer is best preferred for Combined sewer system."
          }
        ]
      }
    ]
  },
  {
    id: 7,
    title: "Irrigation and Drainage",
    code: "ACiE07",
    topics: [
      {
        id: 1,
        title: "Water demand estimation",
        description: "Crop water and irrigation water requirements; water availability for irrigation; command areas; irrigation intensity; duty, delta and their relationship; water losses and irrigation efficiencies; effective rainfall; soil-moisture-irrigation relationship; depth and frequency of irrigation; design discharge for canals.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "As the duration of unit hydrograph increases then base period ___.",
            options: ["Decreases", "Remains same", "Increases", "Becomes zero"],
            correctAnswer: "Increases",
            explanation: "As the duration of unit hydrograph increases then base period Increases."
          },
          {
            id: 2,
            question: "As the duration of unit hydrograph increases, base period ___.",
            options: ["Decreases", "Remains same", "Increases", "Fluctuates"],
            correctAnswer: "Increases",
            explanation: "As the duration of unit hydrograph increases, base period Increases."
          },
          {
            id: 3,
            question: "The ratio of irrigated area under Rabi and Kharif crops is ___.",
            options: ["1", "1.5", "2", "3"],
            correctAnswer: "2",
            explanation: "The ratio of irrigated area under Rabi and Kharif crops is 2."
          },
          {
            id: 4,
            question: "The crop period is time period that elapses from the instant of its sowing to its ___.",
            options: ["Flowering", "Germination", "Harvesting", "Irrigation"],
            correctAnswer: "Harvesting",
            explanation: "The crop period is time period that elapses from the instant of its sowing to its Harvesting."
          },
          {
            id: 5,
            question: "___ crops requires maximum water per hectare for production.",
            options: ["Wheat", "Rice", "Cotton", "Sugarcane"],
            correctAnswer: "Sugarcane",
            explanation: "Sugarcane crops requires maximum water per hectare for production."
          },
          {
            id: 6,
            question: "Duty is maximum ___ on the field.",
            options: ["At head of canal", "At tail of canal", "On the field", "In main canal"],
            correctAnswer: "On the field",
            explanation: "Duty is maximum On the field on the field."
          },
          {
            id: 7,
            question: "The consumptive use in terms of losses are evaporation and ___.",
            options: ["Seepage", "Runoff", "Transpiration", "Deep percolation"],
            correctAnswer: "Transpiration",
            explanation: "The consumptive use in terms of losses are evaporation and Transpiration."
          },
          {
            id: 8,
            question: "Irrigation Interval means ___ of irrigation.",
            options: ["Duration", "Frequency", "Volume", "Depth"],
            correctAnswer: "Frequency",
            explanation: "Irrigation Interval means Frequency of irrigation."
          },
          {
            id: 9,
            question: "The purpose of providing free board is stability against overtopping and safety against ___ crack.",
            options: ["Shear", "Tension", "Frost", "Seismic"],
            correctAnswer: "Frost",
            explanation: "The purpose of providing free board is stability against overtopping and safety against Frost crack."
          },
          {
            id: 10,
            question: "The ratio of base period to delta is ___.",
            options: ["Intensity", "Duty", "Outfall factor", "Crop coefficient"],
            correctAnswer: "Duty",
            explanation: "The ratio of base period to delta is Duty."
          },
          {
            id: 11,
            question: "Crop period is the time period that elapses from instant of ___ to harvesting.",
            options: ["Irrigation", "Sowing", "Germination", "Flowering"],
            correctAnswer: "Sowing",
            explanation: "Crop period is the time period that elapses from instant of Sowing to harvesting."
          },
          {
            id: 12,
            question: "Among common crops, ___ requires the highest water for growth (greatest base period water need).",
            options: ["Wheat", "Maize", "Rice", "Barley"],
            correctAnswer: "Rice",
            explanation: "Among common crops, Rice requires the highest water for growth (greatest base period water need)."
          },
          {
            id: 13,
            question: "Duty is maximum ___.",
            options: ["At the head of canal", "At the outlet", "On the field", "At the reservoir"],
            correctAnswer: "On the field",
            explanation: "Duty is maximum On the field."
          },
          {
            id: 14,
            question: "Which crop requires maximum water per hectare for production?",
            options: ["Wheat", "Sugarcane", "Maize", "Barley"],
            correctAnswer: "Sugarcane",
            explanation: "Sugarcane is the correct answer."
          },
          {
            id: 15,
            question: "Gravity water is water which flows under ___.",
            options: ["Pressure", "Gravity", "Capillary action", "Suction"],
            correctAnswer: "Gravity",
            explanation: "Gravity water is water which flows under Gravity."
          },
          {
            id: 16,
            question: "___ water is usable to plants.",
            options: ["Gravity", "Capillary", "Hygroscopic", "Free"],
            correctAnswer: "Capillary",
            explanation: "Capillary water is usable to plants."
          },
          {
            id: 17,
            question: "Water available for plants is defined as ___.",
            options: ["FC only", "PWP only", "FC − PWP", "FC + PWP"],
            correctAnswer: "FC − PWP",
            explanation: "Water available for plants is defined as FC − PWP."
          },
          {
            id: 18,
            question: "Weight of capillary water is held by ___.",
            options: ["Gravity", "Surface tension", "Atmospheric pressure", "Osmotic pressure"],
            correctAnswer: "Surface tension",
            explanation: "Weight of capillary water is held by Surface tension."
          },
          {
            id: 19,
            question: "Field capacity of soil depends upon capillary tension in soil and ___ of soil.",
            options: ["Density", "Porosity", "Color", "Texture"],
            correctAnswer: "Porosity",
            explanation: "Field capacity of soil depends upon capillary tension in soil and Porosity of soil."
          },
          {
            id: 20,
            question: "Available moisture is defined as the difference in water content of soil between field capacity and ___.",
            options: ["Saturation point", "Permanent wilting point", "Optimum moisture content", "Liquid limit"],
            correctAnswer: "Permanent wilting point",
            explanation: "Available moisture is defined as the difference in water content of soil between field capacity and Permanent wilting point."
          },
          {
            id: 21,
            question: "Consumptive use in terms of losses includes ___.",
            options: ["Evaporation and percolation", "Evaporation and transpiration", "Transpiration only", "Seepage and runoff"],
            correctAnswer: "Evaporation and transpiration",
            explanation: "Consumptive use in terms of losses includes Evaporation and transpiration."
          },
          {
            id: 22,
            question: "Farm pond is used for ___.",
            options: ["Irrigation discharge measurement", "Water storage", "Drainage", "Flood control"],
            correctAnswer: "Water storage",
            explanation: "Farm pond is used for Water storage."
          },
          {
            id: 23,
            question: "Irrigation interval is determined by field capacity to ___.",
            options: ["Available moisture", "Maximum crop water requirement", "Wilting point", "Permanent storage"],
            correctAnswer: "Maximum crop water requirement",
            explanation: "Irrigation interval is determined by field capacity to Maximum crop water requirement."
          },
          {
            id: 24,
            question: "Aggrading river/channel is undergoing ___.",
            options: ["Scouring", "Silting", "Erosion", "Degradation"],
            correctAnswer: "Silting",
            explanation: "Aggrading river/channel is undergoing Silting."
          },
          {
            id: 25,
            question: "Due to lined channel section, command area ___.",
            options: ["Decreases", "Remains same", "Increases", "Fluctuates"],
            correctAnswer: "Increases",
            explanation: "Due to lined channel section, command area Increases."
          },
          {
            id: 26,
            question: "Purpose of providing freeboard is stability against overtopping and safety against ___.",
            options: ["Erosion", "Frost crack", "Corrosion", "Seepage"],
            correctAnswer: "Frost crack",
            explanation: "Purpose of providing freeboard is stability against overtopping and safety against Frost crack."
          },
          {
            id: 27,
            question: "Placement of intake is NOT optimal when placed in ___.",
            options: ["Main river only", "Natural channel and navigation channel", "Reservoir", "Spring"],
            correctAnswer: "Natural channel and navigation channel",
            explanation: "Placement of intake is NOT optimal when placed in Natural channel and navigation channel."
          },
          {
            id: 28,
            question: "The problem in Nepal for artificial channels is formation of ___ soil.",
            options: ["Lateritic", "Alluvial", "Clayey", "Sandy"],
            correctAnswer: "Alluvial",
            explanation: "The problem in Nepal for artificial channels is formation of Alluvial soil."
          },
          {
            id: 29,
            question: "Sediments that are rolling, sliding and bouncing are called ___ load.",
            options: ["Suspended", "Wash", "Bed", "Total"],
            correctAnswer: "Bed",
            explanation: "Sediments that are rolling, sliding and bouncing are called Bed load."
          },
          {
            id: 30,
            question: "If B is formation width and depth y with slope s:1, area of cross section is ___.",
            options: ["Bd + sd", "Bd + sd²", "Bd² + sd", "B + sd²"],
            correctAnswer: "Bd + sd²",
            explanation: "If B is formation width and depth y with slope s:1, area of cross section is Bd + sd²."
          },
          {
            id: 31,
            question: "Garret's diagrams are based on ___ theory.",
            options: ["Lacey's", "Kennedy's", "Manning's", "Chezy's"],
            correctAnswer: "Kennedy's",
            explanation: "Garret's diagrams are based on Kennedy's theory."
          },
          {
            id: 32,
            question: "Triangular section lining is adopted when discharge in the channel is ___.",
            options: ["> 85 cumecs", "< 85 cumecs", "= 85 cumecs", "Independent of discharge"],
            correctAnswer: "< 85 cumecs",
            explanation: "Triangular section lining is adopted when discharge in the channel is < 85 cumecs."
          },
          {
            id: 33,
            question: "Fish ladder is provided on the side of ___.",
            options: ["Main weir", "Under sluice", "Divide wall", "Guide bank"],
            correctAnswer: "Divide wall",
            explanation: "Fish ladder is provided on the side of Divide wall."
          },
          {
            id: 34,
            question: "Divide wall is used to separate the under sluice portion from the ___ portion.",
            options: ["Secondary", "Head works", "Main weir", "Spillway"],
            correctAnswer: "Main weir",
            explanation: "Divide wall is used to separate the under sluice portion from the Main weir portion."
          },
          {
            id: 35,
            question: "A quantum of discharge with high enough magnitude and frequency to bring changes to river boundary is called ___ discharge.",
            options: ["Bank-full", "Dominant", "Peak", "Design"],
            correctAnswer: "Dominant",
            explanation: "A quantum of discharge with high enough magnitude and frequency to bring changes to river boundary is called Dominant discharge."
          },
          {
            id: 36,
            question: "Uplifting pressure is important for the stability of ___.",
            options: ["Earthen dam", "Concrete dam", "Rockfill dam", "Gravity weir only"],
            correctAnswer: "Concrete dam",
            explanation: "Uplifting pressure is important for the stability of Concrete dam."
          },
          {
            id: 37,
            question: "Number of considerations governing depth of downstream vertical cutoff is ___.",
            options: ["1", "2", "3", "4"],
            correctAnswer: "2",
            explanation: "Number of considerations governing depth of downstream vertical cutoff is 2."
          },
          {
            id: 38,
            question: "Guide banks are provided to train the flow of a river along a ___.",
            options: ["Natural course", "Specified course", "Straight line only", "Meandering path"],
            correctAnswer: "Specified course",
            explanation: "Guide banks are provided to train the flow of a river along a Specified course."
          },
          {
            id: 39,
            question: "Length of upstream guide bank is ___ length of downstream guide bank.",
            options: ["Less than", "Equal to", "Greater than", "Independent of"],
            correctAnswer: "Greater than",
            explanation: "Length of upstream guide bank is Greater than length of downstream guide bank."
          },
          {
            id: 40,
            question: "Sensitivity of a rigid module is ___.",
            options: ["One", "Infinity", "Negative", "Zero"],
            correctAnswer: "Zero",
            explanation: "Sensitivity of a rigid module is Zero."
          },
          {
            id: 41,
            question: "An outlet is said to be proportional if its flexibility is equal to ___.",
            options: ["Zero", "0.5", "Unity", "Infinity"],
            correctAnswer: "Unity",
            explanation: "An outlet is said to be proportional if its flexibility is equal to Unity."
          },
          {
            id: 42,
            question: "Saline soil can be improved by ___.",
            options: ["Compaction", "Lime treatment", "Leaching", "Cement stabilization"],
            correctAnswer: "Leaching",
            explanation: "Saline soil can be improved by Leaching."
          },
          {
            id: 43,
            question: "Irregular topography depends upon depressions of terrain and causes ___.",
            options: ["Erosion", "Water logging", "Drought", "Subsidence"],
            correctAnswer: "Water logging",
            explanation: "Irregular topography depends upon depressions of terrain and causes Water logging."
          },
          {
            id: 44,
            question: "Tile drainage helps to increase crop yields by ___.",
            options: ["Decreasing soil volume", "Increasing volume of soil available for roots", "Reducing irrigation need", "Increasing salinity"],
            correctAnswer: "Increasing volume of soil available for roots",
            explanation: "Tile drainage helps to increase crop yields by Increasing volume of soil available for roots."
          },
          {
            id: 45,
            question: "Tile drainage should NOT be placed under ___ strata.",
            options: ["Pervious", "Less pervious", "Sandy", "Gravel"],
            correctAnswer: "Less pervious",
            explanation: "Tile drainage should NOT be placed under Less pervious strata."
          },
          {
            id: 46,
            question: "A tile drain is suitable for ___ soil.",
            options: ["Dry", "Wet", "Rocky", "Sandy"],
            correctAnswer: "Wet",
            explanation: "A tile drain is suitable for Wet soil."
          },
          {
            id: 47,
            question: "Spacing of tile drains to relieve water-logged land is directly proportional to coefficient of ___ of the soil.",
            options: ["Compressibility", "Cohesion", "Permeability", "Consolidation"],
            correctAnswer: "Permeability",
            explanation: "Spacing of tile drains to relieve water-logged land is directly proportional to coefficient of Permeability of the soil."
          },
          {
            id: 48,
            question: "The method using dead furrows on cropped farms for drainage of excess irrigation/rain water is called ___.",
            options: ["Leaching", "Bedding", "Ridging", "Contouring"],
            correctAnswer: "Bedding",
            explanation: "The method using dead furrows on cropped farms for drainage of excess irrigation/rain water is called Bedding."
          },
          {
            id: 49,
            question: "Top soil of a waterlogged field becomes more alkaline and infertile if its pH value is ___.",
            options: ["7", "9", "11", "13"],
            correctAnswer: "11",
            explanation: "Top soil of a waterlogged field becomes more alkaline and infertile if its pH value is 11."
          },
          {
            id: 50,
            question: "River reach can be classified on the basis of ___.",
            options: ["Width", "Origin", "Depth", "Slope only"],
            correctAnswer: "Origin",
            explanation: "River reach can be classified on the basis of Origin."
          },
          {
            id: 51,
            question: "Soil becomes infertile when waterlogged due to ___.",
            options: ["Nutrient enrichment", "Growing of weeds", "Increased aeration", "Reduced salinity"],
            correctAnswer: "Growing of weeds",
            explanation: "Soil becomes infertile when waterlogged due to Growing of weeds."
          },
          {
            id: 52,
            question: "Ratio of irrigated area under Rabi and Kharif crops is ___.",
            options: ["1", "1.5", "2", "2.5"],
            correctAnswer: "2",
            explanation: "Ratio of irrigated area under Rabi and Kharif crops is 2."
          },
          {
            id: 53,
            question: "Crest of under sluice portion of diversion head works is kept at ___ level of river.",
            options: ["Flood", "Full supply", "Bed", "Top"],
            correctAnswer: "Bed",
            explanation: "Crest of under sluice portion of diversion head works is kept at Bed level of river."
          },
          {
            id: 54,
            question: "Kor watering in irrigation is defined as the ___ watering given to a crop when the crop is a few cm high.",
            options: ["Last", "Second", "First", "Third"],
            correctAnswer: "First",
            explanation: "Kor watering in irrigation is defined as the First watering given to a crop when the crop is a few cm high."
          },
          {
            id: 55,
            question: "The discharge value of water is controlled by ___.",
            options: ["Weirs", "Regulators", "Gates only", "Spillways"],
            correctAnswer: "Regulators",
            explanation: "The discharge value of water is controlled by Regulators."
          },
          {
            id: 56,
            question: "Sewage sickness occurs when voids of soil get clogged due to ___ application of sewage on a piece of land.",
            options: ["Intermittent", "Continuous", "Minimal", "Seasonal"],
            correctAnswer: "Continuous",
            explanation: "Sewage sickness occurs when voids of soil get clogged due to Continuous application of sewage on a piece of land."
          }
        ]
      },
      {
        id: 2,
        title: "Design of canals",
        description: "Canal types, network and alignment; tractive force approach of canal design; design of stable canals, alluvial canals (Kennedy's and Lacey's theory), and lined canals.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Canal normally used for diversion of flood water of a river is ___ canal.",
            options: ["Link", "Feeder", "Main", "Inundation"],
            correctAnswer: "Inundation",
            explanation: "Canal normally used for diversion of flood water of a river is Inundation canal."
          },
          {
            id: 2,
            question: "The silting in the channel causes ___ in discharge.",
            options: ["Increase", "No change", "Decrease", "Fluctuation"],
            correctAnswer: "Decrease",
            explanation: "The silting in the channel causes Decrease in discharge."
          },
          {
            id: 3,
            question: "Lacey's regime velocity is proportional to ___.",
            options: ["R^(1/2) S^(1/3)", "R^(2/3) S^(1/3)", "R^(1/3) S^(1/2)", "R S^(2/3)"],
            correctAnswer: "R^(2/3) S^(1/3)",
            explanation: "Lacey's regime velocity is proportional to R^(2/3) S^(1/3)."
          },
          {
            id: 4,
            question: "Irrigation canals are generally aligned along ___ line.",
            options: ["Contour", "Ridge", "Valley", "Road"],
            correctAnswer: "Ridge",
            explanation: "Irrigation canals are generally aligned along Ridge line."
          },
          {
            id: 5,
            question: "Balanced depth of cutting of canal is where volume of cutting is ___ volume of filling.",
            options: ["Greater than", "Less than", "Equal to", "Double"],
            correctAnswer: "Equal to",
            explanation: "Balanced depth of cutting of canal is where volume of cutting is Equal to volume of filling."
          },
          {
            id: 6,
            question: "The critical velocity ratio was introduced in Kennedy's equation to account for the effect of ___.",
            options: ["Channel slope", "Silt grade", "Roughness", "Wetted perimeter"],
            correctAnswer: "Silt grade",
            explanation: "The critical velocity ratio was introduced in Kennedy's equation to account for the effect of Silt grade."
          },
          {
            id: 7,
            question: "Silting in the channel causes ___ in discharge.",
            options: ["Increase", "Decrease", "No change", "Fluctuation"],
            correctAnswer: "Decrease",
            explanation: "Silting in the channel causes Decrease in discharge."
          },
          {
            id: 8,
            question: "According to Lacey, if D is regime depth of scour, depth of scour in a right angled bend equals ___.",
            options: ["D", "1.5D", "2.00D", "2.5D"],
            correctAnswer: "2.00D",
            explanation: "According to Lacey, if D is regime depth of scour, depth of scour in a right angled bend equals 2.00D."
          },
          {
            id: 9,
            question: "Side slope canal does NOT need ___ structures.",
            options: ["Regulating", "Cross drainage", "Escape", "Fall"],
            correctAnswer: "Cross drainage",
            explanation: "Side slope canal does NOT need Cross drainage structures."
          },
          {
            id: 10,
            question: "Canal irrigation is generally preferred in ___ canal.",
            options: ["Rocky", "Alluvial", "Clayey", "Hilly"],
            correctAnswer: "Alluvial",
            explanation: "Canal irrigation is generally preferred in Alluvial canal."
          },
          {
            id: 11,
            question: "Design canal discharge is based on ___ irrigation water requirement.",
            options: ["Minimum", "Average", "Maximum", "Monthly"],
            correctAnswer: "Maximum",
            explanation: "Design canal discharge is based on Maximum irrigation water requirement."
          },
          {
            id: 12,
            question: "___ canal is not considered to be directly used for irrigation.",
            options: ["Branch", "Distributary", "Main", "Field"],
            correctAnswer: "Main",
            explanation: "Main canal is not considered to be directly used for irrigation."
          },
          {
            id: 13,
            question: "The capacity of irrigation canal is determined by ___ water depth.",
            options: ["Rabi", "Kor (Kharif)", "Summer", "Winter"],
            correctAnswer: "Kor (Kharif)",
            explanation: "The capacity of irrigation canal is determined by Kor (Kharif) water depth."
          },
          {
            id: 14,
            question: "Water in canal is based on ___ irrigation requirement.",
            options: ["Net", "Gross", "Average", "Optimal"],
            correctAnswer: "Gross",
            explanation: "Water in canal is based on Gross irrigation requirement."
          },
          {
            id: 15,
            question: "Which condition is NOT applicable to a true regime?",
            options: ["Channel maintains slope and section", "Silt charge equal to silt grade", "Channel can be scoured more easily than deposited", "Channel is in dynamic equilibrium"],
            correctAnswer: "Channel can be scoured more easily than deposited",
            explanation: "Channel can be scoured more easily than deposited is the correct answer."
          },
          {
            id: 16,
            question: "The structure provided to discharge extra water from a canal is ___.",
            options: ["Head regulator", "Canal escape", "Fall", "Aqueduct"],
            correctAnswer: "Canal escape",
            explanation: "The structure provided to discharge extra water from a canal is Canal escape."
          },
          {
            id: 17,
            question: "The hydraulic structure that allows drainage to mix with the canal is ___.",
            options: ["Canal outlet", "Canal inlet", "Drop", "Syphon"],
            correctAnswer: "Canal inlet",
            explanation: "The hydraulic structure that allows drainage to mix with the canal is Canal inlet."
          },
          {
            id: 18,
            question: "For irrigation channel with side slope 1:S, width B, depth y, length L, total area of side slope is ___.",
            options: ["L×y×S", "2L×y√(1+S²)", "L×y√(1+S²)", "2L×y×S"],
            correctAnswer: "2L×y√(1+S²)",
            explanation: "For irrigation channel with side slope 1:S, width B, depth y, length L, total area of side slope is 2L×y√(1+S²)."
          },
          {
            id: 19,
            question: "For design of non-scouring channels in coarse alluviums, shield's entrainment function should be ___.",
            options: ["0.020", "0.035", "0.056", "0.075"],
            correctAnswer: "0.056",
            explanation: "For design of non-scouring channels in coarse alluviums, shield's entrainment function should be 0.056."
          },
          {
            id: 20,
            question: "Irrigation canals are generally aligned along ___.",
            options: ["Valley line", "Ridge line", "Contour line", "River bank"],
            correctAnswer: "Ridge line",
            explanation: "Irrigation canals are generally aligned along Ridge line."
          },
          {
            id: 21,
            question: "The canal intake is preferred in ___ stage.",
            options: ["Flood", "Low flow", "Trough", "Peak"],
            correctAnswer: "Trough",
            explanation: "The canal intake is preferred in Trough stage."
          },
          {
            id: 22,
            question: "A canal drop/fall is provided if ground slope ___ designed bed slope.",
            options: ["Equals", "Is less than", "Exceeds", "Is independent of"],
            correctAnswer: "Exceeds",
            explanation: "A canal drop/fall is provided if ground slope Exceeds designed bed slope."
          },
          {
            id: 23,
            question: "Crossing arrangement preferably made at the junction of a large canal and a river carrying short-lived high flood at equal bed levels is a ___ crossing.",
            options: ["Super-passage", "Syphon", "Aqueduct", "Level"],
            correctAnswer: "Level",
            explanation: "Crossing arrangement preferably made at the junction of a large canal and a river carrying short-lived high flood at equal bed levels is a Level crossing."
          },
          {
            id: 24,
            question: "In a super-passage, FSL of a canal is ___ the drain flood level.",
            options: ["Above", "Equal to", "Below", "Twice"],
            correctAnswer: "Below",
            explanation: "In a super-passage, FSL of a canal is Below the drain flood level."
          },
          {
            id: 25,
            question: "Considering canals as a factor, seepage of water through canals causes ___.",
            options: ["Erosion", "Water logging", "Aggradation", "Subsidence"],
            correctAnswer: "Water logging",
            explanation: "Considering canals as a factor, seepage of water through canals causes Water logging."
          },
          {
            id: 26,
            question: "The general depth of scour calculated by Lacey's formula in a river represents depth below ___.",
            options: ["Bed level", "Mean sea level", "Maximum flood level", "Normal water level"],
            correctAnswer: "Maximum flood level",
            explanation: "The general depth of scour calculated by Lacey's formula in a river represents depth below Maximum flood level."
          },
          {
            id: 27,
            question: "A lined alluvial canal is best designed on the basis of ___ theory.",
            options: ["Lacey", "Kennedy", "Manning", "Chezy"],
            correctAnswer: "Manning",
            explanation: "A lined alluvial canal is best designed on the basis of Manning theory."
          },
          {
            id: 28,
            question: "Meandering ___ possible in an alluvial channel carrying sediments.",
            options: ["Is always", "Is never", "Is", "Is not"],
            correctAnswer: "Is",
            explanation: "Meandering Is possible in an alluvial channel carrying sediments."
          }
        ]
      },
      {
        id: 3,
        title: "Diversion headworks",
        description: "Components of headwork; seepage theories and their applications (Bligh's, Lane's, Khosla's); design of silt control structures (excluder, ejector and settling basins); design of weir/barrage (crest, length and thickness of impervious floor); design of energy dissipaters.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "According to Khosla, the soil material with lowest safe exit gradient is ___.",
            options: ["Coarse sand", "Gravel", "Fine sand", "Boulder"],
            correctAnswer: "Fine sand",
            explanation: "According to Khosla, the soil material with lowest safe exit gradient is Fine sand."
          },
          {
            id: 2,
            question: "According to Khosla theory, exit gradient in the absence of downstream cut-off is ___.",
            options: ["Zero", "Minimum", "Infinity", "Equal to upstream gradient"],
            correctAnswer: "Infinity",
            explanation: "According to Khosla theory, exit gradient in the absence of downstream cut-off is Infinity."
          },
          {
            id: 3,
            question: "Masonry or concrete sloping weir is of ___ origin.",
            options: ["Ancient", "Recent", "Medieval", "Unknown"],
            correctAnswer: "Recent",
            explanation: "Masonry or concrete sloping weir is of Recent origin."
          },
          {
            id: 4,
            question: "The most efficient weir shape is ___.",
            options: ["Rectangular", "Trapezoidal", "Parabolic", "Triangular"],
            correctAnswer: "Parabolic",
            explanation: "The most efficient weir shape is Parabolic."
          },
          {
            id: 5,
            question: "The main function of weir and barrage is to increase water ___.",
            options: ["Flow", "Velocity", "Height", "Discharge"],
            correctAnswer: "Height",
            explanation: "The main function of weir and barrage is to increase water Height."
          },
          {
            id: 6,
            question: "Major differentiating point between weirs and barrages is presence of ___.",
            options: ["Crest", "Apron", "Gates", "Cutoffs"],
            correctAnswer: "Gates",
            explanation: "Major differentiating point between weirs and barrages is presence of Gates."
          },
          {
            id: 7,
            question: "According to Bligh's creep theory, percolating water flows along the outline of the ___ of the foundation.",
            options: ["Top", "Sides", "Base", "Crest"],
            correctAnswer: "Base",
            explanation: "According to Bligh's creep theory, percolating water flows along the outline of the Base of the foundation."
          },
          {
            id: 8,
            question: "Bligh's theory of seepage assumes equal weightage to horizontal and vertical ___.",
            options: ["Pressure", "Flow", "Creep", "Seepage"],
            correctAnswer: "Creep",
            explanation: "Bligh's theory of seepage assumes equal weightage to horizontal and vertical Creep."
          },
          {
            id: 9,
            question: "The method evolved by Khosla for designing hydraulic structures is ___.",
            options: ["Bligh's method", "Lacey's method", "Method of Independent Variables", "Method of Superposition"],
            correctAnswer: "Method of Independent Variables",
            explanation: "The method evolved by Khosla for designing hydraulic structures is Method of Independent Variables."
          },
          {
            id: 10,
            question: "A weir whose weight is completely balanced by upward seepage force of water is called ___ weir.",
            options: ["Gravity", "Vertical drop", "Sloping", "Raised crest"],
            correctAnswer: "Gravity",
            explanation: "A weir whose weight is completely balanced by upward seepage force of water is called Gravity weir."
          },
          {
            id: 11,
            question: "Lane's creep length formula is ___ (d1 = upstream cutoff, d2 = downstream cutoff, L = floor length).",
            options: ["D1+L+d2", "2d1+L+2d2", "2d1+L/3+2d2", "D1+L/3+d2"],
            correctAnswer: "2d1+L/3+2d2",
            explanation: "Lane's creep length formula is 2d1+L/3+2d2 (d1 = upstream cutoff, d2 = downstream cutoff, L = floor length)."
          },
          {
            id: 12,
            question: "According to Khosla's theory, exit gradient formula is ___.",
            options: ["H/dπ√λ", "H/(dπ√λ)", "Hd/π√λ", "H√λ/dπ"],
            correctAnswer: "H/(dπ√λ)",
            explanation: "According to Khosla's theory, exit gradient formula is H/(dπ√λ)."
          },
          {
            id: 13,
            question: "The structure used to separate the weir from under sluice is ___.",
            options: ["Fish ladder", "Divide wall", "Guide bank", "Training wall"],
            correctAnswer: "Divide wall",
            explanation: "The structure used to separate the weir from under sluice is Divide wall."
          }
        ]
      },
      {
        id: 4,
        title: "River training works",
        description: "River stages and need of river training; design of river training works (guide bund and launching aprons, levees and spurs); watershed management.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "River training work dealing with flood control is ___.",
            options: ["Training for discharge", "Training for navigation", "Training for irrigation", "Training for power"],
            correctAnswer: "Training for discharge",
            explanation: "River training work dealing with flood control is Training for discharge."
          },
          {
            id: 2,
            question: "Launching apron is made of ___.",
            options: ["Concrete only", "Steel", "Gabion, stone, geotextile fabric", "Timber"],
            correctAnswer: "Gabion, stone, geotextile fabric",
            explanation: "Launching apron is made of Gabion, stone, geotextile fabric."
          },
          {
            id: 3,
            question: "Launching apron is primarily made of ___.",
            options: ["Concrete", "Steel", "Gabion", "Timber"],
            correctAnswer: "Gabion",
            explanation: "Launching apron is primarily made of Gabion."
          },
          {
            id: 4,
            question: "Repelling spur is inclined ___.",
            options: ["Downstream", "Upstream", "Perpendicular to flow", "Parallel to flow"],
            correctAnswer: "Upstream",
            explanation: "Repelling spur is inclined Upstream."
          }
        ]
      },
      {
        id: 5,
        title: "Regulating and cross-drainage structures",
        description: "Functions of various types of regulators, design of regulators and escapes (crest, length and thickness of impervious floor); design of pipe outlet (free and submerged); design of vertical drop (crest, length, and thickness of impervious floor); design of cross-drainage structures.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Canal escape structures are used to remove surplus water from canal into a ___.",
            options: ["Main canal", "Natural drain", "Reservoir", "Pump house"],
            correctAnswer: "Natural drain",
            explanation: "Canal escape structures are used to remove surplus water from canal into a Natural drain."
          },
          {
            id: 2,
            question: "The function of cross regulator in irrigation is to maintain the head for flow in ___ taking canal.",
            options: ["Main", "Branch", "Off", "Distributary"],
            correctAnswer: "Off",
            explanation: "The function of cross regulator in irrigation is to maintain the head for flow in Off taking canal."
          },
          {
            id: 3,
            question: "The structure at the head of regulator to remove silt is silt ___.",
            options: ["Trap", "Pocket", "Excluder", "Basin"],
            correctAnswer: "Excluder",
            explanation: "The structure at the head of regulator to remove silt is silt Excluder."
          },
          {
            id: 4,
            question: "Cross drainage works carrying canal over a natural drain are called ___.",
            options: ["Aqueduct and syphon aqueduct", "Super passage and syphon", "Level crossing", "Canal inlet"],
            correctAnswer: "Aqueduct and syphon aqueduct",
            explanation: "Cross drainage works carrying canal over a natural drain are called Aqueduct and syphon aqueduct."
          },
          {
            id: 5,
            question: "The drainage provided to escape water from a waterlogged area is called ___.",
            options: ["Canals", "Drains", "Aqueducts", "Syphons"],
            correctAnswer: "Drains",
            explanation: "The drainage provided to escape water from a waterlogged area is called Drains."
          },
          {
            id: 6,
            question: "A free pipe outlet is a ___ outlet.",
            options: ["Rigid", "Semi-rigid", "Flexible", "Fixed"],
            correctAnswer: "Flexible",
            explanation: "A free pipe outlet is a Flexible outlet."
          },
          {
            id: 7,
            question: "At bed level, there is ___ provision of gates in head regulator.",
            options: ["Always", "No", "Optional", "Double"],
            correctAnswer: "No",
            explanation: "At bed level, there is No provision of gates in head regulator."
          }
        ]
      },
      {
        id: 6,
        title: "Water logging and drainage",
        description: "Causes, effects and preventive measures; design of surface and subsurface drainage systems.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The open drain that is fully operative only in the rainy season is ___ surface drain.",
            options: ["Deep", "Shallow", "Wide", "Narrow"],
            correctAnswer: "Shallow",
            explanation: "The open drain that is fully operative only in the rainy season is Shallow surface drain."
          },
          {
            id: 2,
            question: "Excessive tapping of ground water ___ contribute to water logging.",
            options: ["Always", "Strongly", "Does not", "Sometimes"],
            correctAnswer: "Does not",
            explanation: "Excessive tapping of ground water Does not contribute to water logging."
          },
          {
            id: 3,
            question: "The factor causing waterlogging that suggests extensive irrigation is ___.",
            options: ["Under irrigation", "Controlled irrigation", "Over and intensive irrigation", "Drip irrigation"],
            correctAnswer: "Over and intensive irrigation",
            explanation: "The factor causing waterlogging that suggests extensive irrigation is Over and intensive irrigation."
          },
          {
            id: 4,
            question: "Frequent irrigation ___ prevent waterlogging.",
            options: ["Always does", "Strongly", "Doesn't", "Sometimes"],
            correctAnswer: "Doesn't",
            explanation: "Frequent irrigation Doesn't prevent waterlogging."
          },
          {
            id: 5,
            question: "The optimal shape for a surface drain is ___.",
            options: ["Rectangular", "Circular", "Trapezoidal", "Triangular"],
            correctAnswer: "Trapezoidal",
            explanation: "The optimal shape for a surface drain is Trapezoidal."
          }
        ]
      }
    ]
  },
  {
    id: 8,
    title: "Hydropower",
    code: "ACiE08",
    topics: [
      {
        id: 1,
        title: "Planning of hydropower projects",
        description: "Power potential (gross, technical, economic) of Nepal and the world; stages of hydropower development, hydropower development in Nepal (history, policy, acts & regulation).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "In context of Nepal, ___ plant is most reliable/suitable.",
            options: ["Thermal", "Solar", "Wind", "Hydro"],
            correctAnswer: "Hydro",
            explanation: "In context of Nepal, Hydro plant is most reliable/suitable."
          },
          {
            id: 2,
            question: "The date of construction and capacity of Pharping hydropower plant is ___.",
            options: ["1905 AD, 200 KW", "1911 AD, 500 KW", "1920 AD, 1000 KW", "1935 AD, 2000 KW"],
            correctAnswer: "1911 AD, 500 KW",
            explanation: "The date of construction and capacity of Pharping hydropower plant is 1911 AD, 500 KW."
          },
          {
            id: 3,
            question: "Flow duration curve is the graph drawn between discharge and ___ of time such discharge is exceeded.",
            options: ["Mean", "Percentage", "Total", "Cumulative"],
            correctAnswer: "Percentage",
            explanation: "Flow duration curve is the graph drawn between discharge and Percentage of time such discharge is exceeded."
          },
          {
            id: 4,
            question: "___ and Uplift are the causes of failure of hydraulic structure on the pervious foundation.",
            options: ["Sliding", "Overturning", "Undermining", "Piping"],
            correctAnswer: "Undermining",
            explanation: "Undermining and Uplift are the causes of failure of hydraulic structure on the pervious foundation."
          },
          {
            id: 5,
            question: "Power needed to uplift water can be calculated as P = ___.",
            options: ["ΓQH", "ΗγQH", "ΓQ/H", "ΗγQ/H"],
            correctAnswer: "ΗγQH",
            explanation: "Power needed to uplift water can be calculated as P = ΗγQH."
          },
          {
            id: 6,
            question: "Trash rack is used to prevent the entry of ___.",
            options: ["Water", "Sediment", "Debris", "Silt"],
            correctAnswer: "Debris",
            explanation: "Trash rack is used to prevent the entry of Debris."
          },
          {
            id: 7,
            question: "Submerged intake is located at ___ of river.",
            options: ["Surface", "Middle depth", "Bottom", "Bank"],
            correctAnswer: "Bottom",
            explanation: "Submerged intake is located at Bottom of river."
          },
          {
            id: 8,
            question: "According to Khosla's theory, the exit gradient formula is ___.",
            options: ["H/dπ√λ", "H/(dπ√λ)", "Hd/π√λ", "H√λ/dπ"],
            correctAnswer: "H/(dπ√λ)",
            explanation: "According to Khosla's theory, the exit gradient formula is H/(dπ√λ)."
          },
          {
            id: 9,
            question: "The main function of weir & barrage is to increase water ___.",
            options: ["Flow", "Velocity", "Height", "Discharge"],
            correctAnswer: "Height",
            explanation: "The main function of weir & barrage is to increase water Height."
          },
          {
            id: 10,
            question: "The major differentiating point between weirs and barrages is presence of ___.",
            options: ["Crest", "Apron", "Gates", "Cutoffs"],
            correctAnswer: "Gates",
            explanation: "The major differentiating point between weirs and barrages is presence of Gates."
          },
          {
            id: 11,
            question: "Guide banks are provided to train the ___ of a river along a specified course.",
            options: ["Water level", "Sediment", "Flow", "Bank"],
            correctAnswer: "Flow",
            explanation: "Guide banks are provided to train the Flow of a river along a specified course."
          },
          {
            id: 12,
            question: "Divide wall is used to separate the under sluice portion from ___ weir portion.",
            options: ["Secondary", "Head works", "Main", "Spillway"],
            correctAnswer: "Main",
            explanation: "Divide wall is used to separate the under sluice portion from Main weir portion."
          },
          {
            id: 13,
            question: "The lanes creep length formula is ___.",
            options: ["D1+L+d2", "2d1+L+2d2", "2d1+L/3+2d2", "D1+L/3+d2"],
            correctAnswer: "2d1+L/3+2d2",
            explanation: "The lanes creep length formula is 2d1+L/3+2d2."
          },
          {
            id: 14,
            question: "Bligh's theory of seepage assumes equal weightage to the horizontal and vertical ___.",
            options: ["Pressure", "Flow", "Creep", "Seepage"],
            correctAnswer: "Creep",
            explanation: "Bligh's theory of seepage assumes equal weightage to the horizontal and vertical Creep."
          },
          {
            id: 15,
            question: "___ spur is inclined upstream.",
            options: ["Attracting", "Deflecting", "Repelling", "Training"],
            correctAnswer: "Repelling",
            explanation: "Repelling spur is inclined upstream."
          },
          {
            id: 16,
            question: "In a super-passage, the Full Supply Level (FSL) of a canal is ___ the drain flood level.",
            options: ["Above", "Equal to", "Below", "Twice"],
            correctAnswer: "Below",
            explanation: "In a super-passage, the Full Supply Level (FSL) of a canal is Below the drain flood level."
          },
          {
            id: 17,
            question: "According to Lacey, if D is the depth of scour in regime flow, depth of scour in a right angled bend equals ___.",
            options: ["D", "1.5D", "2.00D", "2.5D"],
            correctAnswer: "2.00D",
            explanation: "According to Lacey, if D is the depth of scour in regime flow, depth of scour in a right angled bend equals 2.00D."
          },
          {
            id: 18,
            question: "The sensitivity of rigid module is ___.",
            options: ["One", "Infinity", "Negative", "Zero"],
            correctAnswer: "Zero",
            explanation: "The sensitivity of rigid module is Zero."
          },
          {
            id: 19,
            question: "The crest of under sluice portion of diversion head works is kept at ___ level of river.",
            options: ["Flood", "Full supply", "Bed", "Top"],
            correctAnswer: "Bed",
            explanation: "The crest of under sluice portion of diversion head works is kept at Bed level of river."
          },
          {
            id: 20,
            question: "Cross drainage works carrying canal over natural drain called ___ and syphon aqueduct.",
            options: ["Super passage", "Syphon", "Aqueduct", "Level crossing"],
            correctAnswer: "Aqueduct",
            explanation: "Cross drainage works carrying canal over natural drain called Aqueduct and syphon aqueduct."
          },
          {
            id: 21,
            question: "The spacing of tile drains to relieve water-logged land is directly proportional to the coefficient of ___ of the soil.",
            options: ["Compressibility", "Cohesion", "Permeability", "Consolidation"],
            correctAnswer: "Permeability",
            explanation: "The spacing of tile drains to relieve water-logged land is directly proportional to the coefficient of Permeability of the soil."
          },
          {
            id: 22,
            question: "The balanced depth of cutting of canal is where volume of cutting is ___ to volume of filling.",
            options: ["Greater than", "Less than", "Equal", "Proportional"],
            correctAnswer: "Equal",
            explanation: "The balanced depth of cutting of canal is where volume of cutting is Equal to volume of filling."
          }
        ]
      },
      {
        id: 2,
        title: "Power and energy potential study",
        description: "Power and energy potentials; methods of fixing installed capacity of a plant; types of hydropower plants on various basis; components of different types of hydropower projects; reservoirs and their regulation.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Load factor is the ratio of ___ to maximum demand.",
            options: ["Installed capacity", "Peak demand", "Average demand", "Minimum demand"],
            correctAnswer: "Average demand",
            explanation: "Load factor is the ratio of Average demand to maximum demand."
          },
          {
            id: 2,
            question: "The pondage in a hydropower station is ___ storage to meet peak demands.",
            options: ["Permanent", "Long-term", "Temporary", "Seasonal"],
            correctAnswer: "Temporary",
            explanation: "The pondage in a hydropower station is Temporary storage to meet peak demands."
          },
          {
            id: 3,
            question: "Dead storage of storage reservoir is level between bed level and ___ pool level.",
            options: ["Flood", "Maximum", "Minimum", "Normal"],
            correctAnswer: "Minimum",
            explanation: "Dead storage of storage reservoir is level between bed level and Minimum pool level."
          },
          {
            id: 4,
            question: "The power output from a hydro-electric power plant depends on three parameters: head, discharge, and ___ of the system.",
            options: ["Volume", "Area", "Efficiency", "Size"],
            correctAnswer: "Efficiency",
            explanation: "The power output from a hydro-electric power plant depends on three parameters: head, discharge, and Efficiency of the system."
          },
          {
            id: 5,
            question: "In hydropower plant, the Net head is gross head ___ head losses.",
            options: ["Plus", "Times", "Minus", "Divided by"],
            correctAnswer: "Minus",
            explanation: "In hydropower plant, the Net head is gross head Minus head losses."
          }
        ]
      },
      {
        id: 3,
        title: "Headworks of storage plants",
        description: "Components of a typical storage plant; dams (types, functions, selection, design, failure modes and remedies); stability analysis of gravity dam, seepage control and foundation treatment in dams; design of intake, spillway and energy dissipaters; gates (types and locations).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Gravity dam is most suitable when the foundation is ___.",
            options: ["Weak", "Sandy", "Strong", "Alluvial"],
            correctAnswer: "Strong",
            explanation: "Gravity dam is most suitable when the foundation is Strong."
          },
          {
            id: 2,
            question: "The recommended top width of low earthen dam is ___.",
            options: ["0.1H + 2", "0.2H + 3", "0.3H + 4", "H/5"],
            correctAnswer: "0.2H + 3",
            explanation: "The recommended top width of low earthen dam is 0.2H + 3."
          },
          {
            id: 3,
            question: "The core of an earthen embankment is important for controlling ___.",
            options: ["Uplift", "Settlement", "Seepage", "Erosion"],
            correctAnswer: "Seepage",
            explanation: "The core of an earthen embankment is important for controlling Seepage."
          },
          {
            id: 4,
            question: "Morning glory is the special flared inlet of the ___ spillway of a large dam project.",
            options: ["Chute", "Side channel", "Shaft", "Ogee"],
            correctAnswer: "Shaft",
            explanation: "Morning glory is the special flared inlet of the Shaft spillway of a large dam project."
          },
          {
            id: 5,
            question: "The temporary structures that are built to enclose certain worksite are ___ dams.",
            options: ["Gravity", "Arch", "Coffer", "Buttress"],
            correctAnswer: "Coffer",
            explanation: "The temporary structures that are built to enclose certain worksite are Coffer dams."
          },
          {
            id: 6,
            question: "The safety valve of dam/reservoir is ___.",
            options: ["Outlet works", "Penstock", "Spillway", "Intake"],
            correctAnswer: "Spillway",
            explanation: "The safety valve of dam/reservoir is Spillway."
          },
          {
            id: 7,
            question: "The central core of the zoned embankment type earth dam ___ the seepage.",
            options: ["Allows", "Increases", "Checks", "Drains"],
            correctAnswer: "Checks",
            explanation: "The central core of the zoned embankment type earth dam Checks the seepage."
          },
          {
            id: 8,
            question: "The process of laying and compacting earth in layers by power roller under OMC for construction of earthen dam is known as ___ filled method.",
            options: ["Hydraulic", "Semi", "Rolled", "Dry"],
            correctAnswer: "Rolled",
            explanation: "The process of laying and compacting earth in layers by power roller under OMC for construction of earthen dam is known as Rolled filled method."
          },
          {
            id: 9,
            question: "The annual depreciation of a dam in hydro power plant is about ___ %.",
            options: ["0.1 to 0.5", "0.5 to 1.5", "2 to 3", "3 to 5"],
            correctAnswer: "0.5 to 1.5",
            explanation: "The annual depreciation of a dam in hydro power plant is about 0.5 to 1.5 %."
          },
          {
            id: 10,
            question: "The axis of a gravity dam is the line of the crown of the dam on the ___ side.",
            options: ["Downstream", "Toe", "Heel", "Upstream"],
            correctAnswer: "Upstream",
            explanation: "The axis of a gravity dam is the line of the crown of the dam on the Upstream side."
          },
          {
            id: 11,
            question: "The maximum permissible eccentricity for no tension at the base of the gravity dam is ___.",
            options: ["B/3", "B/4", "B/6", "B/8"],
            correctAnswer: "B/6",
            explanation: "The maximum permissible eccentricity for no tension at the base of the gravity dam is B/6."
          },
          {
            id: 12,
            question: "According to Bligh's creep theory, percolating water flows along the outline of the ___ of the foundation of the dam.",
            options: ["Top", "Sides", "Base", "Crest"],
            correctAnswer: "Base",
            explanation: "According to Bligh's creep theory, percolating water flows along the outline of the Base of the foundation of the dam."
          }
        ]
      },
      {
        id: 4,
        title: "Headworks of run-of-river (ROR) plants",
        description: "Components of a typical ROR plant; design of intake; methods of bed and suspended load handling; design of settling basin (practice and concentration approach), estimation of sediment volume in settling basin, flushing of deposited sediment, estimation of flushing frequency for sediments.",
        videos: [],
        externalLinks: [],
        mcqs: []
      },
      {
        id: 5,
        title: "Water conveyance structures",
        description: "Hydraulic tunnels, x-sections, and hydraulic design (velocity and sizing); tunnel lining; design of forebay and surge tanks; design of penstocks and pressure shaft; hydraulic transients (water hammer).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The water hammer effect in hydropower plant is prevented by ___ tank.",
            options: ["Forebay", "Head", "Surge", "Settling"],
            correctAnswer: "Surge",
            explanation: "The water hammer effect in hydropower plant is prevented by Surge tank."
          },
          {
            id: 2,
            question: "The function of a surge tank is to relieve ___ pressures in the penstock pipe.",
            options: ["Static", "Dynamic", "Water hammer", "Fatigue"],
            correctAnswer: "Water hammer",
            explanation: "The function of a surge tank is to relieve Water hammer pressures in the penstock pipe."
          }
        ]
      },
      {
        id: 6,
        title: "Hydro-electric machines and powerhouse",
        description: "Hydro-mechanical equipment and their functions; types of turbines and performance characteristics; selection of turbine and their specific speed; preliminary design of Francis and Pelton turbines; scroll case and draft tubes; generators (types, rating); governs; pumps and their performance characteristics; powerhouse (types, general arrangements, dimensions).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Pelton is ___ turbine.",
            options: ["Reaction", "Mixed flow", "Impulse", "Axial flow"],
            correctAnswer: "Impulse",
            explanation: "Pelton is Impulse turbine."
          },
          {
            id: 2,
            question: "Kaplan turbine is low head ___ flow turbine.",
            options: ["Radial", "Mixed", "Axial", "Tangential"],
            correctAnswer: "Axial",
            explanation: "Kaplan turbine is low head Axial flow turbine."
          },
          {
            id: 3,
            question: "Draft tubes are not used in ___ turbine.",
            options: ["Kaplan", "Francis", "Pelton", "Reaction"],
            correctAnswer: "Pelton",
            explanation: "Draft tubes are not used in Pelton turbine."
          },
          {
            id: 4,
            question: "The use of draft tube in reaction turbine helps to convert KE to ___ energy.",
            options: ["Electrical", "Thermal", "Pressure", "Potential"],
            correctAnswer: "Pressure",
            explanation: "The use of draft tube in reaction turbine helps to convert KE to Pressure energy."
          },
          {
            id: 5,
            question: "High head turbine is ___ turbine.",
            options: ["Kaplan", "Francis", "Pelton", "Cross flow"],
            correctAnswer: "Pelton",
            explanation: "High head turbine is Pelton turbine."
          },
          {
            id: 6,
            question: "The hydraulic efficiency of a turbine is fluid power transferred to runners divided by power ___ at the inlet to the turbine.",
            options: ["Generated", "Lost", "Available", "Consumed"],
            correctAnswer: "Available",
            explanation: "The hydraulic efficiency of a turbine is fluid power transferred to runners divided by power Available at the inlet to the turbine."
          },
          {
            id: 7,
            question: "The governor in a hydropower plant regulates the flow rate of water striking the runner to control turbine ___.",
            options: ["Power", "Discharge", "RPM", "Head"],
            correctAnswer: "RPM",
            explanation: "The governor in a hydropower plant regulates the flow rate of water striking the runner to control turbine RPM."
          },
          {
            id: 8,
            question: "Penstock in a hydroelectric power plant is a conduit connecting forebay to ___ of turbine.",
            options: ["Draft tube", "Runner", "Scroll case", "Tail race"],
            correctAnswer: "Scroll case",
            explanation: "Penstock in a hydroelectric power plant is a conduit connecting forebay to Scroll case of turbine."
          },
          {
            id: 9,
            question: "The formula used to calculate velocity of jet for Pelton turbine is ___.",
            options: ["Cv(gH)^0.5", "Cv(2gH)^0.5", "Cv(4gH)^0.5", "Cv(gH/2)^0.5"],
            correctAnswer: "Cv(2gH)^0.5",
            explanation: "The formula used to calculate velocity of jet for Pelton turbine is Cv(2gH)^0.5."
          },
          {
            id: 10,
            question: "The correct sequence in hydropower plant for the direction of flow of water is reservoir, ___, surge tank, turbine.",
            options: ["Draft tube", "Penstock", "Forebay", "Tailrace"],
            correctAnswer: "Penstock",
            explanation: "The correct sequence in hydropower plant for the direction of flow of water is reservoir, Penstock, surge tank, turbine."
          },
          {
            id: 11,
            question: "In a Francis turbine runner, the number of blades are generally between ___ to 24.",
            options: ["8", "12", "16", "20"],
            correctAnswer: "16",
            explanation: "In a Francis turbine runner, the number of blades are generally between 16 to 24."
          }
        ]
      }
    ]
  },
  {
    id: 9,
    title: "Transportation",
    code: "ACiE09",
    topics: [
      {
        id: 1,
        title: "Highway planning and survey",
        description: "Modes of transport, history of road development in Nepal; classification of roads; road survey; highway alignment and controlling factors; evaluating alternate alignments; Road Standards of Nepal.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The most reliable mode of transportation is ___ transport.",
            options: ["Rail", "Water", "Road", "Air"],
            correctAnswer: "Road",
            explanation: "The most reliable mode of transportation is Road transport."
          },
          {
            id: 2,
            question: "The sequence of four stages of the survey in a highway alignment is map survey, ___, preliminary survey, and detailed survey.",
            options: ["Topographic survey", "Soil survey", "Reconnaissance survey", "Aerial survey"],
            correctAnswer: "Reconnaissance survey",
            explanation: "The sequence of four stages of the survey in a highway alignment is map survey, Reconnaissance survey, preliminary survey, and detailed survey."
          },
          {
            id: 3,
            question: "The length visible to driver at any instance of time is called ___ distance.",
            options: ["Braking", "Stopping", "Sight", "Overtaking"],
            correctAnswer: "Sight",
            explanation: "The length visible to driver at any instance of time is called Sight distance."
          },
          {
            id: 4,
            question: "As per NRS 2070, the maximum value for coefficient of lateral friction is taken as ___.",
            options: ["0.10", "0.12", "0.15", "0.18"],
            correctAnswer: "0.15",
            explanation: "As per NRS 2070, the maximum value for coefficient of lateral friction is taken as 0.15."
          },
          {
            id: 5,
            question: "As per NRS 2070, the Right of Way (ROW) for feeder road is ___ m.",
            options: ["15", "20", "25", "30"],
            correctAnswer: "30",
            explanation: "As per NRS 2070, the Right of Way (ROW) for feeder road is 30 m."
          },
          {
            id: 6,
            question: "The ideal shape of a transition curve is ___.",
            options: ["Parabola", "Spiral", "Lemniscate", "Clothoid"],
            correctAnswer: "Clothoid",
            explanation: "The ideal shape of a transition curve is Clothoid."
          },
          {
            id: 7,
            question: "The minimum width of a single lane road is ___ m.",
            options: ["3.0", "3.25", "3.5", "3.75"],
            correctAnswer: "3.75",
            explanation: "The minimum width of a single lane road is 3.75 m."
          },
          {
            id: 8,
            question: "The organic binding material used in road pavement is ___.",
            options: ["Tar", "Bitumen", "Asphalt", "Road oil"],
            correctAnswer: "Bitumen",
            explanation: "The organic binding material used in road pavement is Bitumen."
          },
          {
            id: 9,
            question: "The longitudinal depression in the wheel path in bituminous pavements is ___.",
            options: ["Shoving", "Ravelling", "Rutting", "Cracking"],
            correctAnswer: "Rutting",
            explanation: "The longitudinal depression in the wheel path in bituminous pavements is Rutting."
          },
          {
            id: 10,
            question: "The highest quality construction in the group of black top pavements is ___ concrete.",
            options: ["Dense graded", "Open graded", "Bituminous", "Stone mastic"],
            correctAnswer: "Bituminous",
            explanation: "The highest quality construction in the group of black top pavements is Bituminous concrete."
          },
          {
            id: 11,
            question: "According to administrative classification, the road with high mobility and least accessibility is called ___ Highway.",
            options: ["District", "Feeder", "Local", "National"],
            correctAnswer: "National",
            explanation: "According to administrative classification, the road with high mobility and least accessibility is called National Highway."
          },
          {
            id: 12,
            question: "Alligator cracking is ___ failure.",
            options: ["Rutting", "Fatigue", "Thermal", "Shear"],
            correctAnswer: "Fatigue",
            explanation: "Alligator cracking is Fatigue failure."
          },
          {
            id: 13,
            question: "Impact value in surface layer of road pavement should be less than ___.",
            options: ["20", "25", "30", "40"],
            correctAnswer: "30",
            explanation: "Impact value in surface layer of road pavement should be less than 30."
          },
          {
            id: 14,
            question: "A 160 kN load damages pavement ___ times more than 80 kN load.",
            options: ["4", "8", "16", "32"],
            correctAnswer: "16",
            explanation: "A 160 kN load damages pavement 16 times more than 80 kN load."
          },
          {
            id: 15,
            question: "The Lane Distribution Factor (LDF) for 4 lane road is ___.",
            options: ["0.3", "0.35", "0.4", "0.5"],
            correctAnswer: "0.4",
            explanation: "The Lane Distribution Factor (LDF) for 4 lane road is 0.4."
          },
          {
            id: 16,
            question: "The standard temperature taken for the rebound deflection calculation is ___°C.",
            options: ["25", "30", "35", "40"],
            correctAnswer: "35",
            explanation: "The standard temperature taken for the rebound deflection calculation is 35°C."
          },
          {
            id: 17,
            question: "The thin hairline crack is also known as ___.",
            options: ["Rutting", "Ravelling", "Crazing", "Shoving"],
            correctAnswer: "Crazing",
            explanation: "The thin hairline crack is also known as Crazing."
          },
          {
            id: 18,
            question: "Vertical alignment is the process dealing with vertical curves and ___.",
            options: ["Sight distances", "Super elevations", "Cross sections", "Gradients"],
            correctAnswer: "Gradients",
            explanation: "Vertical alignment is the process dealing with vertical curves and Gradients."
          },
          {
            id: 19,
            question: "85th percentile cumulative frequency is used for speed ___.",
            options: ["Design", "Research", "Enforcement", "Regulation"],
            correctAnswer: "Regulation",
            explanation: "85th percentile cumulative frequency is used for speed Regulation."
          },
          {
            id: 20,
            question: "The basic capacity of road can be calculated with formula ___.",
            options: ["1000V/(L-S)", "1000V/(L+S)", "1000V×L/S", "1000VS/L"],
            correctAnswer: "1000V/(L+S)",
            explanation: "The basic capacity of road can be calculated with formula 1000V/(L+S)."
          },
          {
            id: 21,
            question: "In valley curve design, the height of head light above the road surface is taken as ___ m.",
            options: ["0.50", "0.60", "0.75", "1.00"],
            correctAnswer: "0.75",
            explanation: "In valley curve design, the height of head light above the road surface is taken as 0.75 m."
          },
          {
            id: 22,
            question: "For sandy soils, the most common method of stabilization is soil-___.",
            options: ["Lime", "Bitumen", "Cement", "Fly ash"],
            correctAnswer: "Cement",
            explanation: "For sandy soils, the most common method of stabilization is soil-Cement."
          },
          {
            id: 23,
            question: "Which pavement is best for night visibility?",
            options: ["Flexible pavement", "Bituminous concrete", "Rigid pavement (cement concrete)", "WBM"],
            correctAnswer: "Rigid pavement (cement concrete)",
            explanation: "Rigid pavement (cement concrete) is the correct answer."
          },
          {
            id: 24,
            question: "The first step in flooring is ___ coat.",
            options: ["Finishing", "Screeding", "Base", "Wearing"],
            correctAnswer: "Base",
            explanation: "The first step in flooring is Base coat."
          },
          {
            id: 25,
            question: "The feeder for other means of transportation is ___.",
            options: ["Railway", "Waterway", "Roadway", "Airway"],
            correctAnswer: "Roadway",
            explanation: "The feeder for other means of transportation is Roadway."
          },
          {
            id: 26,
            question: "A road inside the city is called ___.",
            options: ["Highway", "Expressway", "Street", "Boulevard"],
            correctAnswer: "Street",
            explanation: "A road inside the city is called Street."
          },
          {
            id: 27,
            question: "Which of the following is NOT a fixed component of a railway?",
            options: ["Rail", "Sleeper", "Ballast", "Locomotive"],
            correctAnswer: "Locomotive",
            explanation: "Locomotive is the correct answer."
          },
          {
            id: 28,
            question: "Which of the following is NOT a negative impact of transportation?",
            options: ["Accidents", "Pollution", "Mobility", "Congestion"],
            correctAnswer: "Mobility",
            explanation: "Mobility is the correct answer."
          },
          {
            id: 29,
            question: "The correct sequence of survey stages in highway alignment is map survey, reconnaissance survey, ___, and detailed survey.",
            options: ["Soil survey", "Aerial survey", "Preliminary survey", "Topographic survey"],
            correctAnswer: "Preliminary survey",
            explanation: "The correct sequence of survey stages in highway alignment is map survey, reconnaissance survey, Preliminary survey, and detailed survey."
          },
          {
            id: 30,
            question: "Endoscope is used to determine ___ speed.",
            options: ["Space mean", "Time mean", "Spot", "Design"],
            correctAnswer: "Spot",
            explanation: "Endoscope is used to determine Spot speed."
          },
          {
            id: 31,
            question: "Which factor is NOT considered when designing highways?",
            options: ["Traffic volume", "Gradient", "Settlement", "Pavement thickness"],
            correctAnswer: "Settlement",
            explanation: "Settlement is the correct answer."
          },
          {
            id: 32,
            question: "Speed at a particular place at different times is ___.",
            options: ["SMS", "Space mean speed", "TMS", "Spot speed"],
            correctAnswer: "TMS",
            explanation: "Speed at a particular place at different times is TMS."
          },
          {
            id: 33,
            question: "If space mean speed is 50 kmph, TMS will be ___ 50 kmph.",
            options: ["Less than", "Equal to", "Greater than", "Independent of"],
            correctAnswer: "Greater than",
            explanation: "If space mean speed is 50 kmph, TMS will be Greater than 50 kmph."
          },
          {
            id: 34,
            question: "As per NURS, arterial road is called ___.",
            options: ["Expressway", "Highway", "Path", "Boulevard"],
            correctAnswer: "Path",
            explanation: "As per NURS, arterial road is called Path."
          },
          {
            id: 35,
            question: "As per NRS 2070, the life of perpetual road is about ___ years.",
            options: ["10", "15", "20", "25"],
            correctAnswer: "20",
            explanation: "As per NRS 2070, the life of perpetual road is about 20 years."
          },
          {
            id: 36,
            question: "As per NRS 2070, maximum coefficient of lateral friction is taken as ___.",
            options: ["0.10", "0.12", "0.15", "0.18"],
            correctAnswer: "0.15",
            explanation: "As per NRS 2070, maximum coefficient of lateral friction is taken as 0.15."
          },
          {
            id: 37,
            question: "As per NRS 2070, Right of Way (ROW) for feeder road is ___ m.",
            options: ["15", "20", "25", "30"],
            correctAnswer: "30",
            explanation: "As per NRS 2070, Right of Way (ROW) for feeder road is 30 m."
          },
          {
            id: 38,
            question: "In plain terrain, design speed for 1st class road is ___ km/hr.",
            options: ["80", "100", "120", "150"],
            correctAnswer: "120",
            explanation: "In plain terrain, design speed for 1st class road is 120 km/hr."
          },
          {
            id: 39,
            question: "Improper highway alignment does NOT cause ___.",
            options: ["Accidents", "Traffic delays", "Fatigue cracking", "Poor visibility"],
            correctAnswer: "Fatigue cracking",
            explanation: "Improper highway alignment does NOT cause Fatigue cracking."
          },
          {
            id: 40,
            question: "Vertical alignment deals with vertical curves and ___.",
            options: ["Super elevation", "Pavement width", "Gradients", "Cross-falls"],
            correctAnswer: "Gradients",
            explanation: "Vertical alignment deals with vertical curves and Gradients."
          },
          {
            id: 41,
            question: "Drainage structure parallel to road to intercept rain in hilly region is ___ drain.",
            options: ["Side", "Valley", "Catch", "Soak"],
            correctAnswer: "Catch",
            explanation: "Drainage structure parallel to road to intercept rain in hilly region is Catch drain."
          },
          {
            id: 42,
            question: "If speed of overtaken vehicle is 80 kmph, design speed = ___.",
            options: ["80 kmph", "88 kmph", "96 kmph", "100 kmph"],
            correctAnswer: "96 kmph",
            explanation: "If speed of overtaken vehicle is 80 kmph, design speed = 96 kmph."
          },
          {
            id: 43,
            question: "Minimum width of a single lane road is ___ m.",
            options: ["3.0", "3.25", "3.5", "3.75"],
            correctAnswer: "3.75",
            explanation: "Minimum width of a single lane road is 3.75 m."
          },
          {
            id: 44,
            question: "Basic capacity of road can be calculated as ___.",
            options: ["1000V/(L-S)", "1000V/(L+S)", "1000V×S/L", "1000×L×S/V"],
            correctAnswer: "1000V/(L+S)",
            explanation: "Basic capacity of road can be calculated as 1000V/(L+S)."
          },
          {
            id: 45,
            question: "In valley curve design, height of head light above road surface is taken as ___ m.",
            options: ["0.50", "0.60", "0.75", "1.00"],
            correctAnswer: "0.75",
            explanation: "In valley curve design, height of head light above road surface is taken as 0.75 m."
          },
          {
            id: 46,
            question: "Distance between two samples in penetration test should be ___ mm.",
            options: ["5", "8", "10", "15"],
            correctAnswer: "10",
            explanation: "Distance between two samples in penetration test should be 10 mm."
          },
          {
            id: 47,
            question: "If penetration grade is 62, penetration value is ___ mm.",
            options: ["4.2", "5.2", "6.2", "7.2"],
            correctAnswer: "6.2",
            explanation: "If penetration grade is 62, penetration value is 6.2 mm."
          },
          {
            id: 48,
            question: "Vacuum capillary tube viscometer test is suitable for temperature range of ___°C.",
            options: ["10±0.1", "15±0.1", "20±0.1", "25±0.1"],
            correctAnswer: "20±0.1",
            explanation: "Vacuum capillary tube viscometer test is suitable for temperature range of 20±0.1°C."
          },
          {
            id: 49,
            question: "Distribution factor for 4 lane road in Nepal is ___.",
            options: ["0.3", "0.35", "0.4", "0.5"],
            correctAnswer: "0.4",
            explanation: "Distribution factor for 4 lane road in Nepal is 0.4."
          },
          {
            id: 50,
            question: "If total lost time is 10 for sum of proportion 0.6, optimal cycle length is ___.",
            options: ["35", "45", "50", "60"],
            correctAnswer: "50",
            explanation: "If total lost time is 10 for sum of proportion 0.6, optimal cycle length is 50."
          },
          {
            id: 51,
            question: "Minimum value of 15-minute peak hour factor on a section of road is ___.",
            options: ["0.10", "0.15", "0.20", "0.25"],
            correctAnswer: "0.25",
            explanation: "Minimum value of 15-minute peak hour factor on a section of road is 0.25."
          },
          {
            id: 52,
            question: "Lane Distribution Factor (LDF) for 4 lane road is ___.",
            options: ["0.3", "0.35", "0.4", "0.5"],
            correctAnswer: "0.4",
            explanation: "Lane Distribution Factor (LDF) for 4 lane road is 0.4."
          },
          {
            id: 53,
            question: "'School ahead' sign is a type of ___ sign.",
            options: ["Mandatory", "Informatory", "Regulatory", "Cautionary"],
            correctAnswer: "Cautionary",
            explanation: "'School ahead' sign is a type of Cautionary sign."
          },
          {
            id: 54,
            question: "Standard temperature for rebound (Benkleman beam) deflection calculation is ___°C.",
            options: ["25", "30", "35", "40"],
            correctAnswer: "35",
            explanation: "Standard temperature for rebound (Benkleman beam) deflection calculation is 35°C."
          },
          {
            id: 55,
            question: "In Benkleman beam test, deflection checked for single lane road at ___ m from edge.",
            options: ["0.3", "0.45", "0.6", "0.9"],
            correctAnswer: "0.6",
            explanation: "In Benkleman beam test, deflection checked for single lane road at 0.6 m from edge."
          },
          {
            id: 56,
            question: "Highest quality construction in group of black top pavements is ___ concrete.",
            options: ["Dense graded", "Open graded", "Bituminous", "Stone mastic"],
            correctAnswer: "Bituminous",
            explanation: "Highest quality construction in group of black top pavements is Bituminous concrete."
          },
          {
            id: 57,
            question: "Thin hairline crack is also known as ___.",
            options: ["Rutting", "Ravelling", "Crazing", "Shoving"],
            correctAnswer: "Crazing",
            explanation: "Thin hairline crack is also known as Crazing."
          },
          {
            id: 58,
            question: "For sandy soils, most common stabilization method is soil-___.",
            options: ["Lime", "Bitumen", "Cement", "Fly ash"],
            correctAnswer: "Cement",
            explanation: "For sandy soils, most common stabilization method is soil-Cement."
          },
          {
            id: 59,
            question: "Longitudinal depression in wheel path in bituminous pavements is ___.",
            options: ["Shoving", "Ravelling", "Rutting", "Crazing"],
            correctAnswer: "Rutting",
            explanation: "Longitudinal depression in wheel path in bituminous pavements is Rutting."
          },
          {
            id: 60,
            question: "According to DOR, maximum thickness of sub-base/premix pavement is ___ cm.",
            options: ["20", "25", "30", "35"],
            correctAnswer: "30",
            explanation: "According to DOR, maximum thickness of sub-base/premix pavement is 30 cm."
          },
          {
            id: 61,
            question: "Pot hole maintenance in bituminous road is ___ maintenance.",
            options: ["Emergency", "Periodic", "Recurrent", "Preventive"],
            correctAnswer: "Recurrent",
            explanation: "Pot hole maintenance in bituminous road is Recurrent maintenance."
          },
          {
            id: 62,
            question: "Equivalent wheel load of 100 kN load is ___ times repetition of design load.",
            options: ["1.5", "2.0", "2.25", "2.5"],
            correctAnswer: "2.25",
            explanation: "Equivalent wheel load of 100 kN load is 2.25 times repetition of design load."
          },
          {
            id: 63,
            question: "Road with high mobility and least accessibility is called ___ highway.",
            options: ["Feeder", "District", "Local", "National"],
            correctAnswer: "National",
            explanation: "Road with high mobility and least accessibility is called National highway."
          },
          {
            id: 64,
            question: "Survey in which details are covered roughly but not accurately is called ___.",
            options: ["Preliminary survey", "Map study", "Reconnaissance", "Detailed survey"],
            correctAnswer: "Reconnaissance",
            explanation: "Survey in which details are covered roughly but not accurately is called Reconnaissance."
          },
          {
            id: 65,
            question: "Vehicle with highest equivalent factors (6 PCU) is ___.",
            options: ["Truck", "Bus", "Bicycle", "Bull carts"],
            correctAnswer: "Bull carts",
            explanation: "Vehicle with highest equivalent factors (6 PCU) is Bull carts."
          },
          {
            id: 66,
            question: "A vehicle changing path without changing destination — that path is known as ___ path.",
            options: ["Alternate", "Detour", "Diversion", "Bypass"],
            correctAnswer: "Diversion",
            explanation: "A vehicle changing path without changing destination — that path is known as Diversion path."
          }
        ]
      },
      {
        id: 2,
        title: "Geometric design of highway",
        description: "Basic design control and criteria; elements of highway cross-section; highway curves; super elevation; average and ruling gradients; stopping sight distance; design considerations for horizontal and vertical alignments, extra widening, and set back distance; design of road drainage structures; design considerations for hill roads.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Extra widening is equal to sum of Mechanical and ___ widening.",
            options: ["Safety", "Visibility", "Psychological", "Friction"],
            correctAnswer: "Psychological",
            explanation: "Extra widening is equal to sum of Mechanical and Psychological widening."
          },
          {
            id: 2,
            question: "Formula of mechanical extra widening in road is ___.",
            options: ["Wm = nl/2R", "Wm = nl²/2R", "Wm = n²l/2R", "Wm = nl²/R"],
            correctAnswer: "Wm = nl²/2R",
            explanation: "Formula of mechanical extra widening in road is Wm = nl²/2R."
          },
          {
            id: 3,
            question: "The relationship between SSD and ISD is ISD = ___ SSD.",
            options: ["1.5", "2", "2.5", "3"],
            correctAnswer: "2",
            explanation: "The relationship between SSD and ISD is ISD = 2 SSD."
          },
          {
            id: 4,
            question: "As per NURS 2071, the maximum gradient [%] for hair pin bend is ___.",
            options: ["2%", "3%", "4%", "5%"],
            correctAnswer: "4%",
            explanation: "As per NURS 2071, the maximum gradient [%] for hair pin bend is 4%."
          },
          {
            id: 5,
            question: "The minimum radius of curvature for hair pin bend in hill roads is ___ m.",
            options: ["10", "12", "15", "20"],
            correctAnswer: "15",
            explanation: "The minimum radius of curvature for hair pin bend in hill roads is 15 m."
          },
          {
            id: 6,
            question: "Super elevation formula in hilly roads is e = ___.",
            options: ["V²/225R", "V²/127R", "V²/100R", "V/127R"],
            correctAnswer: "V²/127R",
            explanation: "Super elevation formula in hilly roads is e = V²/127R."
          },
          {
            id: 7,
            question: "The brake reaction time of a normal driver is ___ sec.",
            options: ["1.5", "2.0", "2.5", "3.0"],
            correctAnswer: "2.5",
            explanation: "The brake reaction time of a normal driver is 2.5 sec."
          },
          {
            id: 8,
            question: "The distance travelled by moving vehicles during perception and brake reaction time is known as ___ distance.",
            options: ["Stopping", "Braking", "Lag", "Overtaking"],
            correctAnswer: "Lag",
            explanation: "The distance travelled by moving vehicles during perception and brake reaction time is known as Lag distance."
          },
          {
            id: 9,
            question: "For the purpose of measuring the stopping sight distance, the height of the object is suggested as ___ cm above the road surface.",
            options: ["10", "12", "15", "20"],
            correctAnswer: "15",
            explanation: "For the purpose of measuring the stopping sight distance, the height of the object is suggested as 15 cm above the road surface."
          },
          {
            id: 10,
            question: "Gradient is NOT related to ___ of road.",
            options: ["Longitudinal slope", "Cross section", "Alignment", "Pavement design"],
            correctAnswer: "Cross section",
            explanation: "Gradient is NOT related to Cross section of road."
          },
          {
            id: 11,
            question: "A gradient is called exceptional if it is less than minimum gradient or ___ maximum gradient.",
            options: ["Equal to", "Less than", "More than", "Twice"],
            correctAnswer: "More than",
            explanation: "A gradient is called exceptional if it is less than minimum gradient or More than maximum gradient."
          },
          {
            id: 12,
            question: "As per NURS 2071, maximum gradient for hair pin bend is ___.",
            options: ["2%", "3%", "4%", "5%"],
            correctAnswer: "4%",
            explanation: "As per NURS 2071, maximum gradient for hair pin bend is 4%."
          },
          {
            id: 13,
            question: "Minimum radius of curvature for hair pin bend in hill roads is ___ m.",
            options: ["10", "12", "15", "20"],
            correctAnswer: "15",
            explanation: "Minimum radius of curvature for hair pin bend in hill roads is 15 m."
          },
          {
            id: 14,
            question: "Maximum vertical clearance in hill road for overhanging cliff is ___ m.",
            options: ["3", "4", "5", "6"],
            correctAnswer: "5",
            explanation: "Maximum vertical clearance in hill road for overhanging cliff is 5 m."
          },
          {
            id: 15,
            question: "Brake reaction time of a normal driver is ___ sec.",
            options: ["1.5", "2.0", "2.5", "3.0"],
            correctAnswer: "2.5",
            explanation: "Brake reaction time of a normal driver is 2.5 sec."
          },
          {
            id: 16,
            question: "Distance travelled by moving vehicles during perception and brake reaction time is called ___ distance.",
            options: ["Stopping", "Overtaking", "Lag", "Braking"],
            correctAnswer: "Lag",
            explanation: "Distance travelled by moving vehicles during perception and brake reaction time is called Lag distance."
          },
          {
            id: 17,
            question: "For measuring stopping sight distance, height of object above road surface is suggested as ___ cm.",
            options: ["10", "12", "15", "20"],
            correctAnswer: "15",
            explanation: "For measuring stopping sight distance, height of object above road surface is suggested as 15 cm."
          },
          {
            id: 18,
            question: "Super elevation in horizontal curve is to counteract ___ force.",
            options: ["Gravitational", "Centripetal", "Centrifugal", "Frictional"],
            correctAnswer: "Centrifugal",
            explanation: "Super elevation in horizontal curve is to counteract Centrifugal force."
          },
          {
            id: 19,
            question: "On pavement with parabolic camber, angle of inclination of vehicles will be more at ___.",
            options: ["Center", "Edges", "Quarter points", "Random"],
            correctAnswer: "Edges",
            explanation: "On pavement with parabolic camber, angle of inclination of vehicles will be more at Edges."
          }
        ]
      },
      {
        id: 3,
        title: "Highway materials",
        description: "Types of aggregates and tests on their gradation, strength, durability; binding materials and their tests; design of asphalt mixes; evaluation of subgrade soil.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The standard temperature for Marshall Stability test is ___°C.",
            options: ["40", "50", "60", "70"],
            correctAnswer: "60",
            explanation: "The standard temperature for Marshall Stability test is 60°C."
          },
          {
            id: 2,
            question: "Bitumen is obtained from ___.",
            options: ["Coal", "Natural gas", "Petroleum", "Wood"],
            correctAnswer: "Petroleum",
            explanation: "Bitumen is obtained from Petroleum."
          },
          {
            id: 3,
            question: "Minimum bitumen ductility value to use in road is ___ cm.",
            options: ["25", "40", "50", "75"],
            correctAnswer: "50",
            explanation: "Minimum bitumen ductility value to use in road is 50 cm."
          },
          {
            id: 4,
            question: "Rate of stretching bitumen in ductility test is ___ cm/min.",
            options: ["2", "3", "5", "7"],
            correctAnswer: "5",
            explanation: "Rate of stretching bitumen in ductility test is 5 cm/min."
          },
          {
            id: 5,
            question: "The test used to measure weathering of aggregate is ___ test.",
            options: ["Impact", "Abrasion", "Soundness", "Crushing"],
            correctAnswer: "Soundness",
            explanation: "The test used to measure weathering of aggregate is Soundness test."
          },
          {
            id: 6,
            question: "Abrasion test is done for ___.",
            options: ["Toughness", "Hardness", "Durability", "Polishing"],
            correctAnswer: "Hardness",
            explanation: "Abrasion test is done for Hardness."
          },
          {
            id: 7,
            question: "The sieve size used in Los Angeles abrasion test is ___ mm.",
            options: ["1.18", "1.7", "2.36", "4.75"],
            correctAnswer: "1.7",
            explanation: "The sieve size used in Los Angeles abrasion test is 1.7 mm."
          },
          {
            id: 8,
            question: "The bitumen layer spread over old pavement to bind newer pavement layer together is ___ coat.",
            options: ["Prime", "Seal", "Tack", "Bond"],
            correctAnswer: "Tack",
            explanation: "The bitumen layer spread over old pavement to bind newer pavement layer together is Tack coat."
          },
          {
            id: 9,
            question: "Standard temperature for Marshall Stability test is ___°C.",
            options: ["40", "50", "60", "70"],
            correctAnswer: "60",
            explanation: "Standard temperature for Marshall Stability test is 60°C."
          },
          {
            id: 10,
            question: "Bitumen content is determined by ___ test.",
            options: ["Penetration", "Ductility", "Marshall", "Flash point"],
            correctAnswer: "Marshall",
            explanation: "Bitumen content is determined by Marshall test."
          },
          {
            id: 11,
            question: "Bitumen extraction test is typically done at 3600 rpm at ___°C.",
            options: ["60", "80", "100", "110"],
            correctAnswer: "110",
            explanation: "Bitumen extraction test is typically done at 3600 rpm at 110°C."
          },
          {
            id: 12,
            question: "Maximum moisture content in bitumen is ___.",
            options: ["0.1%", "0.2%", "0.5%", "1.0%"],
            correctAnswer: "0.2%",
            explanation: "Maximum moisture content in bitumen is 0.2%."
          },
          {
            id: 13,
            question: "Bitumen layer spread over old pavement to bind newer layer is ___ coat.",
            options: ["Prime", "Seal", "Tack", "Bond"],
            correctAnswer: "Tack",
            explanation: "Bitumen layer spread over old pavement to bind newer layer is Tack coat."
          },
          {
            id: 14,
            question: "Specified temperature in penetration test of bitumen is ___°C.",
            options: ["15", "20", "25", "30"],
            correctAnswer: "25",
            explanation: "Specified temperature in penetration test of bitumen is 25°C."
          }
        ]
      },
      {
        id: 4,
        title: "Traffic engineering and safety",
        description: "Impact of human and vehicular characteristics on traffic planning; traffic operations and regulations; traffic control devices; traffic studies (volume, speed, O&D, traffic capacity, traffic flow characteristics, parking, accident, flow); road intersections (types, configurations, design); traffic lights; factors influencing night visibility, road safety measures.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Daily average traffic calculated based on 30 days survey in 365 days is ___.",
            options: ["AADT", "ADT", "PHV", "DDHV"],
            correctAnswer: "ADT",
            explanation: "Daily average traffic calculated based on 30 days survey in 365 days is ADT."
          },
          {
            id: 2,
            question: "For the movement of vehicles at an intersection without any interference, the type of grade separator preferred is ___.",
            options: ["Trumpet", "Diamond", "Clover leaf", "Rotary"],
            correctAnswer: "Clover leaf",
            explanation: "For the movement of vehicles at an intersection without any interference, the type of grade separator preferred is Clover leaf."
          },
          {
            id: 3,
            question: "The minimum weaving angle in the rotary section is ___°.",
            options: ["10", "12", "15", "20"],
            correctAnswer: "15",
            explanation: "The minimum weaving angle in the rotary section is 15°."
          },
          {
            id: 4,
            question: "The type of parking in which maximum number of vehicles can be parked is ___°.",
            options: ["30", "45", "60", "90"],
            correctAnswer: "90",
            explanation: "The type of parking in which maximum number of vehicles can be parked is 90°."
          },
          {
            id: 5,
            question: "The school ahead is the type of traffic sign of ___ sign.",
            options: ["Mandatory", "Informatory", "Cautionary", "Regulatory"],
            correctAnswer: "Cautionary",
            explanation: "The school ahead is the type of traffic sign of Cautionary sign."
          },
          {
            id: 6,
            question: "The traffic that is prepared based on 365 days of the year is called ___ average daily traffic.",
            options: ["Peak hour", "Design", "Annual average", "Normal"],
            correctAnswer: "Annual average",
            explanation: "The traffic that is prepared based on 365 days of the year is called Annual average average daily traffic."
          },
          {
            id: 7,
            question: "Longitudinal ridging due to the channelization of traffic is called ___.",
            options: ["Rutting", "Shoving", "Grooving", "Corrugation"],
            correctAnswer: "Grooving",
            explanation: "Longitudinal ridging due to the channelization of traffic is called Grooving."
          },
          {
            id: 8,
            question: "Daily average traffic based on 30 days survey in 365 days is ___.",
            options: ["AADT", "PHV", "ADT", "DDHV"],
            correctAnswer: "ADT",
            explanation: "Daily average traffic based on 30 days survey in 365 days is ADT."
          },
          {
            id: 9,
            question: "Longitudinal ridging due to channelization of traffic is called ___.",
            options: ["Rutting", "Shoving", "Grooving", "Corrugation"],
            correctAnswer: "Grooving",
            explanation: "Longitudinal ridging due to channelization of traffic is called Grooving."
          },
          {
            id: 10,
            question: "At intersection of two roads, grade separator preferred for vehicle movement without interference is ___.",
            options: ["Trumpet", "Diamond", "Clover leaf", "Rotary"],
            correctAnswer: "Clover leaf",
            explanation: "At intersection of two roads, grade separator preferred for vehicle movement without interference is Clover leaf."
          },
          {
            id: 11,
            question: "An intersection provided for different levels of the road is called ___ intersection.",
            options: ["At-grade", "Channelized", "Grade-separated", "Rotary"],
            correctAnswer: "Grade-separated",
            explanation: "An intersection provided for different levels of the road is called Grade-separated intersection."
          },
          {
            id: 12,
            question: "Minimum weaving angle in rotary section is ___°.",
            options: ["10", "12", "15", "20"],
            correctAnswer: "15",
            explanation: "Minimum weaving angle in rotary section is 15°."
          },
          {
            id: 13,
            question: "Procedure of adopting medians and traffic islands in unchannelized intersection is called ___.",
            options: ["Rotary design", "Signal design", "Channelizing", "Intersection control"],
            correctAnswer: "Channelizing",
            explanation: "Procedure of adopting medians and traffic islands in unchannelized intersection is called Channelizing."
          },
          {
            id: 14,
            question: "'Clearance time' at traffic signal is indicated by ___ light.",
            options: ["Red", "Green", "Amber", "Flashing red"],
            correctAnswer: "Amber",
            explanation: "'Clearance time' at traffic signal is indicated by Amber light."
          },
          {
            id: 15,
            question: "The effect of using traffic signals is to reduce right turn but may ___ rear end accidents.",
            options: ["Reduce", "Eliminate", "Increase", "Not affect"],
            correctAnswer: "Increase",
            explanation: "The effect of using traffic signals is to reduce right turn but may Increase rear end accidents."
          },
          {
            id: 16,
            question: "Maximum number of vehicles that can pass a given point per hour is called traffic ___.",
            options: ["Flow", "Volume", "Capacity", "Density"],
            correctAnswer: "Capacity",
            explanation: "Maximum number of vehicles that can pass a given point per hour is called traffic Capacity."
          },
          {
            id: 17,
            question: "Type of parking accommodating maximum number of vehicles is ___° parking.",
            options: ["30", "45", "60", "90"],
            correctAnswer: "90",
            explanation: "Type of parking accommodating maximum number of vehicles is 90° parking."
          },
          {
            id: 18,
            question: "Traffic survey based on 365 days per year gives ___.",
            options: ["Peak hour volume", "Design hour volume", "Annual average daily traffic", "Monthly daily traffic"],
            correctAnswer: "Annual average daily traffic",
            explanation: "Traffic survey based on 365 days per year gives Annual average daily traffic."
          },
          {
            id: 19,
            question: "Accident book is a legal document that records details of an accident ___.",
            options: ["In court", "For insurance", "In the workplace", "With police"],
            correctAnswer: "In the workplace",
            explanation: "Accident book is a legal document that records details of an accident In the workplace."
          },
          {
            id: 20,
            question: "Recommended speed limit for traffic in rotary (roundabout) for urban areas is ___ km/hr.",
            options: ["20", "25", "30", "40"],
            correctAnswer: "30",
            explanation: "Recommended speed limit for traffic in rotary (roundabout) for urban areas is 30 km/hr."
          },
          {
            id: 21,
            question: "Relation between mid ordinate (MO) and Intersection Point (IP) is ___.",
            options: ["MO > IP", "MO = IP", "IP > MO", "MO < IP (but not IP > MO)"],
            correctAnswer: "IP > MO",
            explanation: "Relation between mid ordinate (MO) and Intersection Point (IP) is IP > MO."
          }
        ]
      },
      {
        id: 5,
        title: "Road pavement",
        description: "Different types of pavement; design methods for flexible and rigid pavements (DOR Guidelines); loads and other factors controlling pavement design; stress due to load, temperature.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "In CBR test, the rate of penetration of plunger is ___ mm/min.",
            options: ["0.5", "1.0", "1.25", "2.0"],
            correctAnswer: "1.25",
            explanation: "In CBR test, the rate of penetration of plunger is 1.25 mm/min."
          },
          {
            id: 2,
            question: "The design factor not considered in CBR is ___.",
            options: ["Traffic", "Subgrade strength", "Pavement thickness", "Weather"],
            correctAnswer: "Weather",
            explanation: "The design factor not considered in CBR is Weather."
          },
          {
            id: 3,
            question: "Tie bars in rigid pavements provide across ___ joints.",
            options: ["Transverse", "Expansion", "Contraction", "Longitudinal"],
            correctAnswer: "Longitudinal",
            explanation: "Tie bars in rigid pavements provide across Longitudinal joints."
          },
          {
            id: 4,
            question: "The dowel bars are used in rigid pavements for ___ load from one portion to another.",
            options: ["Absorbing", "Redistributing", "Transferring", "Reducing"],
            correctAnswer: "Transferring",
            explanation: "The dowel bars are used in rigid pavements for Transferring load from one portion to another."
          },
          {
            id: 5,
            question: "In flexible pavement, rolling is done from ___ to center.",
            options: ["Corners", "Joints", "Edges", "Ends"],
            correctAnswer: "Edges",
            explanation: "In flexible pavement, rolling is done from Edges to center."
          },
          {
            id: 6,
            question: "If CBR = 5%, then resilient modulus as per NRS (Mr) = ___.",
            options: ["25 MPa", "35 MPa", "50 MPa", "75 MPa"],
            correctAnswer: "50 MPa",
            explanation: "If CBR = 5%, then resilient modulus as per NRS (Mr) = 50 MPa."
          },
          {
            id: 7,
            question: "Minimum thickness of the base of a flexible pavement is ___ cm.",
            options: ["5", "7.5", "10", "15"],
            correctAnswer: "10",
            explanation: "Minimum thickness of the base of a flexible pavement is 10 cm."
          },
          {
            id: 8,
            question: "The load transfer to lower layers in flexible pavements is grain to grain ___.",
            options: ["Friction", "Bonding", "Contact", "Interlocking"],
            correctAnswer: "Contact",
            explanation: "The load transfer to lower layers in flexible pavements is grain to grain Contact."
          },
          {
            id: 9,
            question: "If CBR = 5%, resilient modulus as per NRS (Mr) = ___ MPa.",
            options: ["25", "35", "50", "75"],
            correctAnswer: "50",
            explanation: "If CBR = 5%, resilient modulus as per NRS (Mr) = 50 MPa."
          },
          {
            id: 10,
            question: "In CBR test, if CBR value at 5 mm > at 2.5 mm, the test should be ___.",
            options: ["Accepted", "Averaged", "Rejected", "Repeated"],
            correctAnswer: "Repeated",
            explanation: "In CBR test, if CBR value at 5 mm > at 2.5 mm, the test should be Repeated."
          },
          {
            id: 11,
            question: "In CBR test, rate of penetration of plunger is ___ mm/min.",
            options: ["0.5", "1.0", "1.25", "2.0"],
            correctAnswer: "1.25",
            explanation: "In CBR test, rate of penetration of plunger is 1.25 mm/min."
          },
          {
            id: 12,
            question: "Design factor NOT considered in CBR is ___.",
            options: ["Traffic", "Subgrade strength", "Pavement thickness", "Weather"],
            correctAnswer: "Weather",
            explanation: "Design factor NOT considered in CBR is Weather."
          },
          {
            id: 13,
            question: "Probable cause of rutting on flexible pavements is inadequate ___ of pavement layers.",
            options: ["Drainage", "Thickness", "Compaction", "Binding"],
            correctAnswer: "Compaction",
            explanation: "Probable cause of rutting on flexible pavements is inadequate Compaction of pavement layers."
          },
          {
            id: 14,
            question: "Minimum thickness of base of flexible pavement is ___ cm.",
            options: ["5", "7.5", "10", "15"],
            correctAnswer: "10",
            explanation: "Minimum thickness of base of flexible pavement is 10 cm."
          },
          {
            id: 15,
            question: "Coefficient of subgrade does NOT depend upon ___.",
            options: ["Soil type", "Load intensity", "Water table", "Moisture content"],
            correctAnswer: "Water table",
            explanation: "Coefficient of subgrade does NOT depend upon Water table."
          },
          {
            id: 16,
            question: "Factor NOT primarily influencing subgrade capacity is ___.",
            options: ["Subgrade soil type", "Traffic loading", "Pavement thickness", "Seismic activity"],
            correctAnswer: "Seismic activity",
            explanation: "Factor NOT primarily influencing subgrade capacity is Seismic activity."
          },
          {
            id: 17,
            question: "Load transfer to lower layers in flexible pavements is grain to grain ___.",
            options: ["Friction", "Bonding", "Contact", "Interlocking"],
            correctAnswer: "Contact",
            explanation: "Load transfer to lower layers in flexible pavements is grain to grain Contact."
          },
          {
            id: 18,
            question: "Dowel bars in rigid pavements are used for ___ load from one portion to another.",
            options: ["Absorbing", "Reducing", "Transferring", "Eliminating"],
            correctAnswer: "Transferring",
            explanation: "Dowel bars in rigid pavements are used for Transferring load from one portion to another."
          },
          {
            id: 19,
            question: "Correct sequence of flexible pavement construction is excavation, application of binder material, ___, compaction.",
            options: ["Base course laying", "Spreading of premix", "Sub-base preparation", "Priming"],
            correctAnswer: "Spreading of premix",
            explanation: "Correct sequence of flexible pavement construction is excavation, application of binder material, Spreading of premix, compaction."
          }
        ]
      },
      {
        id: 6,
        title: "Road construction & maintenance",
        description: "Activities, techniques, tools, equipment and plants used in road construction; preparation of road subgrade; field compaction control and soil stabilization; construction of asphalt concrete layers; construction procedure for penetration macadam, bituminous bound macadam and plain cement concrete pavements; road maintenance, repair and rehabilitation.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "In mass haul diagram, if end is negative then it means ___.",
            options: ["Cut", "Fill", "Balance", "Burrow"],
            correctAnswer: "Burrow",
            explanation: "In mass haul diagram, if end is negative then it means Burrow."
          },
          {
            id: 2,
            question: "The slope of a Mass Haul Diagram gives the rate of change of earthwork volume over ___.",
            options: ["Time", "Cost", "Distance", "Depth"],
            correctAnswer: "Distance",
            explanation: "The slope of a Mass Haul Diagram gives the rate of change of earthwork volume over Distance."
          },
          {
            id: 3,
            question: "The roller used to compact the coarse grained soil is ___ roller.",
            options: ["Sheep foot", "Smooth wheel", "Pneumatic tyred", "Vibratory"],
            correctAnswer: "Vibratory",
            explanation: "The roller used to compact the coarse grained soil is Vibratory roller."
          },
          {
            id: 4,
            question: "In water bound macadam roads, binding material is stone ___.",
            options: ["Chips", "Grit", "Dust", "Fragments"],
            correctAnswer: "Dust",
            explanation: "In water bound macadam roads, binding material is stone Dust."
          },
          {
            id: 5,
            question: "Maximum ordinate of mass haul diagram occurs at end of a ___.",
            options: ["Filling", "Balancing", "Cutting", "Hauling"],
            correctAnswer: "Cutting",
            explanation: "Maximum ordinate of mass haul diagram occurs at end of a Cutting."
          },
          {
            id: 6,
            question: "In mass haul diagram, negative sign represents ___.",
            options: ["Cutting", "Hauling", "Filling", "Balancing"],
            correctAnswer: "Filling",
            explanation: "In mass haul diagram, negative sign represents Filling."
          },
          {
            id: 7,
            question: "In mass haul diagram, if the end is negative, it means ___.",
            options: ["Waste", "Balance", "Burrow", "Cut"],
            correctAnswer: "Burrow",
            explanation: "In mass haul diagram, if the end is negative, it means Burrow."
          },
          {
            id: 8,
            question: "Premix used in the base course is ___ bound macadam.",
            options: ["Water", "Tar", "Bituminous", "Cement"],
            correctAnswer: "Bituminous",
            explanation: "Premix used in the base course is Bituminous bound macadam."
          },
          {
            id: 9,
            question: "In penetration macadam construction, bitumen is sprayed after aggregates are ___ and compacted.",
            options: ["Cut", "Wetted", "Spread", "Heated"],
            correctAnswer: "Spread",
            explanation: "In penetration macadam construction, bitumen is sprayed after aggregates are Spread and compacted."
          },
          {
            id: 10,
            question: "Roller used to compact coarse grained soil is ___ roller.",
            options: ["Sheep foot", "Smooth wheel", "Pneumatic tyred", "Vibratory"],
            correctAnswer: "Vibratory",
            explanation: "Roller used to compact coarse grained soil is Vibratory roller."
          }
        ]
      }
    ]
  },
  {
    id: 10,
    title: "Project Planning, Design and Implementation",
    code: "AALL10",
    topics: [
      {
        id: 1,
        title: "Engineering drawings and its concepts",
        description: "Fundamentals of standard drawing sheets, dimensions, scale, line diagram, orthographic projection, isometric projection/view, pictorial views, and sectional drawing.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "The size of the letter means the ___ of the letter.",
            options: ["Width", "Height", "Thickness", "Area"],
            correctAnswer: "Height",
            explanation: "The size of the letter means the Height of the letter."
          },
          {
            id: 2,
            question: "The Aspect ratio (width:height) of a Letter is ___.",
            options: ["1:1", "1:2", "1:3", "2:1"],
            correctAnswer: "1:2",
            explanation: "The Aspect ratio (width:height) of a Letter is 1:2."
          },
          {
            id: 3,
            question: "___ degrees is the inclination of inclined lettering.",
            options: ["60", "70", "75", "80"],
            correctAnswer: "75",
            explanation: "75 degrees is the inclination of inclined lettering."
          },
          {
            id: 4,
            question: "The Area of A0 size paper is ___ m².",
            options: ["0.5", "0.75", "1", "2"],
            correctAnswer: "1",
            explanation: "The Area of A0 size paper is 1 m²."
          },
          {
            id: 5,
            question: "Maps are drawn in ___ scale.",
            options: ["Full", "Enlarging", "Reducing", "Proportional"],
            correctAnswer: "Reducing",
            explanation: "Maps are drawn in Reducing scale."
          },
          {
            id: 6,
            question: "___ is a drawing instrument used for drawing circles or arcs.",
            options: ["Scale", "Protractor", "Compass", "Set square"],
            correctAnswer: "Compass",
            explanation: "Compass is a drawing instrument used for drawing circles or arcs."
          },
          {
            id: 7,
            question: "Aspect ratio of Letter (width:height) is 1:2 and Number is ___.",
            options: ["1:1", "1:2", "1:3", "2:1"],
            correctAnswer: "1:3",
            explanation: "Aspect ratio of Letter (width:height) is 1:2 and Number is 1:3."
          },
          {
            id: 8,
            question: "Inclination of inclined lettering is ___ degrees.",
            options: ["60", "70", "75", "80"],
            correctAnswer: "75",
            explanation: "Inclination of inclined lettering is 75 degrees."
          },
          {
            id: 9,
            question: "Paper in drawing is designated by letter ___.",
            options: ["B", "A", "C", "D"],
            correctAnswer: "A",
            explanation: "Paper in drawing is designated by letter A."
          },
          {
            id: 10,
            question: "Area of A0 size paper is ___ m².",
            options: ["0.5", "0.75", "1", "2"],
            correctAnswer: "1",
            explanation: "Area of A0 size paper is 1 m²."
          },
          {
            id: 11,
            question: "Width of standard A-series drawing paper is ___ times the length.",
            options: ["1/√3", "1/√2", "1/2", "2/3"],
            correctAnswer: "1/√2",
            explanation: "Width of standard A-series drawing paper is 1/√2 times the length."
          },
          {
            id: 12,
            question: "Standard size of drawing board designation D1 is ___ mm.",
            options: ["900×600×25", "1000×700×25", "1200×900×25", "800×600×25"],
            correctAnswer: "1000×700×25",
            explanation: "Standard size of drawing board designation D1 is 1000×700×25 mm."
          },
          {
            id: 13,
            question: "Section lines are used to show when the object is ___ and then viewed.",
            options: ["Assembled", "Cut", "Exploded", "Rotated"],
            correctAnswer: "Cut",
            explanation: "Section lines are used to show when the object is Cut and then viewed."
          },
          {
            id: 14,
            question: "Hidden lines are drawn as ___ lines.",
            options: ["Continuous narrow", "Dashed narrow", "Chain dotted", "Solid thick"],
            correctAnswer: "Dashed narrow",
            explanation: "Hidden lines are drawn as Dashed narrow lines."
          },
          {
            id: 15,
            question: "___ sketch shows the front in true shape.",
            options: ["Isometric", "Perspective", "Oblique", "Orthographic"],
            correctAnswer: "Oblique",
            explanation: "Oblique sketch shows the front in true shape."
          },
          {
            id: 16,
            question: "If isometric drawing uses isometric scale, it is called ___ projection.",
            options: ["Oblique", "Orthographic", "Isometric", "Perspective"],
            correctAnswer: "Isometric",
            explanation: "If isometric drawing uses isometric scale, it is called Isometric projection."
          },
          {
            id: 17,
            question: "The object Frustum of Cone — in third angle orthogonal projection its third view is ___.",
            options: ["Circle", "Ellipse", "Rectangle", "Trapezoid"],
            correctAnswer: "Circle",
            explanation: "The object Frustum of Cone — in third angle orthogonal projection its third view is Circle."
          },
          {
            id: 18,
            question: "Which angle CANNOT be made with the help of a Set Square?",
            options: ["30°", "45°", "75°", "115°"],
            correctAnswer: "115°",
            explanation: "115° is the correct answer."
          },
          {
            id: 19,
            question: "Technique for free hand sketch to draw a circle is fixing a fixed point and ___.",
            options: ["Straight line", "Grid", "Arc", "Parallel lines"],
            correctAnswer: "Arc",
            explanation: "Technique for free hand sketch to draw a circle is fixing a fixed point and Arc."
          },
          {
            id: 20,
            question: "Which of the following is NOT a pencil grade?",
            options: ["HB", "H", "B", "HB1"],
            correctAnswer: "HB1",
            explanation: "HB1 is the correct answer."
          },
          {
            id: 21,
            question: "___ chart method of project planning was invented first.",
            options: ["Gantt/bar", "Network", "CPM", "PERT"],
            correctAnswer: "Gantt/bar",
            explanation: "Gantt/bar chart method of project planning was invented first."
          },
          {
            id: 22,
            question: "Hidden line represents features that ___ in the current view.",
            options: ["Are visible", "Are highlighted", "Cannot be seen", "Are dimensioned"],
            correctAnswer: "Cannot be seen",
            explanation: "Hidden line represents features that Cannot be seen in the current view."
          },
          {
            id: 23,
            question: "Compass is a drawing instrument used for drawing circles or ___.",
            options: ["Polygons", "Squares", "Arcs", "Ellipses"],
            correctAnswer: "Arcs",
            explanation: "Compass is a drawing instrument used for drawing circles or Arcs."
          },
          {
            id: 24,
            question: "Symbol R in dimension represents ___.",
            options: ["Roughness", "Ratio", "Radius", "Reaction"],
            correctAnswer: "Radius",
            explanation: "Symbol R in dimension represents Radius."
          },
          {
            id: 25,
            question: "French curve is used to draw ___ curves.",
            options: ["Straight", "Smooth free form", "Geometric", "Parallel"],
            correctAnswer: "Smooth free form",
            explanation: "French curve is used to draw Smooth free form curves."
          },
          {
            id: 26,
            question: "Pencil ___ is used to draw visible lines.",
            options: ["H", "HB", "B", "2B"],
            correctAnswer: "B",
            explanation: "Pencil B is used to draw visible lines."
          },
          {
            id: 27,
            question: "If company can choose only one option among alternatives, alternatives are ___ exclusive.",
            options: ["Collectively", "Mutually", "Jointly", "Independently"],
            correctAnswer: "Mutually",
            explanation: "If company can choose only one option among alternatives, alternatives are Mutually exclusive."
          },
          {
            id: 28,
            question: "The locus traced by a point on a swinging pendulum is a ___.",
            options: ["Circle", "Ellipse", "Spiral", "Parabola"],
            correctAnswer: "Spiral",
            explanation: "The locus traced by a point on a swinging pendulum is a Spiral."
          }
        ]
      },
      {
        id: 2,
        title: "Engineering Economics",
        description: "Understanding of project cash flow; discount rate, interest and time value of money; basic methodologies for engineering economics analysis (Discounted Payback Period, NPV, IRR & MARR); comparison of alternatives, depreciation system and taxation system in Nepal.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "IRR is calculated when NPV equal to ___.",
            options: ["Maximum", "Minimum", "1", "0"],
            correctAnswer: "0",
            explanation: "IRR is calculated when NPV equal to 0."
          },
          {
            id: 2,
            question: "The ratio obtained by dividing 'quick assets' by current liabilities is called ___ test ratio.",
            options: ["Current", "Quick", "Acid test", "Leverage"],
            correctAnswer: "Acid test",
            explanation: "The ratio obtained by dividing 'quick assets' by current liabilities is called Acid test test ratio."
          },
          {
            id: 3,
            question: "The term (1+i)ⁿ is called single payment compound ___ factor.",
            options: ["Present worth", "Sinking fund", "Amount", "Capital recovery"],
            correctAnswer: "Amount",
            explanation: "The term (1+i)ⁿ is called single payment compound Amount factor."
          },
          {
            id: 4,
            question: "Sinking fund is defined as fund for rebuilding a structure when its ___ life is over.",
            options: ["Design", "Service", "Economic", "Physical"],
            correctAnswer: "Economic",
            explanation: "Sinking fund is defined as fund for rebuilding a structure when its Economic life is over."
          },
          {
            id: 5,
            question: "The criteria for the acceptance of project is B/C > ___.",
            options: ["0", "0.5", "1", "2"],
            correctAnswer: "1",
            explanation: "The criteria for the acceptance of project is B/C > 1."
          },
          {
            id: 6,
            question: "The formula of effective annual interest rate 'I' is [1+(r/m)]^m ___.",
            options: ["+1", "-1", "×1", "÷1"],
            correctAnswer: "-1",
            explanation: "The formula of effective annual interest rate 'I' is [1+(r/m)]^m -1."
          },
          {
            id: 7,
            question: "IRR is calculated when NPV equals ___.",
            options: ["Maximum", "Minimum", "1", "0"],
            correctAnswer: "0",
            explanation: "IRR is calculated when NPV equals 0."
          },
          {
            id: 8,
            question: "Ratio of quick assets to current liabilities is called ___ ratio.",
            options: ["Current", "Leverage", "Acid test", "Liquidity"],
            correctAnswer: "Acid test",
            explanation: "Ratio of quick assets to current liabilities is called Acid test ratio."
          },
          {
            id: 9,
            question: "In incremental analysis, project with ___ investment is selected as base alternative.",
            options: ["Highest", "Equal", "Lower", "Uncertain"],
            correctAnswer: "Lower",
            explanation: "In incremental analysis, project with Lower investment is selected as base alternative."
          },
          {
            id: 10,
            question: "Debentures ___ require security.",
            options: ["Always", "Sometimes", "Do not", "Must"],
            correctAnswer: "Do not",
            explanation: "Debentures Do not require security."
          },
          {
            id: 11,
            question: "IRR is mostly adopted in ___ enterprises.",
            options: ["Government", "Non-profit", "Business", "Development"],
            correctAnswer: "Business",
            explanation: "IRR is mostly adopted in Business enterprises."
          },
          {
            id: 12,
            question: "Time value of money is relation between ___ and time.",
            options: ["Profit", "Money", "Interest", "Investment"],
            correctAnswer: "Money",
            explanation: "Time value of money is relation between Money and time."
          },
          {
            id: 13,
            question: "For incremental analysis, initial investment must be ___.",
            options: ["Positive", "Negative", "Zero", "Unknown"],
            correctAnswer: "Zero",
            explanation: "For incremental analysis, initial investment must be Zero."
          },
          {
            id: 14,
            question: "Sinking fund is for rebuilding structure when its ___ life is over.",
            options: ["Design", "Physical", "Useful", "Economic"],
            correctAnswer: "Economic",
            explanation: "Sinking fund is for rebuilding structure when its Economic life is over."
          },
          {
            id: 15,
            question: "Criteria for acceptance of project is B/C ___.",
            options: ["< 1", "= 1", "> 1", "= 0"],
            correctAnswer: "> 1",
            explanation: "Criteria for acceptance of project is B/C > 1."
          },
          {
            id: 16,
            question: "If a is base expenditure, b is yearly increase over n years, total maintenance cost is ___.",
            options: ["A + nb", "A + (n-1)b", "A × nb", "A/(n-1) + b"],
            correctAnswer: "A + (n-1)b",
            explanation: "If a is base expenditure, b is yearly increase over n years, total maintenance cost is A + (n-1)b."
          },
          {
            id: 17,
            question: "Rate used to convert future sum to present value is called ___ rate.",
            options: ["Inflation", "Interest", "Discount", "Return"],
            correctAnswer: "Discount",
            explanation: "Rate used to convert future sum to present value is called Discount rate."
          },
          {
            id: 18,
            question: "In compound interest, the ___ is added to future worth at rate i%.",
            options: ["Tax", "Simple interest", "Principal", "Dividend"],
            correctAnswer: "Principal",
            explanation: "In compound interest, the Principal is added to future worth at rate i%."
          },
          {
            id: 19,
            question: "Formula for effective annual interest rate I is [1+(r/m)]^m ___.",
            options: ["+0", "-1", "×1", "÷1"],
            correctAnswer: "-1",
            explanation: "Formula for effective annual interest rate I is [1+(r/m)]^m -1."
          }
        ]
      },
      {
        id: 3,
        title: "Project planning and scheduling",
        description: "Project classifications; project life cycle phases; project planning process; project scheduling (bar chart, CPM, PERT); resources levelling and smoothing; monitoring/evaluation/controlling.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Salvage value is defined as estimated value of a built-up property at the end of its ___ life without being dismantled.",
            options: ["Design", "Service", "Useful", "Economic"],
            correctAnswer: "Useful",
            explanation: "Salvage value is defined as estimated value of a built-up property at the end of its Useful life without being dismantled."
          },
          {
            id: 2,
            question: "SPI (schedule performance index) is the ratio of ___.",
            options: ["BCWS/BCWP", "ACWP/BCWP", "BCWP/BCWS", "BCWP/ACWP"],
            correctAnswer: "BCWP/BCWS",
            explanation: "SPI (schedule performance index) is the ratio of BCWP/BCWS."
          },
          {
            id: 3,
            question: "In Resource levelling the constraint is ___.",
            options: ["Time", "Cost", "Resources", "Quality"],
            correctAnswer: "Resources",
            explanation: "In Resource levelling the constraint is Resources."
          },
          {
            id: 4,
            question: "Free float is defined as the amount of time a task can be delayed without impacting ___ tasks in the path.",
            options: ["Preceding", "Critical", "Other", "All"],
            correctAnswer: "Other",
            explanation: "Free float is defined as the amount of time a task can be delayed without impacting Other tasks in the path."
          },
          {
            id: 5,
            question: "Setting ___ is the first stage in a project formulation.",
            options: ["Budget", "Timeline", "Objectives", "Scope"],
            correctAnswer: "Objectives",
            explanation: "Setting Objectives is the first stage in a project formulation."
          },
          {
            id: 6,
            question: "In PERT analysis, the time estimates of activities and probability follow ___ distribution curve.",
            options: ["Normal", "Poisson", "Beta", "Binomial"],
            correctAnswer: "Beta",
            explanation: "In PERT analysis, the time estimates of activities and probability follow Beta distribution curve."
          },
          {
            id: 7,
            question: "Critical path is the ___ path.",
            options: ["Shortest", "Easiest", "Longest", "Cheapest"],
            correctAnswer: "Longest",
            explanation: "Critical path is the Longest path."
          },
          {
            id: 8,
            question: "The difference between the maximum time available and the actual time needed to perform an activity is known as ___ float.",
            options: ["Free", "Independent", "Interfering", "Total"],
            correctAnswer: "Total",
            explanation: "The difference between the maximum time available and the actual time needed to perform an activity is known as Total float."
          },
          {
            id: 9,
            question: "CPM is the ___ oriented method based for Deterministic, Focus on time-cost tradeoff.",
            options: ["Event", "Node", "Activity", "Resource"],
            correctAnswer: "Activity",
            explanation: "CPM is the Activity oriented method based for Deterministic, Focus on time-cost tradeoff."
          },
          {
            id: 10,
            question: "Resource smoothing is an adjustment of resources without affecting project ___.",
            options: ["Cost", "Quality", "Duration", "Scope"],
            correctAnswer: "Duration",
            explanation: "Resource smoothing is an adjustment of resources without affecting project Duration."
          },
          {
            id: 11,
            question: "The relationship between different time estimates in PERT activity is Te = ___.",
            options: ["(To + Tp + Tm)/3", "(To + Tp + 4Tm)/6", "(To + 4Tp + Tm)/6", "(4To + Tp + Tm)/6"],
            correctAnswer: "(To + Tp + 4Tm)/6",
            explanation: "The relationship between different time estimates in PERT activity is Te = (To + Tp + 4Tm)/6."
          },
          {
            id: 12,
            question: "Project performance consists of time, cost and ___.",
            options: ["Safety", "Quality", "Resources", "Risk"],
            correctAnswer: "Quality",
            explanation: "Project performance consists of time, cost and Quality."
          },
          {
            id: 13,
            question: "Dummy is used for ___ purpose and logical purpose.",
            options: ["Mathematical", "Graphical", "Grammatical", "Statistical"],
            correctAnswer: "Grammatical",
            explanation: "Dummy is used for Grammatical purpose and logical purpose."
          },
          {
            id: 14,
            question: "In CPM, when two activities meet at a node, then ___ value is taken as backward passing.",
            options: ["Maximum", "Average", "Minimum", "Sum"],
            correctAnswer: "Minimum",
            explanation: "In CPM, when two activities meet at a node, then Minimum value is taken as backward passing."
          },
          {
            id: 15,
            question: "Standard deviation is ___.",
            options: ["Variance", "Variance²", "(variance)^1/2", "Variance/2"],
            correctAnswer: "(variance)^1/2",
            explanation: "Standard deviation is (variance)^1/2."
          },
          {
            id: 16,
            question: "In critical path method, the relationship between total float (TF) and free float (FF) is TF ___ FF.",
            options: ["< ", "> ", "= ", "≤ "],
            correctAnswer: "> ",
            explanation: "In critical path method, the relationship between total float (TF) and free float (FF) is TF >  FF."
          },
          {
            id: 17,
            question: "Salvage value is estimated value of property at end of useful life without being ___.",
            options: ["Renovated", "Dismantled", "Repaired", "Replaced"],
            correctAnswer: "Dismantled",
            explanation: "Salvage value is estimated value of property at end of useful life without being Dismantled."
          },
          {
            id: 18,
            question: "SPI (schedule performance index) is ratio of ___.",
            options: ["BCWS/BCWP", "ACWP/BCWP", "BCWP/BCWS", "BCWP/ACWP"],
            correctAnswer: "BCWP/BCWS",
            explanation: "SPI (schedule performance index) is ratio of BCWP/BCWS."
          },
          {
            id: 19,
            question: "Actual cost incurred for work performed by company in project is known as ___.",
            options: ["BCWP", "BCWS", "ACWP", "EV"],
            correctAnswer: "ACWP",
            explanation: "Actual cost incurred for work performed by company in project is known as ACWP."
          },
          {
            id: 20,
            question: "Free float is amount of time task can be delayed without impacting ___ tasks.",
            options: ["Preceding", "Critical", "Succeeding (other)", "All"],
            correctAnswer: "Succeeding (other)",
            explanation: "Free float is amount of time task can be delayed without impacting Succeeding (other) tasks."
          },
          {
            id: 21,
            question: "Setting ___ is the first stage in project formulation.",
            options: ["Budget", "Timeline", "Objectives", "Scope"],
            correctAnswer: "Objectives",
            explanation: "Setting Objectives is the first stage in project formulation."
          },
          {
            id: 22,
            question: "In PERT analysis, time estimates follow ___ distribution curve.",
            options: ["Normal", "Poisson", "Beta", "Binomial"],
            correctAnswer: "Beta",
            explanation: "In PERT analysis, time estimates follow Beta distribution curve."
          },
          {
            id: 23,
            question: "Difference between max time available and actual time needed to perform activity is known as ___ float.",
            options: ["Free", "Independent", "Interfering", "Total"],
            correctAnswer: "Total",
            explanation: "Difference between max time available and actual time needed to perform activity is known as Total float."
          },
          {
            id: 24,
            question: "Technique for establishing priorities among jobs of a project is known as ___ scheduling.",
            options: ["Resource", "Precedence", "Critical ratio", "Milestone"],
            correctAnswer: "Critical ratio",
            explanation: "Technique for establishing priorities among jobs of a project is known as Critical ratio scheduling."
          },
          {
            id: 25,
            question: "CPM method is based for Deterministic, ___ oriented, Focus on time-Cost trade-off.",
            options: ["Event", "Node", "Activity", "Resource"],
            correctAnswer: "Activity",
            explanation: "CPM method is based for Deterministic, Activity oriented, Focus on time-Cost trade-off."
          },
          {
            id: 26,
            question: "EF = ES + Duration is formula to calculate ___ finish time during forward pass.",
            options: ["Latest", "Earliest", "Critical", "Planned"],
            correctAnswer: "Earliest",
            explanation: "EF = ES + Duration is formula to calculate Earliest finish time during forward pass."
          },
          {
            id: 27,
            question: "Resource smoothing is adjustment of resources without affecting project ___.",
            options: ["Cost", "Quality", "Duration", "Scope"],
            correctAnswer: "Duration",
            explanation: "Resource smoothing is adjustment of resources without affecting project Duration."
          },
          {
            id: 28,
            question: "PERT formula Te = (To + Tp + 4Tm)/6 — To is ___ time.",
            options: ["Typical", "Pessimistic", "Optimistic", "Most likely"],
            correctAnswer: "Optimistic",
            explanation: "PERT formula Te = (To + Tp + 4Tm)/6 — To is Optimistic time."
          },
          {
            id: 29,
            question: "Project performance consists of time, ___, and quality.",
            options: ["Scope", "Safety", "Cost", "Risk"],
            correctAnswer: "Cost",
            explanation: "Project performance consists of time, Cost, and quality."
          },
          {
            id: 30,
            question: "In CPM, when two activities meet at a node, ___ value is taken in backward passing.",
            options: ["Maximum", "Average", "Minimum", "Sum"],
            correctAnswer: "Minimum",
            explanation: "In CPM, when two activities meet at a node, Minimum value is taken in backward passing."
          },
          {
            id: 31,
            question: "In CPM, relationship between total float (TF) and free float (FF) is TF ___ FF.",
            options: ["<", ">", "=", "≤"],
            correctAnswer: ">",
            explanation: "In CPM, relationship between total float (TF) and free float (FF) is TF > FF."
          },
          {
            id: 32,
            question: "In CPM, when two activities meet at a node, ___ value is taken as backward passing.",
            options: ["Maximum", "Average", "Minimum", "Sum"],
            correctAnswer: "Minimum",
            explanation: "In CPM, when two activities meet at a node, Minimum value is taken as backward passing."
          },
          {
            id: 33,
            question: "AOA representation — activities are represented while nodes represent ___ of an activity.",
            options: ["Start and end", "Duration", "Cost", "Resource"],
            correctAnswer: "Start and end",
            explanation: "AOA representation — activities are represented while nodes represent Start and end of an activity."
          },
          {
            id: 34,
            question: "Standard deviation is (variance) ^ ___.",
            options: ["2", "1", "1/2", "1/3"],
            correctAnswer: "1/2",
            explanation: "Standard deviation is (variance) ^ 1/2."
          },
          {
            id: 35,
            question: "In CPM, relationship TF ___ FF.",
            options: ["< ", "> ", "= ", "≤ "],
            correctAnswer: "> ",
            explanation: "In CPM, relationship TF >  FF."
          },
          {
            id: 36,
            question: "Dummy is used for grammatical purpose and ___ purpose.",
            options: ["Mathematical", "Logical", "Statistical", "Graphical"],
            correctAnswer: "Logical",
            explanation: "Dummy is used for grammatical purpose and Logical purpose."
          }
        ]
      },
      {
        id: 4,
        title: "Project management",
        description: "Information system; project risk analysis and management; project financing, tender and its process, and contract management.",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "If part of contract work is assigned to another party, it is called ___ contracting.",
            options: ["Joint", "Parallel", "Sub", "Split"],
            correctAnswer: "Sub",
            explanation: "If part of contract work is assigned to another party, it is called Sub contracting."
          },
          {
            id: 2,
            question: "EPC contract stands for Engineering, ___ and Construction.",
            options: ["Planning", "Procurement", "Performance", "Project"],
            correctAnswer: "Procurement",
            explanation: "EPC contract stands for Engineering, Procurement and Construction."
          },
          {
            id: 3,
            question: "Sealed quotations are used for projects up to ___ million.",
            options: ["5", "10", "20", "50"],
            correctAnswer: "20",
            explanation: "Sealed quotations are used for projects up to 20 million."
          },
          {
            id: 4,
            question: "Revised estimate is prepared when original sanctioned detailed estimate exceeds by ___.",
            options: ["0.02", "0.05", "0.10", "0.15"],
            correctAnswer: "0.05",
            explanation: "Revised estimate is prepared when original sanctioned detailed estimate exceeds by 0.05."
          },
          {
            id: 5,
            question: "Quality and workmanship in construction projects are defined in ___.",
            options: ["Bill of quantities", "Drawings", "Specifications", "Contract"],
            correctAnswer: "Specifications",
            explanation: "Quality and workmanship in construction projects are defined in Specifications."
          },
          {
            id: 6,
            question: "There is provision for price adjustment for the project with duration more than ___ months.",
            options: ["6", "9", "12", "18"],
            correctAnswer: "12",
            explanation: "There is provision for price adjustment for the project with duration more than 12 months."
          },
          {
            id: 7,
            question: "The Bid Validity Period for bid having estimated cost up to 100 million is ___ days.",
            options: ["60", "75", "90", "120"],
            correctAnswer: "90",
            explanation: "The Bid Validity Period for bid having estimated cost up to 100 million is 90 days."
          },
          {
            id: 8,
            question: "In rate analysis, the cost of tool and equipment is taken as ___ % of cost of unskilled labor.",
            options: ["1", "2", "3", "5"],
            correctAnswer: "3",
            explanation: "In rate analysis, the cost of tool and equipment is taken as 3 % of cost of unskilled labor."
          },
          {
            id: 9,
            question: "The ultimate method of resolving any dispute with a contractor is ___.",
            options: ["Arbitration", "Negotiation", "Litigation", "Mediation"],
            correctAnswer: "Litigation",
            explanation: "The ultimate method of resolving any dispute with a contractor is Litigation."
          },
          {
            id: 10,
            question: "The damages caused due to delay in work are termed as ___ damage.",
            options: ["Consequential", "Exemplary", "Liquidated", "Nominal"],
            correctAnswer: "Liquidated",
            explanation: "The damages caused due to delay in work are termed as Liquidated damage."
          },
          {
            id: 11,
            question: "The Bid Validity Period for bid having estimated cost up to 100 million is 90 days and RFP stands for ___.",
            options: ["Request for Project", "Request for Payment", "Request for Proposal", "Request for Planning"],
            correctAnswer: "Request for Proposal",
            explanation: "The Bid Validity Period for bid having estimated cost up to 100 million is 90 days and RFP stands for Request for Proposal."
          },
          {
            id: 12,
            question: "If part of contract work is assigned to another party, it is called ___.",
            options: ["Joint venture", "Sub-contracting", "Partnership", "Delegation"],
            correctAnswer: "Sub-contracting",
            explanation: "If part of contract work is assigned to another party, it is called Sub-contracting."
          },
          {
            id: 13,
            question: "___ type of contract was used when Nepal Government handed fast-track project to Nepal Army.",
            options: ["EPC", "PPP", "BOOT", "BOT"],
            correctAnswer: "BOOT",
            explanation: "BOOT type of contract was used when Nepal Government handed fast-track project to Nepal Army."
          },
          {
            id: 14,
            question: "Most important study for financial institution for risk management is ___.",
            options: ["Feasibility", "Appraisal", "EIA", "Audit"],
            correctAnswer: "Appraisal",
            explanation: "Most important study for financial institution for risk management is Appraisal."
          },
          {
            id: 15,
            question: "Revised estimate prepared when original sanctioned estimate exceeds by ___.",
            options: ["0.02", "0.05", "0.10", "0.15"],
            correctAnswer: "0.05",
            explanation: "Revised estimate prepared when original sanctioned estimate exceeds by 0.05."
          },
          {
            id: 16,
            question: "A contract is a legal document between two parties to do or not do ___.",
            options: ["Work", "Payment", "Something", "Services"],
            correctAnswer: "Something",
            explanation: "A contract is a legal document between two parties to do or not do Something."
          },
          {
            id: 17,
            question: "___ selection method is NOT used for selecting a consultant.",
            options: ["Quality and cost based", "Quality based", "Fixed budget", "Quantity and cost-based"],
            correctAnswer: "Quantity and cost-based",
            explanation: "Quantity and cost-based selection method is NOT used for selecting a consultant."
          },
          {
            id: 18,
            question: "There is provision for price adjustment for project with duration more than ___ months.",
            options: ["6", "9", "12", "18"],
            correctAnswer: "12",
            explanation: "There is provision for price adjustment for project with duration more than 12 months."
          },
          {
            id: 19,
            question: "Bid validity period for bid up to 100 million is ___ days.",
            options: ["60", "75", "90", "120"],
            correctAnswer: "90",
            explanation: "Bid validity period for bid up to 100 million is 90 days."
          },
          {
            id: 20,
            question: "In rate analysis, cost of tool and equipment is taken as ___ % of cost of unskilled labor.",
            options: ["1", "2", "3", "5"],
            correctAnswer: "3",
            explanation: "In rate analysis, cost of tool and equipment is taken as 3 % of cost of unskilled labor."
          },
          {
            id: 21,
            question: "Ultimate method of resolving dispute with contractor is ___.",
            options: ["Arbitration", "Negotiation", "Litigation", "Mediation"],
            correctAnswer: "Litigation",
            explanation: "Ultimate method of resolving dispute with contractor is Litigation."
          },
          {
            id: 22,
            question: "Damages caused due to delay in work are termed as ___ damage.",
            options: ["Consequential", "Exemplary", "Liquidated", "Nominal"],
            correctAnswer: "Liquidated",
            explanation: "Damages caused due to delay in work are termed as Liquidated damage."
          },
          {
            id: 23,
            question: "RFP stands for ___.",
            options: ["Request for Project", "Request for Payment", "Request for Proposal", "Request for Planning"],
            correctAnswer: "Request for Proposal",
            explanation: "RFP stands for Request for Proposal."
          },
          {
            id: 24,
            question: "___ offers financial resources to fund a project.",
            options: ["Contractor", "Client", "Sponsor", "Consultant"],
            correctAnswer: "Sponsor",
            explanation: "Sponsor offers financial resources to fund a project."
          },
          {
            id: 25,
            question: "Ultimate method of resolving dispute with a contractor is ___.",
            options: ["Arbitration", "Mediation", "Negotiation", "Litigation"],
            correctAnswer: "Litigation",
            explanation: "Ultimate method of resolving dispute with a contractor is Litigation."
          },
          {
            id: 26,
            question: "Liquidated damage refers to penalty for delaying work beyond ___.",
            options: ["Budget", "Agreed date", "Scope", "Quality standard"],
            correctAnswer: "Agreed date",
            explanation: "Liquidated damage refers to penalty for delaying work beyond Agreed date."
          },
          {
            id: 27,
            question: "RFP stands for Request for ___.",
            options: ["Project", "Payment", "Proposal", "Planning"],
            correctAnswer: "Proposal",
            explanation: "RFP stands for Request for Proposal."
          },
          {
            id: 28,
            question: "In rate analysis, cost of tool and equipment is ___% of cost of unskilled labor.",
            options: ["1", "2", "3", "5"],
            correctAnswer: "3",
            explanation: "In rate analysis, cost of tool and equipment is 3% of cost of unskilled labor."
          }
        ]
      },
      {
        id: 5,
        title: "Engineering professional practice",
        description: "Environment and society; professional ethics; regulatory environment; contemporary issues/problems in engineering; occupational health and safety; roles/responsibilities of Nepal Engineers Association (NEA).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Nepal Engineer's Association (NEA) is established under ___ act.",
            options: ["Company", "Cooperative", "Social service", "Engineering"],
            correctAnswer: "Social service",
            explanation: "Nepal Engineer's Association (NEA) is established under Social service act."
          },
          {
            id: 2,
            question: "As per labor law, workers are not allowed to work continuously for more than ___ hours.",
            options: ["3", "4", "5", "6"],
            correctAnswer: "5",
            explanation: "As per labor law, workers are not allowed to work continuously for more than 5 hours."
          },
          {
            id: 3,
            question: "The punishment for infringement of Copyright for the first time is imprisonment up to ___ months.",
            options: ["3", "6", "12", "24"],
            correctAnswer: "6",
            explanation: "The punishment for infringement of Copyright for the first time is imprisonment up to 6 months."
          },
          {
            id: 4,
            question: "NEA is established under ___ act.",
            options: ["Company", "Cooperative", "Social service", "Engineering council"],
            correctAnswer: "Social service",
            explanation: "NEA is established under Social service act."
          },
          {
            id: 5,
            question: "Per labor law, workers cannot work continuously more than ___ hours.",
            options: ["3", "4", "5", "6"],
            correctAnswer: "5",
            explanation: "Per labor law, workers cannot work continuously more than 5 hours."
          },
          {
            id: 6,
            question: "Punishment for first-time copyright infringement is imprisonment up to ___ months.",
            options: ["3", "6", "12", "24"],
            correctAnswer: "6",
            explanation: "Punishment for first-time copyright infringement is imprisonment up to 6 months."
          },
          {
            id: 7,
            question: "Copyright is a legal framework that protects original works of ___.",
            options: ["Invention", "Discovery", "Authorship", "Trade"],
            correctAnswer: "Authorship",
            explanation: "Copyright is a legal framework that protects original works of Authorship."
          },
          {
            id: 8,
            question: "Design ideas in an article that are mass-used are ___ protected by copyright.",
            options: ["Fully", "Strongly", "Not", "Partially"],
            correctAnswer: "Not",
            explanation: "Design ideas in an article that are mass-used are Not protected by copyright."
          },
          {
            id: 9,
            question: "Semi-government organization is a mix of government and private management with ___ government control.",
            options: ["Full", "No", "Partial", "Independent"],
            correctAnswer: "Partial",
            explanation: "Semi-government organization is a mix of government and private management with Partial government control."
          },
          {
            id: 10,
            question: "Bias towards ___ is not a professional quality of an engineer.",
            options: ["Excellence", "Innovation", "Political parties", "Clients"],
            correctAnswer: "Political parties",
            explanation: "Bias towards Political parties is not a professional quality of an engineer."
          }
        ]
      },
      {
        id: 6,
        title: "Engineering Regulatory Body",
        description: "Nepal Engineering Council (Acts & Regulations).",
        videos: [],
        externalLinks: [],
        mcqs: [
          {
            id: 1,
            question: "Nepal Engineering Council (NEC) is government and autonomous body was established in ___ BS.",
            options: ["2050", "2052", "2055", "2059"],
            correctAnswer: "2055",
            explanation: "Nepal Engineering Council (NEC) is government and autonomous body was established in 2055 BS."
          },
          {
            id: 2,
            question: "Professional codes of conduct issued by NEC has ___ articles.",
            options: ["7", "9", "11", "13"],
            correctAnswer: "11",
            explanation: "Professional codes of conduct issued by NEC has 11 articles."
          },
          {
            id: 3,
            question: "Ex-officio of NEC is President of ___.",
            options: ["NEC", "GoN", "NEA", "NPC"],
            correctAnswer: "NEA",
            explanation: "Ex-officio of NEC is President of NEA."
          },
          {
            id: 4,
            question: "Er. Ram Babu Sharma is the first president of NEC and 1st registrar is ___.",
            options: ["Prem Nath Thapa", "Bindeshwar Yadav", "Ram Hari Aryal", "Govinda Raj Pokhrel"],
            correctAnswer: "Bindeshwar Yadav",
            explanation: "Er. Ram Babu Sharma is the first president of NEC and 1st registrar is Bindeshwar Yadav."
          },
          {
            id: 5,
            question: "Bachelor Degree and Engineering experience of ___ years is requirement for being Chairman and President of NEC.",
            options: ["5", "10", "15", "20"],
            correctAnswer: "15",
            explanation: "Bachelor Degree and Engineering experience of 15 years is requirement for being Chairman and President of NEC."
          },
          {
            id: 6,
            question: "Engineer is registered in Category A as ___ Engineer.",
            options: ["Professional", "Specialist", "General", "Foreigner"],
            correctAnswer: "General",
            explanation: "Engineer is registered in Category A as General Engineer."
          },
          {
            id: 7,
            question: "The number of members nominated by NEC is ___ and minimum number of female members in NEC committee is 4.",
            options: ["2", "3", "4", "5"],
            correctAnswer: "3",
            explanation: "The number of members nominated by NEC is 3 and minimum number of female members in NEC committee is 4."
          },
          {
            id: 8,
            question: "In NEC, ___ members are involved in exam committee.",
            options: ["3", "4", "5", "7"],
            correctAnswer: "5",
            explanation: "In NEC, 5 members are involved in exam committee."
          },
          {
            id: 9,
            question: "The first amendment of NEC regulation was on ___.",
            options: ["2060-02-17", "2062-02-17", "2064-02-17", "2066-02-17"],
            correctAnswer: "2064-02-17",
            explanation: "The first amendment of NEC regulation was on 2064-02-17."
          },
          {
            id: 10,
            question: "As per NEC Act (Amended 2079), section 30(c), the punishment on violation of rules is NRs ___.",
            options: ["10000", "15000", "20000", "25000"],
            correctAnswer: "25000",
            explanation: "As per NEC Act (Amended 2079), section 30(c), the punishment on violation of rules is NRs 25000."
          },
          {
            id: 11,
            question: "The Minimum time period allocated by GoN for formation of new council after the dissolution of current NEC is ___ months.",
            options: ["1", "2", "3", "6"],
            correctAnswer: "3",
            explanation: "The Minimum time period allocated by GoN for formation of new council after the dissolution of current NEC is 3 months."
          },
          {
            id: 12,
            question: "60% college should score at least in average to get ___ from NEC.",
            options: ["License", "Recognition", "Affiliation", "Accreditation"],
            correctAnswer: "Affiliation",
            explanation: "60% college should score at least in average to get Affiliation from NEC."
          },
          {
            id: 13,
            question: "Bagmati province has ___ number of institutional colleges affiliated by NEC.",
            options: ["Least", "Average", "Most", "Equal"],
            correctAnswer: "Most",
            explanation: "Bagmati province has Most number of institutional colleges affiliated by NEC."
          },
          {
            id: 14,
            question: "Nepal Engineering Council (NEC) established in BS ___.",
            options: ["2050", "2052", "2055", "2059"],
            correctAnswer: "2055",
            explanation: "Nepal Engineering Council (NEC) established in BS 2055."
          },
          {
            id: 15,
            question: "1st President of NEC is Er. Ram Babu Sharma and 1st Registrar is ___.",
            options: ["Prem Nath Thapa", "Bindeshwar Yadav", "Ram Hari Aryal", "Govinda Raj Pokhrel"],
            correctAnswer: "Bindeshwar Yadav",
            explanation: "1st President of NEC is Er. Ram Babu Sharma and 1st Registrar is Bindeshwar Yadav."
          },
          {
            id: 16,
            question: "Requirement for Chairman and President of NEC is Bachelor Degree and ___ years engineering experience.",
            options: ["5", "10", "15", "20"],
            correctAnswer: "15",
            explanation: "Requirement for Chairman and President of NEC is Bachelor Degree and 15 years engineering experience."
          },
          {
            id: 17,
            question: "Category A engineer in NEC is registered as ___ Engineer.",
            options: ["Professional", "Specialist", "General", "Foreigner"],
            correctAnswer: "General",
            explanation: "Category A engineer in NEC is registered as General Engineer."
          },
          {
            id: 18,
            question: "Number of members nominated by NEC is ___ and minimum female members in NEC committee is 4.",
            options: ["2", "3", "4", "5"],
            correctAnswer: "3",
            explanation: "Number of members nominated by NEC is 3 and minimum female members in NEC committee is 4."
          },
          {
            id: 19,
            question: "First amendment of NEC regulation was on ___.",
            options: ["2060-02-17", "2062-02-17", "2064-02-17", "2066-02-17"],
            correctAnswer: "2064-02-17",
            explanation: "First amendment of NEC regulation was on 2064-02-17."
          },
          {
            id: 20,
            question: "As per NEC Act (Amended 2079), sec 30(c), punishment on violation is NRs ___.",
            options: ["10000", "15000", "20000", "25000"],
            correctAnswer: "25000",
            explanation: "As per NEC Act (Amended 2079), sec 30(c), punishment on violation is NRs 25000."
          },
          {
            id: 21,
            question: "Minimum time allocated by GoN for formation of new NEC council after dissolution is ___ months.",
            options: ["1", "2", "3", "6"],
            correctAnswer: "3",
            explanation: "Minimum time allocated by GoN for formation of new NEC council after dissolution is 3 months."
          },
          {
            id: 22,
            question: "If engineer violates sub-section 3(b) of NEC act 2055, punishment is NRs ___ fine.",
            options: ["5000", "10000", "15000", "25000"],
            correctAnswer: "10000",
            explanation: "If engineer violates sub-section 3(b) of NEC act 2055, punishment is NRs 10000 fine."
          },
          {
            id: 23,
            question: "Approval for change in rules of NEC is granted by ___.",
            options: ["NEC council", "NEA", "Government of Nepal", "Parliament"],
            correctAnswer: "Government of Nepal",
            explanation: "Approval for change in rules of NEC is granted by Government of Nepal."
          },
          {
            id: 24,
            question: "As per NEC Act Amended 2079, sec 30(c), punishment is NRs ___.",
            options: ["10000", "15000", "20000", "25000"],
            correctAnswer: "25000",
            explanation: "As per NEC Act Amended 2079, sec 30(c), punishment is NRs 25000."
          },
          {
            id: 25,
            question: "After annual meeting of NEC, the report is submitted to ___.",
            options: ["NEC council", "NEA", "GON", "Parliament"],
            correctAnswer: "GON",
            explanation: "After annual meeting of NEC, the report is submitted to GON."
          },
          {
            id: 26,
            question: "Master's program Affiliation Sub-Regulations formulated by NEC was ___.",
            options: ["2074-09-06", "2075-09-06", "2076-09-06", "2077-09-06"],
            correctAnswer: "2076-09-06",
            explanation: "Master's program Affiliation Sub-Regulations formulated by NEC was 2076-09-06."
          },
          {
            id: 27,
            question: "___ appoints Auditor of Nepal Engineering Council.",
            options: ["GoN", "NEA", "Ministry", "NEC Itself"],
            correctAnswer: "NEC Itself",
            explanation: "NEC Itself appoints Auditor of Nepal Engineering Council."
          }
        ]
      }
    ]
  }
];
